(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iv-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var OPEN_CLASS = 'is-open';
    var BUSY_CLASS = 'is-busy';

    function getRoot() {
      return document.querySelector('.iv-cart-drawer');
    }

    function isOpen(root) {
      return root && root.classList.contains(OPEN_CLASS);
    }

    function openDrawer() {
      var root = getRoot();
      if (!root) return;
      root.classList.add(OPEN_CLASS);
      document.documentElement.style.overflow = 'hidden';
      refreshDrawer();
      var panel = root.querySelector('.iv-cart-drawer__panel');
      if (panel) panel.focus({ preventScroll: true });
    }

    function closeDrawer() {
      var root = getRoot();
      if (!root) return;
      root.classList.remove(OPEN_CLASS);
      document.documentElement.style.overflow = '';
    }

    function swapFromHtml(html) {
      var root = getRoot();
      if (!root || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-content]');
      var current = root.querySelector('[data-cart-drawer-content]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }

    function refreshDrawer() {
      var root = getRoot();
      if (!root) return;
      var id = root.getAttribute('data-section-id');
      if (!id) return;
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          swapFromHtml(data[id]);
        })
        .catch(function () {});
    }

    function changeLine(line, quantity) {
      var root = getRoot();
      if (!root) return;
      var id = root.getAttribute('data-section-id');
      var changeUrl = root.getAttribute('data-cart-change-url') || '/cart/change';
      root.classList.add(BUSY_CLASS);
      fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ line: line, quantity: quantity, sections: id }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (state) {
          if (state.sections && state.sections[id]) swapFromHtml(state.sections[id]);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
        })
        .catch(function () {})
        .then(function () {
          root.classList.remove(BUSY_CLASS);
        });
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-cart-drawer-open]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        return;
      }
      if (event.target.closest('[data-cart-drawer-overlay]')) {
        closeDrawer();
        return;
      }
      var closer = event.target.closest('[data-cart-drawer-close]');
      if (closer && event.target.closest('.iv-cart-drawer')) {
        closeDrawer();
        return;
      }
      var remover = event.target.closest('[data-cart-drawer-remove]');
      if (remover) {
        event.preventDefault();
        changeLine(parseInt(remover.getAttribute('data-line'), 10), 0);
      }
    });

    /* Stepper (klantkeuze Mehmet 14/08): +/- past de UI direct aan en stuurt
       de wijziging gedebounced; typen bevestigt op Enter/blur. */
    var qtyTimers = {};

    function stepperCommit(wrap, qty, direct) {
      var line = wrap.getAttribute('data-line');
      clearTimeout(qtyTimers[line]);
      if (direct) {
        changeLine(parseInt(line, 10), qty);
      } else {
        qtyTimers[line] = setTimeout(function () {
          changeLine(parseInt(line, 10), qty);
        }, 400);
      }
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cart-drawer-qty-minus], [data-cart-drawer-qty-plus]');
      if (!btn) return;
      var wrap = btn.closest('[data-cart-drawer-stepper]');
      var input = wrap && wrap.querySelector('[data-cart-drawer-qty-value]');
      if (!input) return;
      var qty = parseInt(input.value, 10) || 1;
      qty += btn.hasAttribute('data-cart-drawer-qty-plus') ? 1 : -1;
      if (qty < 1) qty = 1;
      input.value = qty;
      var minus = wrap.querySelector('[data-cart-drawer-qty-minus]');
      if (minus) minus.disabled = qty <= 1;
      stepperCommit(wrap, qty, false);
    });

    document.addEventListener('keydown', function (event) {
      var input = event.target.closest('[data-cart-drawer-qty-value]');
      if (!input) return;
      if (event.key === 'Enter') {
        event.preventDefault();
        input.blur();
      }
    });

    document.addEventListener('focusout', function (event) {
      var input = event.target.closest('[data-cart-drawer-qty-value]');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      if (!qty || qty < 1) qty = 1;
      input.value = qty;
      stepperCommit(input.closest('[data-cart-drawer-stepper]'), qty, true);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen(getRoot())) closeDrawer();
    });

    document.addEventListener('cart:refresh', refreshDrawer);

    document.addEventListener('shopify:section:select', function (event) {
      if (event.target && event.target.querySelector('.iv-cart-drawer')) openDrawer();
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      if (event.target && event.target.querySelector('.iv-cart-drawer')) closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BUSY_CLASS = 'is-busy';
    var selfUpdate = false;

    function getRoot() {
      return document.querySelector('.iv-cart');
    }

    function swapFromHtml(html) {
      var root = getRoot();
      if (!root || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-root]');
      var current = root.querySelector('[data-cart-root]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }

    function refreshCart() {
      var root = getRoot();
      if (!root) return;
      var id = root.getAttribute('data-section-id');
      if (!id) return;
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          swapFromHtml(data[id]);
        })
        .catch(function () {});
    }

    function changeLine(line, quantity) {
      var root = getRoot();
      if (!root) return;
      var id = root.getAttribute('data-section-id');
      var changeUrl = root.getAttribute('data-cart-change-url') || '/cart/change';
      root.classList.add(BUSY_CLASS);
      fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ line: line, quantity: quantity, sections: id }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (state) {
          if (state.sections && state.sections[id]) swapFromHtml(state.sections[id]);
          selfUpdate = true;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
          selfUpdate = false;
        })
        .catch(function () {})
        .then(function () {
          root.classList.remove(BUSY_CLASS);
        });
    }

    /* Stepper (klantkeuze Mehmet 14/08): +/- past de UI direct aan en stuurt
       de wijziging gedebounced, zodat snel doorklikken één request wordt;
       typen bevestigt op Enter/blur. */
    var qtyTimers = {};

    function stepperCommit(wrap, qty, direct) {
      var line = wrap.getAttribute('data-line');
      clearTimeout(qtyTimers[line]);
      if (direct) {
        changeLine(parseInt(line, 10), qty);
      } else {
        qtyTimers[line] = setTimeout(function () {
          changeLine(parseInt(line, 10), qty);
        }, 400);
      }
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.iv-cart [data-cart-qty-minus], .iv-cart [data-cart-qty-plus]');
      if (!btn) return;
      var wrap = btn.closest('[data-cart-stepper]');
      var input = wrap && wrap.querySelector('[data-cart-qty-value]');
      if (!input) return;
      var qty = parseInt(input.value, 10) || 1;
      qty += btn.hasAttribute('data-cart-qty-plus') ? 1 : -1;
      if (qty < 1) qty = 1;
      input.value = qty;
      var minus = wrap.querySelector('[data-cart-qty-minus]');
      if (minus) minus.disabled = qty <= 1;
      stepperCommit(wrap, qty, false);
    });

    document.addEventListener('keydown', function (event) {
      var input = event.target.closest('.iv-cart [data-cart-qty-value]');
      if (!input) return;
      if (event.key === 'Enter') {
        event.preventDefault();
        input.blur();
      }
    });

    document.addEventListener('focusout', function (event) {
      var input = event.target.closest('.iv-cart [data-cart-qty-value]');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      if (!qty || qty < 1) qty = 1;
      input.value = qty;
      stepperCommit(input.closest('[data-cart-stepper]'), qty, true);
    });

    document.addEventListener('click', function (event) {
      var remover = event.target.closest('.iv-cart [data-cart-remove]');
      if (remover) {
        event.preventDefault();
        changeLine(parseInt(remover.getAttribute('data-line'), 10), 0);
        return;
      }
      var toggle = event.target.closest('.iv-cart [data-cart-discount-toggle]');
      if (toggle) {
        var form = toggle.parentElement.querySelector('[data-cart-discount-form]');
        if (!form) return;
        var isHidden = form.hasAttribute('hidden');
        if (isHidden) {
          form.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
          var input = form.querySelector('input');
          if (input) input.focus();
        } else {
          form.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        }
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.iv-cart [data-cart-discount-form]');
      if (!form) return;
      event.preventDefault();
      var input = form.querySelector('input');
      var code = input ? input.value.trim() : '';
      if (!code) return;
      var root = getRoot();
      var cartUrl = (root && root.getAttribute('data-cart-url')) || '/cart';
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
    });

    document.addEventListener('cart:updated', function () {
      if (selfUpdate) return;
      refreshCart();
    });

    document.addEventListener('cart:refresh', refreshCart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-category-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCategoryGrid(root) {
      if (root.dataset.ivCgInit) return;
      root.dataset.ivCgInit = 'true';
      var scroller = root.querySelector('.iv-category-grid__grid');
      var next = root.querySelector('[data-cg-next]');
      var prev = root.querySelector('[data-cg-prev]');
      if (!scroller || !next) return;

      if (root.classList.contains('iv-category-grid--carousel')) {
        initCardsLoop(scroller, prev, next);
        return;
      }

      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth;
        next.classList.toggle('is-hidden', max <= 4 || scroller.scrollLeft >= max - 4);
      }

      next.addEventListener('click', function () {
        var cell = scroller.querySelector('.iv-category-grid__cell');
        var step = cell ? cell.getBoundingClientRect().width + 4 : scroller.clientWidth * 0.8;
        scroller.scrollBy({ left: step, behavior: 'smooth' });
      });

      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    /* Desktop edge-to-edge loop-carousel (Figma 995:28863): clones aan beide
       einden zodat er links én rechts altijd een aangesneden kaart zichtbaar is;
       de pijlen stappen één kaart en de positie wordt naadloos genormaliseerd. */
    function initCardsLoop(scroller, prev, next) {
      var cells = Array.prototype.slice.call(scroller.querySelectorAll('.iv-category-grid__cell'));
      var n = cells.length;
      var mq = window.matchMedia('(min-width: 750px)');

      function pitch() {
        var cell = scroller.querySelector('.iv-category-grid__cell');
        return cell ? cell.getBoundingClientRect().width + 4 : 339;
      }

      if (n < 3) {
        // Te weinig kaarten voor een loop: pijlen scrollen gewoon binnen de rij.
        prev && prev.addEventListener('click', function () { scroller.scrollBy({ left: -pitch(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { scroller.scrollBy({ left: pitch(), behavior: 'smooth' }); });
        return;
      }

      var CLONES = 3;
      function prepClone(el) {
        el.classList.add('iv-category-grid__cell--clone');
        el.setAttribute('aria-hidden', 'true');
        Array.prototype.slice.call(el.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-shopify') === 0) el.removeAttribute(attr.name);
        });
        el.querySelectorAll('a, button').forEach(function (t) { t.setAttribute('tabindex', '-1'); });
      }
      for (var i = 0; i < CLONES; i++) {
        var head = cells[(n - 1 - i % n + n) % n].cloneNode(true);
        prepClone(head);
        scroller.insertBefore(head, scroller.firstChild);
        var tail = cells[i % n].cloneNode(true);
        prepClone(tail);
        scroller.appendChild(tail);
      }

      var validMax = 2 * CLONES + n - 5; // hoogste uitgelijnde kaart-index met kaart-peek rechts (T-5, T = totaal incl. clones)

      function align() {
        scroller.scrollLeft = mq.matches ? CLONES * pitch() : 0;
      }

      function normalize() {
        if (!mq.matches) return;
        var p = pitch();
        var span = n * p;
        var guard = 0;
        while (scroller.scrollLeft < p * 0.5 && guard < 5) { scroller.scrollLeft += span; guard++; }
        while (scroller.scrollLeft > (validMax + 0.5) * p && guard < 10) { scroller.scrollLeft -= span; guard++; }
      }

      var settle;
      function go(dir) {
        scroller.scrollBy({ left: dir * pitch(), behavior: 'smooth' });
        clearTimeout(settle);
        settle = setTimeout(normalize, 520);
      }
      prev && prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      if ('onscrollend' in window) scroller.addEventListener('scrollend', normalize);
      if (mq.addEventListener) mq.addEventListener('change', align);
      window.addEventListener('resize', function () {
        if (!mq.matches) return;
        clearTimeout(settle);
        settle = setTimeout(align, 150);
      });
      align();
    }

    function esc(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    function valHtml(value) {
      return esc(value)
        .split('//')
        .map(function (part) { return part.trim(); })
        .join('<br>');
    }

    var CHEV_LEFT = '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6.5 12.5L0.5 6.5L6.5 0.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var CHEV_RIGHT = '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0.5 12.5L6.5 6.5L0.5 0.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function initCompare(root) {
      if (root.dataset.ivCmpInit) return;
      root.dataset.ivCmpInit = 'true';
      var dataEl = root.querySelector('[data-cmp-data]');
      if (!dataEl) return;
      var models = [];
      try {
        models = (JSON.parse(dataEl.textContent).models || []);
      } catch (err) {
        return;
      }
      if (!models.length) return;

      var cols = Array.prototype.slice.call(root.querySelectorAll('[data-cmp-col]'));
      var state = cols.map(function (col) {
        return Math.min(parseInt(col.dataset.cmpCol, 10), models.length - 1);
      });
      if (!state.length) state = [0];
      var imgIdx = state.map(function (m) { return models[m].active || 0; });

      function mediaHtml(model, idx) {
        var html = '<div class="iv-category-grid__cmp-frame">';
        html += '<img class="iv-category-grid__cmp-img" src="' + esc(model.images[idx] || '') + '" width="680" height="680" loading="lazy" alt="' + esc(model.title) + '">';
        if (model.images.length > 1) {
          html += '<div class="iv-category-grid__cmp-dots" data-cmp-dots>';
          model.images.forEach(function (_, i) {
            html += '<span' + (i === idx ? ' class="is-active"' : '') + '></span>';
          });
          html += '</div></div>';
          html += '<button class="iv-category-grid__cmp-nav iv-category-grid__cmp-nav--prev" type="button" data-cmp-prev aria-label="' + (document.documentElement.lang === 'nl' ? 'Vorige afbeelding' : 'Previous image') + '">' + CHEV_LEFT + '</button>';
          html += '<button class="iv-category-grid__cmp-nav iv-category-grid__cmp-nav--next" type="button" data-cmp-next aria-label="' + (document.documentElement.lang === 'nl' ? 'Volgende afbeelding' : 'Next image') + '">' + CHEV_RIGHT + '</button>';
          html += '<div class="iv-category-grid__cmp-thumbs" data-cmp-thumbs>';
          model.images.forEach(function (src, i) {
            html += '<button type="button" class="iv-category-grid__cmp-thumb' + (i === idx ? ' is-active' : '') + '" data-cmp-thumb="' + i + '" aria-label="' + (document.documentElement.lang === 'nl' ? 'Afbeelding' : 'Image') + ' ' + (i + 1) + '"><img src="' + esc(src) + '" width="64" height="64" loading="lazy" alt=""></button>';
          });
          html += '</div>';
        } else {
          html += '</div>';
        }
        return html;
      }

      function specsHtml(model) {
        return model.specs.map(function (row) {
          return '<div class="iv-category-grid__cmp-row"><span class="iv-category-grid__cmp-label">' + esc(row[0]) + '</span><span class="iv-category-grid__cmp-value">' + valHtml(row[1]) + '</span></div>';
        }).join('');
      }

      function mobileSpecs(model) {
        return model.specsMobile && model.specsMobile.length ? model.specsMobile : model.specs;
      }

      function renderCol(colIndex) {
        var col = cols[colIndex];
        if (!col) return;
        var model = models[state[colIndex]];
        var media = col.querySelector('[data-cmp-media]');
        if (media) media.innerHTML = mediaHtml(model, imgIdx[colIndex]);
        var specs = col.querySelector('[data-cmp-specs]');
        if (specs) specs.innerHTML = specsHtml(model);
        var cta = col.querySelector('[data-cmp-cta]');
        if (cta) {
          cta.textContent = model.ctaLabel;
          cta.setAttribute('href', model.ctaUrl || '#');
        }
      }

      function renderMobile() {
        var mrows = root.querySelector('[data-cmp-mrows]');
        var mA = models[state[0]];
        var mB = state.length > 1 ? models[state[1]] : null;
        [0, 1].forEach(function (i) {
          var model = models[state[i]];
          if (!model) return;
          var prod = root.querySelector('[data-cmp-mprod="' + i + '"]');
          if (prod) {
            var img = prod.querySelector('.iv-category-grid__cmp-img');
            if (img) {
              img.setAttribute('src', model.images[model.active || 0] || '');
              img.setAttribute('srcset', '');
              img.setAttribute('alt', model.title);
            }
          }
          var mcta = root.querySelector('[data-cmp-mcta="' + i + '"]');
          if (mcta) {
            mcta.textContent = model.ctaLabel;
            mcta.setAttribute('href', model.ctaUrl || '#');
          }
        });
        if (mrows && mA) {
          var specsA = mobileSpecs(mA);
          var specsB = mB ? mobileSpecs(mB) : null;
          mrows.innerHTML = specsA.map(function (row, i) {
            var second = specsB ? '<span>' + valHtml((specsB[i] || [])[1]) + '</span>' : '';
            return '<div class="iv-category-grid__cmp-mrow"><span class="iv-category-grid__cmp-label">' + esc(row[0]) + '</span><div class="iv-category-grid__cmp-mvals"><span>' + valHtml(row[1]) + '</span>' + second + '</div></div>';
          }).join('');
        }
      }

      root.addEventListener('change', function (event) {
        var select = event.target.closest('select[data-cmp-select]');
        if (!select) return;
        var colIndex = parseInt(select.dataset.cmpSelect, 10);
        var value = parseInt(select.value, 10);
        if (isNaN(colIndex) || isNaN(value) || !models[value]) return;
        state[colIndex] = value;
        imgIdx[colIndex] = models[value].active || 0;
        root.querySelectorAll('select[data-cmp-select="' + colIndex + '"]').forEach(function (other) {
          other.value = String(value);
        });
        renderCol(colIndex);
        renderMobile();
      });

      root.addEventListener('click', function (event) {
        var prev = event.target.closest('[data-cmp-prev]');
        var next = event.target.closest('[data-cmp-next]');
        var thumb = event.target.closest('[data-cmp-thumb]');
        if (!prev && !next && !thumb) return;
        var col = event.target.closest('[data-cmp-col]');
        if (!col) return;
        var colIndex = cols.indexOf(col);
        if (colIndex < 0) return;
        var model = models[state[colIndex]];
        var count = model.images.length;
        if (count < 2) return;
        if (thumb) {
          imgIdx[colIndex] = parseInt(thumb.dataset.cmpThumb, 10) || 0;
        } else {
          var delta = prev ? -1 : 1;
          imgIdx[colIndex] = (imgIdx[colIndex] + delta + count) % count;
        }
        var media = col.querySelector('[data-cmp-media]');
        if (!media) return;
        var img = media.querySelector('.iv-category-grid__cmp-img');
        if (img) img.setAttribute('src', model.images[imgIdx[colIndex]]);
        media.querySelectorAll('[data-cmp-thumb]').forEach(function (t, i) {
          t.classList.toggle('is-active', i === imgIdx[colIndex]);
        });
        var dots = media.querySelector('[data-cmp-dots]');
        if (dots) {
          Array.prototype.forEach.call(dots.children, function (dot, i) {
            dot.classList.toggle('is-active', i === imgIdx[colIndex]);
          });
        }
      });
    }

    function initStories(root) {
      if (root.dataset.ivStInit) return;
      root.dataset.ivStInit = 'true';
      var track = root.querySelector('.iv-category-grid__st-track');
      var prev = root.querySelector('[data-st-prev]');
      var next = root.querySelector('[data-st-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.querySelector('.iv-category-grid__st-card');
        return card ? card.getBoundingClientRect().width + 4 : track.clientWidth * 0.8;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.toggleAttribute('disabled', track.scrollLeft <= 4);
        next.toggleAttribute('disabled', max <= 4 || track.scrollLeft >= max - 4);
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll(root) {
      initCategoryGrid(root);
      initCompare(root);
      initStories(root);
    }

    document.querySelectorAll('.iv-category-grid').forEach(initAll);
    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target.querySelector('.iv-category-grid');
      if (el) initAll(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Filter- en sorteerlade. Het paneel is een gewoon GET-formulier: zonder JS
    // is de lade niet te openen, maar de knoppen en de chip-links erin werken.
    // Met JS bouwen we de URL uit de HUIDIGE locatie op, zodat parameters die wij
    // niet kennen — bijvoorbeeld ?view= op de collecties die nog geen
    // templateSuffix hebben — behouden blijven. `page` gaat er altijd af: na een
    // filter- of sorteerwissel hoor je op pagina 1 te beginnen.
    function initFilterDrawer(drawer) {
      if (drawer.dataset.cgDrawerInit) return;
      drawer.dataset.cgDrawerInit = '1';

      const form = drawer.querySelector('[data-cg-drawer-form]');
      const panel = drawer.querySelector('[data-cg-drawer-panel]');
      if (!form) return;
      let opener = null;

      const buildUrl = (keepForm) => {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        Array.from(params.keys()).forEach((key) => {
          if (key === 'sort_by' || key === 'page' || key.indexOf('filter.') === 0) {
            params.delete(key);
          }
        });
        if (keepForm) {
          new FormData(form).forEach((value, key) => {
            if (String(value).trim() === '') return;
            params.append(key, value);
          });
        } else {
          // Alles wissen: de filters gaan eruit, de gekozen sortering blijft staan.
          const sort = form.querySelector('input[name="sort_by"]:checked');
          if (sort && sort.value) params.append('sort_by', sort.value);
        }
        const query = params.toString();
        return url.pathname + (query ? '?' + query : '');
      };

      const openDrawer = () => {
        drawer.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        if (panel) panel.focus({ preventScroll: true });
      };

      const closeDrawer = () => {
        drawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        if (opener && document.body.contains(opener)) opener.focus({ preventScroll: true });
        opener = null;
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        window.location.assign(buildUrl(true));
      });

      drawer.addEventListener('click', (event) => {
        if (event.target.closest('[data-cg-drawer-overlay]') || event.target.closest('[data-cg-drawer-close]')) {
          closeDrawer();
          return;
        }

        const clear = event.target.closest('[data-cg-drawer-clear]');
        if (clear) {
          event.preventDefault();
          window.location.assign(buildUrl(false));
          return;
        }

        // Chip van een actief filter: haalt dat filter uit de lade zonder meteen te
        // navigeren, zodat het samen met de rest op Toepassen doorgaat. Zonder JS
        // doet de href (url_to_remove) hetzelfde in één stap.
        const chip = event.target.closest('[data-cg-drawer-remove]');
        if (!chip) return;
        event.preventDefault();
        const priceNames = (chip.dataset.cgPrice || '').split('|');
        Array.from(form.elements).forEach((field) => {
          if (chip.dataset.cgPrice) {
            if (priceNames.indexOf(field.name) !== -1) field.value = '';
          } else if (field.type === 'checkbox' && field.name === chip.dataset.cgParam && field.value === chip.dataset.cgValue) {
            field.checked = false;
          }
        });
        const group = chip.closest('[data-cg-drawer-active]');
        chip.remove();
        if (group && !group.querySelector('[data-cg-drawer-remove]')) group.remove();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      });

      // Contract met iv-collection-header: de "Filter & sort"-knop daar dispatcht
      // een cancelable 'iv:filters:open'. preventDefault meldt dat wij het
      // afhandelen, zodat zijn eigen fallback (scrollen naar het raster) uitblijft.
      document.addEventListener('iv:filters:open', (event) => {
        if (!document.body.contains(drawer)) return;
        event.preventDefault();
        opener = event.target && typeof event.target.focus === 'function' ? event.target : null;
        openDrawer();
      });
    }

    function initCollectionGrid(root) {
      if (root.dataset.cgInit) return;
      root.dataset.cgInit = '1';

      root.querySelectorAll('[data-cg-card]').forEach((card) => {
        const slider = card.querySelector('[data-cg-slider]');
        const segs = card.querySelectorAll('[data-cg-seg]');
        if (!slider || segs.length < 2) return;
        let current = 0;
        slider.addEventListener(
          'scroll',
          () => {
            requestAnimationFrame(() => {
              const i = Math.min(
                segs.length - 1,
                Math.max(0, Math.round(slider.scrollLeft / (slider.clientWidth + 2)))
              );
              if (i !== current) {
                segs[current].classList.remove('is-active');
                segs[i].classList.add('is-active');
                current = i;
              }
            });
          },
          { passive: true }
        );
      });
    }

    const initAll = () => {
      document.querySelectorAll('.iv-collection-grid').forEach(initCollectionGrid);
      document.querySelectorAll('[data-cg-drawer]').forEach(initFilterDrawer);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.iv-collection-grid');
      if (section) initCollectionGrid(section);
      const drawer = event.target.querySelector('[data-cg-drawer]');
      if (drawer) initFilterDrawer(drawer);
    });

    // Hover -> volgende foto, zelfde gedrag als de listingkaarten (klantpunt
    // Ivo 14/08; gelijkgetrokken 20/08). Slide 0 blijft "thuis": de
    // actieve-swatch-sweep zet die vooraan, dus mouseout keert daarnaar terug.
    if (!window.__ivCgPhotoNav) {
      window.__ivCgPhotoNav = 1;
      if (window.matchMedia('(hover: hover)').matches) {
        const cgStep = (slider) => slider.clientWidth + 2;
        document.addEventListener('mouseover', (e) => {
          const card = e.target.closest('[data-cg-card]');
          if (!card || card.contains(e.relatedTarget)) return;
          const slider = card.querySelector('[data-cg-slider]');
          if (!slider || slider.children.length < 2) return;
          // Kaart met hover-laag (tweede foto, Ivo 28/08): de laag wint, niet scrollen.
          if (card.dataset.cgDesktop && card.dataset.cgDesktop !== 'slider') return;
          if (card.querySelector('[data-cg-hover]')) return;
          if (Math.abs(slider.scrollLeft) < 4) {
            slider.scrollTo({ left: cgStep(slider), behavior: 'smooth' });
          }
        });
        document.addEventListener('mouseout', (e) => {
          const card = e.target.closest('[data-cg-card]');
          if (!card || card.contains(e.relatedTarget)) return;
          const slider = card.querySelector('[data-cg-slider]');
          if (!slider) return;
          if (Math.abs(slider.scrollLeft) > 4) {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          }
        });
      }
    }

    // Swatch-klik -> variant-foto; gedeeld contract met iv-product-listing
    // (zelfde data-attributen + window-guard, welke sectie ook als eerste laadt).
    if (!window.__ivSwatchInit) {
      window.__ivSwatchInit = true;
      document.addEventListener('click', (e) => {
        const sw = e.target.closest('[data-swatch-value]');
        if (!sw) return;
        e.preventDefault();
        const card = sw.closest('[data-lp-card], [data-cg-card]');
        if (!card) return;
        card.querySelectorAll('[data-swatch-value]').forEach((s) => {
          s.classList.toggle('is-active', s === sw);
        });
        const label = card.querySelector('.iv-product-listing__swatch-label, .iv-collection-grid__swatch-label');
        if (label) label.textContent = sw.dataset.swatchValue;
        const slider = card.querySelector('[data-lp-slider], [data-cg-slider]');
        if (!slider) return;
        const slides = Array.from(slider.children);
        const target = sw.dataset.swatchMedia
          ? slides.findIndex((s) => s.dataset.mediaId === sw.dataset.swatchMedia)
          : -1;
        if (target >= 0) {
          slider.scrollTo({ left: target * (slider.clientWidth + 2), behavior: 'smooth' });
        } else if (sw.dataset.swatchImage) {
          const img = slides[0] && slides[0].querySelector('img');
          if (img) {
            img.removeAttribute('srcset');
            img.src = sw.dataset.swatchImage;
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-collection-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCollectionHeader(root) {
      if (root.dataset.ivChInit) return;
      root.dataset.ivChInit = 'true';

      var desc = root.querySelector('.iv-collection-header__desc');
      var more = root.querySelector('.iv-collection-header__more');
      if (desc && more) {
        var update = function () {
          if (desc.classList.contains('is-expanded')) return;
          more.hidden = desc.scrollHeight <= desc.clientHeight + 1;
        };

        more.addEventListener('click', function () {
          var expanded = desc.classList.toggle('is-expanded');
          more.textContent = expanded
            ? more.dataset.lessLabel || 'Lees minder'
            : more.dataset.moreLabel || 'Lees meer';
          more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });

        window.addEventListener('resize', update);
        update();
      }

      var filter = root.querySelector('[data-iv-filters-open]');
      if (filter) {
        filter.addEventListener('click', function () {
          var event = new CustomEvent('iv:filters:open', { bubbles: true, cancelable: true });
          var notHandled = filter.dispatchEvent(event);
          if (notHandled) {
            var grid = document.querySelector('.iv-collection-grid');
            if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    }

    document.querySelectorAll('.iv-collection-header').forEach(initCollectionHeader);
    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target.querySelector('.iv-collection-header');
      if (el) initCollectionHeader(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initContact(root) {
      if (root.dataset.ivContactInit) return;
      root.dataset.ivContactInit = '1';

      // Conditionele velden: disabled zolang verborgen, zodat er geen lege
      // contact[...]-regels in de mail komen.
      function sync() {
        const type = root.querySelector('input[name="contact[customer_type]"]:checked');
        const req = root.querySelector('input[name="contact[request]"]:checked');
        const states = {
          business: type && type.dataset.ivToggle === 'business',
          quote: req && req.dataset.ivToggle === 'quote',
          showroom: req && req.dataset.ivToggle === 'showroom',
        };
        root.querySelectorAll('[data-iv-when]').forEach((blok) => {
          const aan = !!states[blok.dataset.ivWhen];
          blok.hidden = !aan;
          blok.querySelectorAll('input, select').forEach((veld) => {
            veld.disabled = !aan;
          });
        });
        const cartItems = root.querySelector('[data-iv-cart-items]');
        if (cartItems) cartItems.disabled = !states.quote;
      }

      root.addEventListener('change', (e) => {
        if (e.target.matches('input[name="contact[customer_type]"], input[name="contact[request]"]')) sync();
      });
      sync();
    }

    document.querySelectorAll('[data-iv-contact]').forEach(initContact);
    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('[data-iv-contact]').forEach(initContact);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.iv-faq__summary');
    if (!summary) return;
    var item = summary.closest('.iv-faq__item');
    if (!item) return;
    event.preventDefault();
    var wrap = item.querySelector('.iv-faq__answer-wrap');
    if (item._ivFaqCleanup) item._ivFaqCleanup();
    if (!wrap || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      item.open = !item.open;
      return;
    }
    var closing = item.classList.contains('is-closing');
    if (item.open && !closing) {
      // Sluiten: dichtanimeren en [open] pas weghalen als de transitie echt
      // klaar is (transitionend, niet een losse timer — timers lopen uit de
      // pas met de animatie en lieten het antwoord halverwege wegspringen).
      item.classList.add('is-closing');
      var done = function (e) {
        if (e && (e.target !== wrap || e.propertyName !== 'grid-template-rows')) return;
        cleanup();
        item.open = false;
        item.classList.remove('is-closing');
      };
      var fallback = setTimeout(done, 400);
      var cleanup = function () {
        clearTimeout(fallback);
        wrap.removeEventListener('transitionend', done);
        wrap.removeEventListener('transitioncancel', done);
        item._ivFaqCleanup = null;
      };
      item._ivFaqCleanup = cleanup;
      wrap.addEventListener('transitionend', done);
      wrap.addEventListener('transitioncancel', done);
    } else if (item.open && closing) {
      // Was aan het sluiten: vanaf de huidige stand weer open animeren.
      item.classList.remove('is-closing');
    } else {
      // Openen: dicht (0fr) renderen, reflow forceren en in dezelfde taak naar
      // 1fr — de transitie start direct, zonder dubbele-rAF-wachtframes.
      item.classList.add('is-closing');
      item.open = true;
      void wrap.offsetHeight;
      item.classList.remove('is-closing');
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target;
    if (item && item.classList && item.classList.contains('iv-faq__item')) {
      item.open = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-feature-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.iv-feature-banner [data-iv-fb-play]');
    if (!trigger) return;
    const media = trigger.closest('.iv-feature-banner__media');
    if (!media) return;
    // Geüploade video (Shopify Files) speelt inline af.
    const fileVideo = media.querySelector('[data-iv-fb-video]');
    if (fileVideo) {
      fileVideo.hidden = false;
      media.classList.add('iv-feature-banner__media--playing');
      const el = fileVideo.querySelector('video');
      if (el) {
        // Geluid-schakelaar (gelijk aan iv-how-it-works): wie klikt om af te
        // spelen verwacht geluid, tenzij de merchant dat bewust uit heeft gezet.
        el.muted = !fileVideo.hasAttribute('data-iv-fb-sound');
        el.play();
      }
      return;
    }
  });

  /* Autoplay-fragment (patroon klantcase 18/08): start zodra de banner in beeld
     staat en pauzeert zodra hij eruit loopt, zodat er nooit een video
     onzichtbaar door blijft lopen. Bij prefers-reduced-motion gebeurt er niets:
     de poster (de bestaande afbeelding) blijft staan en de afspeelknop laat de
     bezoeker het fragment alsnog zelf starten. */
  function ivFbAutoplay(scope) {
    (scope || document).querySelectorAll('[data-iv-fb-autoplay] video').forEach((video) => {
      if (video.dataset.ivFbInit) return;
      video.dataset.ivFbInit = '1';
      const media = video.closest('.iv-feature-banner__media');
      const wrap = video.closest('[data-iv-fb-video]');
      const knop = media && media.querySelector('[data-iv-fb-play]');
      video.addEventListener('playing', () => {
        if (media) media.classList.add('iv-feature-banner__media--playing');
      });
      /* Klik op de spelende video zet het geluid aan, precies als How it works
         (Mehmet 26/08: geen losse geluidsknop). Automatisch afspelen kan in geen
         enkele browser mét geluid starten, dus dit is de route. */
      if (wrap && wrap.hasAttribute('data-iv-fb-sound')) {
        video.addEventListener('click', () => {
          if (!video.muted) return;
          video.muted = false;
          video.controls = true;
          const poging = video.play();
          if (poging && poging.catch) poging.catch(() => {});
        });
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        // Geen autostart: de afspeelknop is hier de enige route, ook als de
        // merchant hem heeft verborgen.
        if (knop) knop.hidden = false;
        return;
      }
      if (!('IntersectionObserver' in window)) {
        if (knop) knop.hidden = false;
        return;
      }
      /* Voorladen zodra de banner de viewport nadert (halve schermhoogte
         ervoor), zodat het afspelen direct start wanneer hij echt in beeld
         staat — en er vóór die nadering helemaal niets wordt gedownload.
         De readyState-guard voorkomt dat load() een al gestart afspelen
         reset als beide observers in dezelfde tick vuren. */
      const lader = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            if (video.paused && video.readyState === 0) {
              video.preload = 'auto';
              video.load();
            }
            lader.disconnect();
          });
        },
        { rootMargin: '50% 0px' }
      );
      lader.observe(video);
      const waarnemer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const poging = video.play();
              // Geblokkeerde autoplay (bv. energiebesparing op mobiel): de knop
              // komt terug, anders is de video onbereikbaar.
              if (poging && poging.catch) poging.catch(() => { if (knop) knop.hidden = false; });
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.4 }
      );
      waarnemer.observe(video);
    });
  }

  ivFbAutoplay();
  document.addEventListener('DOMContentLoaded', () => {
    ivFbAutoplay();
  });
  document.addEventListener('shopify:section:load', (event) => {
    ivFbAutoplay(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-featured-testimonial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.iv-featured-testimonial [data-iv-ft-play]');
    if (!trigger) return;
    const media = trigger.closest('.iv-featured-testimonial__media');
    if (!media) return;
    // Geüploade video (Shopify Files) speelt inline; anders de YouTube/Vimeo-embed.
    const fileVideo = media.querySelector('[data-iv-ft-video]');
    if (fileVideo) {
      fileVideo.hidden = false;
      media.classList.add('iv-featured-testimonial__media--playing');
      const el = fileVideo.querySelector('video');
      if (el) el.play();
      return;
    }
    if (!media.dataset.embedSrc || media.querySelector('iframe')) return;
    const iframe = document.createElement('iframe');
    iframe.className = 'iv-featured-testimonial__iframe';
    iframe.src = media.dataset.embedSrc;
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', trigger.getAttribute('aria-label') || 'Video');
    media.append(iframe);
    media.classList.add('iv-featured-testimonial__media--playing');
  });

  /* Foto en knop volgen de videostaat, welke afspeelroute ook gebruikt is
     (Mehmet 22/08: zelfde gedrag als de How it works-video). Media-events
     bubbelen niet, dus capture-fase. 'play' dekt ook de autoplay-route en een
     herstart via de native bediening; na 'ended' terug naar de ruststand
     (foto + ronde knop). Het YouTube/Vimeo-iframe stuurt geen media-events en
     houdt zijn eigen eindscherm. */
  const ivFtVolgtVideo = (event, speelt) => {
    const el = event.target;
    if (!el.matches || !el.matches('.iv-featured-testimonial [data-iv-ft-video] video')) return;
    const media = el.closest('.iv-featured-testimonial__media');
    if (media) media.classList.toggle('iv-featured-testimonial__media--playing', speelt);
    // Klik-route (geen autoplay): na afloop de videolaag weer dichtklappen,
    // anders blijft het laatste frame boven de teruggekeerde foto staan.
    const wrap = el.closest('[data-iv-ft-video]');
    if (!speelt && wrap && !wrap.hasAttribute('data-iv-ft-autoplay')) wrap.hidden = true;
  };
  document.addEventListener('play', (event) => ivFtVolgtVideo(event, true), true);
  document.addEventListener('ended', (event) => ivFtVolgtVideo(event, false), true);

  /* Autoplay-klantcase (klantpunt Ivo 18/08). Het fragment start zodra de kaart
     in beeld staat en pauzeert zodra hij eruit loopt, zodat er nooit een video
     onzichtbaar door blijft lopen. Bij prefers-reduced-motion gebeurt er niets:
     de poster (de bestaande foto) blijft staan en de ronde afspeelknop erboven
     laat de bezoeker het fragment alsnog zelf starten. */
  function ivFtAutoplay(scope) {
    (scope || document).querySelectorAll('[data-iv-ft-autoplay] video').forEach((video) => {
      if (video.dataset.ivFtInit) return;
      video.dataset.ivFtInit = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      const waarnemer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const poging = video.play();
              if (poging && poging.catch) poging.catch(() => {});
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.4 }
      );
      waarnemer.observe(video);
    });
  }

  ivFtAutoplay();
  document.addEventListener('DOMContentLoaded', () => ivFtAutoplay());
  document.addEventListener('shopify:section:load', (event) => ivFtAutoplay(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.iv-footer__col-toggle');
    if (!toggle || !window.matchMedia('(max-width: 749px)').matches) return;
    var col = toggle.closest('.iv-footer__col');
    if (!col) return;
    var open = col.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.classList || !select.classList.contains('iv-footer__lang-select')) return;
    var form = select.closest('form');
    if (form) form.submit();
  });

  // Dynamische Trustpilot-teller (Ivo 24/08): zelfde bron, cache-key en slanke
  // vorm als de reviewcarrousel in iv-testimonials (tweeling bewust gelijk
  // houden), zodat op de meeste pagina's geen extra request nodig is. Alleen
  // het getal in de tekst wisselt; de vertaalde tekst eromheen blijft.
  (function () {
    var el = document.querySelector('[data-iv-footer-tp]');
    if (!el) return;
    var src = el.getAttribute('data-iv-footer-tp');
    var key = 'iv-tp-reviews:v5:' + src;
    function zet(totaal) {
      if (totaal && /[\d.,+]+/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/[\d.,+]+/, String(totaal));
      }
    }
    try {
      var cached = JSON.parse(localStorage.getItem(key) || 'null');
      // 3600000 = 1 uur (Ivo 31/08, was 24). Zelfde waarde als
      // assets/iv-trustpilot-live.js, iv-testimonials, iv-ivono-at-work en
      // iv-product-rating: gedeelde cache-key, dus gelijk houden.
      if (cached && cached.t && Date.now() - cached.t < 3600000 && cached.d) {
        zet(cached.d.businessUnit && cached.d.businessUnit.total);
        return;
      }
    } catch (e) { /* cache onbruikbaar: gewoon fetchen */ }
    fetch(src)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        var slank = {
          businessUnit: d.businessUnit && d.businessUnit.numberOfReviews ? { total: d.businessUnit.numberOfReviews.total, trustScore: d.businessUnit.trustScore, stars: d.businessUnit.stars } : null,
          starsString: d.starsString || '',
          reviews: (d.reviews || []).map(function (r) {
            return {
              stars: r.stars,
              title: r.title,
              text: r.text,
              createdAt: r.createdAt,
              reviewUrl: r.reviewUrl,
              consumer: { displayName: r.consumer && r.consumer.displayName },
              verification: { isVerified: !!(r.verification && r.verification.isVerified) }
            };
          })
        };
        try { localStorage.setItem(key, JSON.stringify({ t: Date.now(), d: slank })); } catch (e) { /* private mode */ }
        zet(slank.businessUnit && slank.businessUnit.total);
      })
      .catch(function () { /* fallback: de ingestelde tekst blijft staan */ });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ---- Announcement-rotatie (klantverzoek Ivo 2026-08-18) ----
  // Op 1512 staan de drie berichten naast elkaar en verandert er niets. Passen
  // ze niet (mobiel, en in de tussenmaten 750-1040), dan schuiven ze om de 4s
  // door. Of het past bepalen we door te meten, niet met een breakpoint: de
  // merchant kan berichten toevoegen of langer maken.
  var ANNOUNCE_INTERVAL = 4000;
  var ANNOUNCE_FADE = 400;

  function initAnnouncement(root) {
    var wrap = root.querySelector('[data-announcement-rotator]');
    if (!wrap) return;
    var items = Array.prototype.slice.call(wrap.querySelectorAll('.iv-header__message'));
    if (items.length < 2) return;

    var index = 0;
    var timer = null;
    var leaveTimer = null;
    var resizeTimer = null;
    var paused = false;

    // Roteren zodra de bezoeker niet álle berichten ziet. Drie manieren waarop er
    // eentje wegvalt, en we moeten ze alle drie vangen:
    //   1. de ≤749-regel zet bericht 2 en 3 op display:none;
    //   2. flex-wrap + max-height duwt een bericht naar regel 2, buiten de balk;
    //   3. bij nowrap zou het rechts uit beeld lopen.
    // Alleen op breedte meten zou geval 1 missen: tussen 640 en 749 pássen de drie
    // berichten wel, maar de mobiele CSS verbergt er twee. Dan bleef het bij één
    // vast bericht en gebeurde er niets. Meten gebeurt in de natuurlijke staat,
    // dus `is-rotating` gaat er synchroon even af (geen paint ertussen, dus geen
    // flikkering en geen herstartende transitie).
    function needsRotation() {
      var wasRotating = wrap.classList.contains('is-rotating');
      if (wasRotating) wrap.classList.remove('is-rotating');
      var hidden = items.some(function (item) {
        return window.getComputedStyle(item).display === 'none';
      });
      var clipped =
        wrap.scrollHeight > wrap.clientHeight + 1 || wrap.scrollWidth > wrap.clientWidth + 1;
      if (wasRotating) wrap.classList.add('is-rotating');
      return hidden || clipped;
    }

    function show(next) {
      if (next === index) return;
      var current = items[index];
      var upcoming = items[next];
      current.classList.remove('is-current');
      current.classList.add('is-leaving');
      upcoming.classList.remove('is-leaving');
      upcoming.classList.add('is-current');
      index = next;
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(function () {
        items.forEach(function (item) {
          if (item !== items[index]) item.classList.remove('is-leaving');
        });
      }, ANNOUNCE_FADE + 100);
    }

    function tick() {
      if (paused || document.hidden) return;
      show((index + 1) % items.length);
    }

    function start() {
      if (!wrap.classList.contains('is-rotating')) {
        wrap.classList.add('is-rotating');
        items.forEach(function (item, i) {
          item.classList.remove('is-leaving');
          item.classList.toggle('is-current', i === index);
        });
      }
      if (timer) return;
      timer = setInterval(tick, ANNOUNCE_INTERVAL);
    }

    function stop() {
      clearInterval(timer);
      clearTimeout(leaveTimer);
      timer = null;
      wrap.classList.remove('is-rotating');
      items.forEach(function (item) {
        item.classList.remove('is-current', 'is-leaving');
      });
      index = 0;
    }

    function apply() {
      if (needsRotation()) {
        start();
      } else {
        stop();
      }
    }

    // Pauze bij hover/focus: de bezoeker die een bericht leest of een link erin
    // aanwijst, verliest hem niet halverwege (WCAG 2.2.2).
    wrap.addEventListener('mouseenter', function () { paused = true; });
    wrap.addEventListener('mouseleave', function () { paused = false; });
    wrap.addEventListener('focusin', function () { paused = true; });
    wrap.addEventListener('focusout', function () { paused = false; });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(apply, 150);
    });

    apply();
    // Fallback-fonts zijn smaller dan Hanken Grotesk/Nunito: meten vóór de fonts
    // binnen zijn geeft "past wel" waar het straks niet past.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(apply).catch(function () {});
    }
  }

  function initHeader(root) {
    if (root.dataset.ivInit) return;
    root.dataset.ivInit = '1';

    initAnnouncement(root);

    var menu = root.querySelector('.iv-header__menu');
    var menuToggle = root.querySelector('.iv-header__menu-toggle');
    var searchToggle = root.querySelector('.iv-header__search-toggle');
    var mobileSearch = root.querySelector('.iv-header__mobile-search');
    var menuCloseTimer = null;
    // Houdt de uitgestelde tweede-paneel-opening vast, zodat een snelle
    // vervolgklik of een sluiting hem kan afbreken.
    var previewStagger = null;
    var paneelWachtOpruimen = null;
    // Nav-link die het menu opende; bij sluiten gaat de focus daarheen terug.
    var menuReturnFocus = null;

    function resetNavExpanded() {
      root.querySelectorAll('.iv-header__nav-link[aria-expanded="true"]').forEach(function (l) {
        l.setAttribute('aria-expanded', 'false');
      });
    }

    // Terugknop volgt de paneelstand: alleen zichtbaar zolang er een tweede paneel open
    // staat, en alleen op mobiel (daar dekt dat paneel het menu volledig).
    function toonTerugknop() {
      var knop = root.querySelector('[data-preview-back]');
      if (!knop) return;
      var open = !!root.querySelector('.iv-header__preview.is-open');
      knop.hidden = !(open && window.matchMedia('(max-width: 989px)').matches);
    }

    function closePreviews() {
      root.querySelectorAll('.iv-header__preview.is-open').forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
      root.querySelectorAll('.iv-header__primary-item.is-active').forEach(function (i) {
        i.classList.remove('is-active');
        i.setAttribute('aria-expanded', 'false');
      });
      toonTerugknop();
    }

    root.querySelectorAll('[data-preview-back]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        var actief = root.querySelector('.iv-header__primary-item.is-active');
        closePreviews();
        // Focus terug naar het item waar de bezoeker vandaan kwam.
        if (actief && actief.focus) actief.focus();
      });
    });
    window.addEventListener('resize', toonTerugknop);

    function openMenu() {
      if (!menu) return;
      // A pending close-timeout would hide the menu mid-open (reopen within 260ms).
      window.clearTimeout(menuCloseTimer);
      // Standaard geen focus-terugkeer: de hamburgerknop houdt zijn eigen focus.
      // Een nav-link zet menuReturnFocus meteen na deze aanroep zelf.
      menuReturnFocus = null;
      menu.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          menu.classList.add('is-open');
        });
      });
      menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    /* Roept `klaar` aan zodra het menupaneel zijn inschuif-animatie af heeft.
       Werkt op `transitionend` van de transform, met een timeout als vangnet:
       vuurt die transitie niet (reduced motion, een onderbroken animatie, een
       browser die hem overslaat), dan blijft het tweede paneel anders eeuwig
       dicht. 900ms is ruim boven de gemeten 565 waarop het paneel stilstaat
       (450ms transitie plus de twee frames die openMenu wacht). */
    function wachtOpPaneel(klaar) {
      var paneel = root.querySelector('.iv-header__panel');
      annuleerPaneelWacht();
      if (!paneel) { klaar(); return; }

      var afgehandeld = false;
      function eenmalig() {
        if (afgehandeld) return;
        afgehandeld = true;
        paneel.removeEventListener('transitionend', opTransitie);
        window.clearTimeout(previewStagger);
        previewStagger = null;
        klaar();
      }
      function opTransitie(e) {
        if (e.target !== paneel || e.propertyName !== 'transform') return;
        eenmalig();
      }

      paneelWachtOpruimen = function () {
        afgehandeld = true;
        paneel.removeEventListener('transitionend', opTransitie);
      };
      paneel.addEventListener('transitionend', opTransitie);
      previewStagger = window.setTimeout(eenmalig, 900);
    }

    function annuleerPaneelWacht() {
      window.clearTimeout(previewStagger);
      previewStagger = null;
      if (paneelWachtOpruimen) {
        paneelWachtOpruimen();
        paneelWachtOpruimen = null;
      }
    }

    function closeMenu() {
      if (!menu || menu.hidden || !menu.classList.contains('is-open')) return;
      // Sluit iemand binnen de wachttijd weer, dan mag het tweede paneel niet
      // alsnog uitschuiven over een menu dat al wegglijdt.
      annuleerPaneelWacht();
      menu.classList.remove('is-open');
      menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
      resetNavExpanded();
      document.body.style.overflow = '';
      window.clearTimeout(menuCloseTimer);
      menuCloseTimer = window.setTimeout(function () {
        menu.hidden = true;
        closePreviews();
      }, 260);
      // Focus terug naar de nav-link die het menu opende, anders blijft hij op
      // een element staan dat straks op `hidden` gaat en valt hij terug op body.
      if (menuReturnFocus) {
        var back = menuReturnFocus;
        menuReturnFocus = null;
        back.focus();
      }
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        // Track is-open, not `hidden`: during the close animation hidden is still
        // false for 260ms, so a click in that window would close a second time
        // instead of reopening.
        if (menu && !menu.classList.contains('is-open')) openMenu();
        else closeMenu();
      });
    }
    root.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });

    function openPreview(item, target) {
      closePreviews();
      target.classList.add('is-open');
      target.setAttribute('aria-hidden', 'false');
      item.classList.add('is-active');
      item.setAttribute('aria-expanded', 'true');
      toonTerugknop();
    }

    // Submenu previews in the panel
    root.querySelectorAll('.iv-header__primary-item[data-preview-target]').forEach(function (item) {
      item.addEventListener('click', function () {
        var target = root.querySelector('#' + item.dataset.previewTarget);
        if (!target) return;
        if (target.classList.contains('is-open')) closePreviews();
        else { openPreview(item, target); toonTerugknop(); }
      });
    });

    // Nav-items in de balk openen het hamburger-menu op hun eigen paneel
    // (klantbeslissing Mehmet 2026-08-06, vervangt de productdropdown). De oude
    // hover-handlers zijn weg: die klapten de dropdown open zonder klik.
    // Alleen items met een bestaand paneel worden bedraad, de rest ("Office
    // projects", "Support") blijft een gewone link zonder aria-status.
    root.querySelectorAll('.iv-header__nav-link[data-menu-panel]').forEach(function (link) {
      var target = root.querySelector('#' + link.dataset.menuPanel);
      var item = root.querySelector('.iv-header__primary-item[data-preview-target="' + link.dataset.menuPanel + '"]');
      if (!target || !item) return;
      // aria-expanded staat er pas als het gedrag er ook echt is (dus niet in de
      // Liquid): zonder JS is dit een gewone link en mag hij niets beloven.
      // aria-haspopup laten we weg: het paneel is geen ARIA-menu en heeft geen
      // dialog-role, en aria-expanded beschrijft precies wat er gebeurt, net als
      // bij de hamburgerknop.
      link.setAttribute('aria-expanded', 'false');
      link.addEventListener('click', function (e) {
        // Middenklik en modifier-klik blijven navigeren (nieuw tabblad/venster).
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        resetNavExpanded();
        openMenu();
        // Het tweede paneel schuift NA het eerste uit, niet tegelijk
        // (klantvoorstel Mehmet 2026-08-06). Tegelijk openen liet de twee
        // kolommen als één blok binnenkomen, waardoor de bezoeker niet ziet
        // dat het om twee niveaus gaat.
        //
        // We hangen dit aan het einde van de eerste animatie, niet aan een
        // vast aantal milliseconden. De CSS zegt 0.25s, maar gemeten op
        // 2026-08-06 begint het paneel pas op 144ms te bewegen (openMenu zet
        // `hidden=false` en wacht twee frames) en staat het op 600ms stil. Een
        // hardgecodeerde 250 zou het tweede paneel dus middenin de eerste
        // beweging laten vertrekken, precies wat we niet willen.
        wachtOpPaneel(function () {
          if (!menu || !menu.classList.contains('is-open')) return;
          openPreview(item, target);
        });
        link.setAttribute('aria-expanded', 'true');
        // Focus mee het menu in; closeMenu zet hem terug op deze link.
        menuReturnFocus = link;
        item.focus();
      });
    });

    // Language switchers
    root.querySelectorAll('[data-lang]').forEach(function (lang) {
      var trigger = lang.querySelector('.iv-header__lang-trigger');
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = lang.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      lang.querySelectorAll('.iv-header__lang-option').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          // Echte taalwissel: submit-knop in het localization-form. Niets
          // tegenhouden — Shopify verwerkt de POST en herlaadt in de gekozen taal.
          if (opt.type === 'submit') return;
          var short = opt.dataset.short;
          root.querySelectorAll('[data-lang]').forEach(function (l) {
            l.querySelectorAll('.iv-header__lang-option').forEach(function (o) {
              o.classList.toggle('is-active', o.dataset.short === short);
            });
            var labelShort = l.querySelector('[data-lang-label]');
            var labelLong = l.querySelector('[data-lang-label-long]');
            if (labelShort) labelShort.textContent = opt.dataset.short;
            if (labelLong) labelLong.textContent = opt.dataset.long;
          });
          lang.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        });
      });
    });

    // Audience toggles: IVAudience beheert state + btw-vrije prijzen (b2b);
    // fallback zonder module = alleen visueel syncen.
    root.querySelectorAll('.iv-header__audience-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var value = opt.dataset.audience;
        if (window.IVAudience) {
          window.IVAudience.set(value);
          return;
        }
        root.querySelectorAll('.iv-header__audience-option').forEach(function (o) {
          o.classList.toggle('is-active', o.dataset.audience === value);
        });
      });
    });

    // Predictive search: Shopify /search/suggest.json (volgt Search & Discovery-instellingen)
    root.querySelectorAll('form[data-predictive]').forEach(function (form) {
      var input = form.querySelector('.iv-header__search-input');
      var panel = form.querySelector('[data-suggest-panel]');
      if (!input || !panel) return;
      var controller = null;
      var debounceTimer = null;
      var euro = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 });
      // Dit JS-blok verwerkt geen Liquid: icoon, zoek-URL en de labels van het
      // suggestie-paneel komen uit de DOM (data-attributen op het formulier).
      var iconEl = form.querySelector('.iv-icon');
      var iconSvg = iconEl ? iconEl.innerHTML : '';
      var searchUrl = form.getAttribute('action');
      var productsHeading = form.dataset.suggestProducts || 'Producten';
      var emptyText = form.dataset.suggestEmpty || 'Geen suggesties voor deze zoekterm';
      var allLabel = form.dataset.suggestAll || 'Alle resultaten bekijken';

      function hidePanel() {
        panel.hidden = true;
      }

      function render(data, query) {
        var products = (data.resources.results.products || []).slice(0, 5);
        var queries = (data.resources.results.queries || []).slice(0, 3);
        var html = '';
        queries.forEach(function (q) {
          html += '<a class="iv-header__suggest-query" href="' + q.url + '">' +
            '<span class="iv-icon">' + iconSvg + '</span>' +
            '<span>' + (q.styled_text || q.text) + '</span></a>';
        });
        if (products.length) {
          html += '<p class="iv-header__suggest-heading">' + productsHeading + '</p>';
          products.forEach(function (p) {
            var parts = (p.title || '').split('|');
            var name = parts[0].trim();
            var sub = parts.length > 1 ? parts[1].trim() : '';
            var priceCents = p.price ? Math.round(parseFloat(p.price) * 100) : 0;
            var price = '';
            if (priceCents) {
              price = window.IVAudience
                ? window.IVAudience.display(priceCents)
                : euro.format(priceCents / 100).replace(/\s/g, '');
            }
            html += '<a class="iv-header__suggest-product" href="' + p.url + '">' +
              '<span class="iv-header__suggest-thumb">' + (p.image ? '<img src="' + p.image + '&width=88" width="44" height="44" loading="lazy" alt="">' : '') + '</span>' +
              '<span class="iv-header__suggest-stack"><span class="iv-header__suggest-name"></span>' +
              (sub ? '<span class="iv-header__suggest-sub"></span>' : '') + '</span>' +
              (price ? '<span class="iv-header__suggest-price">' + price + '</span>' : '') + '</a>';
          });
        }
        if (!queries.length && !products.length) {
          html += '<p class="iv-header__suggest-empty">' + emptyText + '</p>';
        }
        html += '<a class="iv-header__suggest-all" href="' + searchUrl + '?q=' + encodeURIComponent(query) + '">' + allLabel + '</a>';
        panel.innerHTML = html;
        // Titels als text zetten (geen HTML-injectie vanuit productdata)
        var nameEls = panel.querySelectorAll('.iv-header__suggest-name');
        var subEls = panel.querySelectorAll('.iv-header__suggest-sub');
        var nameIdx = 0;
        var subIdx = 0;
        products.forEach(function (p) {
          var parts = (p.title || '').split('|');
          if (nameEls[nameIdx]) nameEls[nameIdx].textContent = parts[0].trim();
          nameIdx += 1;
          if (parts.length > 1 && subEls[subIdx]) {
            subEls[subIdx].textContent = parts[1].trim();
            subIdx += 1;
          }
        });
        panel.hidden = false;
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        window.clearTimeout(debounceTimer);
        if (controller) controller.abort();
        if (q.length < 2) {
          hidePanel();
          return;
        }
        debounceTimer = window.setTimeout(function () {
          controller = new AbortController();
          var url = form.dataset.suggestUrl + '.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,query&resources[limit]=5&resources[options][unavailable_products]=hide';
          fetch(url, { signal: controller.signal })
            .then(function (r) { return r.json(); })
            .then(function (data) { render(data, q); })
            .catch(function () {});
        }, 250);
      });
      input.addEventListener('focus', function () {
        if (panel.innerHTML !== '' && input.value.trim().length >= 2) panel.hidden = false;
      });
    });

    // Mobile search row
    if (searchToggle && mobileSearch) {
      searchToggle.addEventListener('click', function () {
        var open = mobileSearch.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = mobileSearch.querySelector('input');
          input && input.focus();
        }
      });
    }

    // Global close behaviour
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        root.querySelectorAll('.iv-header__lang.is-open').forEach(function (l) {
          l.classList.remove('is-open');
        });
        return;
      }
      if (!e.target.closest('[data-lang]')) {
        root.querySelectorAll('.iv-header__lang.is-open').forEach(function (l) {
          l.classList.remove('is-open');
        });
      }
      if (!e.target.closest('form[data-predictive]')) {
        root.querySelectorAll('[data-suggest-panel]').forEach(function (p) {
          p.hidden = true;
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeMenu();
      root.querySelectorAll('.iv-header__lang.is-open').forEach(function (l) {
        l.classList.remove('is-open');
      });
      root.querySelectorAll('[data-suggest-panel]').forEach(function (p) {
        p.hidden = true;
      });
    });
  }

  // Cart-badge site-breed live houden: cart:updated / cart:refresh
  // (cartpagina, drawer, quick-ATC) updaten .iv-header__cart-count client-side.
  function setCartCount(count) {
    document.querySelectorAll('.iv-header__cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }
  function syncCartCount(e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart && typeof cart.item_count === 'number') {
      setCartCount(cart.item_count);
      return;
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (c && typeof c.item_count === 'number') setCartCount(c.item_count);
      })
      .catch(function () {});
  }
  document.addEventListener('cart:updated', syncCartCount);
  document.addEventListener('cart:refresh', syncCartCount);

  document.querySelectorAll('.iv-header').forEach(initHeader);
  document.addEventListener('shopify:section:load', function (e) {
    var header = e.target.querySelector('.iv-header');
    if (header) initHeader(header);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-hero"] && !Shopify.designMode) return;
  try {
    
  /* Uitgesteld starten van de achtergrondvideo (snelheidssweep 24/08): de
     markup heeft bewust géén autoplay en preload="none", zodat de 5,2 MB-mp4
     nooit met de LCP concurreert. Pas ná window-load start het afspelen; bij
     'verminder beweging' of databesparing blijft alleen de poster staan (CSS
     verbergt de video bij reduced motion sowieso al). */
  (function () {
    var videos = document.querySelectorAll('.iv-hero__video[data-hero-video]');
    if (!videos.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (navigator.connection && navigator.connection.saveData) return;
    function start() {
      setTimeout(function () {
        videos.forEach(function (video) {
          video.play().catch(function () { /* autoplay geweigerd: poster blijft */ });
        });
      }, 200);
    }
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-how-it-works"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.iv-how-it-works [data-hiw-play]');
    if (!trigger) return;
    const media = trigger.closest('.iv-how-it-works__media');
    const wrap = media && media.querySelector('[data-hiw-video]');
    if (!wrap) return;
    wrap.hidden = false;
    trigger.hidden = true;
    const el = wrap.querySelector('video');
    if (el) {
      // Geluid-schakelaar (Mehmet 24/08): wie klikt om af te spelen verwacht
      // geluid, dus de klik-route volgt de instelling expliciet. Staat het
      // geluid uit, dan blijft de video gedempt; via de bedieningsbalk kan de
      // bezoeker het alsnog aanzetten.
      el.muted = !wrap.hasAttribute('data-hiw-sound');
      el.controls = true;
      el.play();
    }
  });

  // Knop-zichtbaarheid volgt de videostaat, welke afspeelroute ook gebruikt is
  // (Mehmet 20/08: de playbutton moet weg zodra de video speelt). Media-events
  // bubbelen niet, dus capture-fase. Na afloop komt de knop terug voor herstart.
  const hiwKnopVolgtVideo = (event, verbergen) => {
    const el = event.target;
    if (!el.matches || !el.matches('.iv-how-it-works [data-hiw-video] video')) return;
    const media = el.closest('.iv-how-it-works__media');
    const trigger = media && media.querySelector('[data-hiw-play]');
    if (trigger) trigger.hidden = verbergen;
    // Na afloop terug naar de ruststand: geen bedieningsbalk, alleen de knop.
    if (!verbergen) el.controls = false;
  };
  document.addEventListener('play', (event) => hiwKnopVolgtVideo(event, true), true);
  document.addEventListener('ended', (event) => hiwKnopVolgtVideo(event, false), true);

  // Autoplay-stand (Ivo 24/08): speelt gedempt en in een lus, alleen zolang de
  // video in beeld is; een klik op de video zet het geluid aan (autoplay mét
  // geluid staan browsers niet toe). Bij prefers-reduced-motion geen autoplay:
  // de afspeelknop komt terug en de klik-route geldt, met geluid.
  (() => {
    const wraps = document.querySelectorAll('.iv-how-it-works [data-hiw-video][data-hiw-autoplay]');
    if (!wraps.length) return;
    const rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
    wraps.forEach((wrap) => {
      const el = wrap.querySelector('video');
      if (!el) return;
      if (rustig.matches) {
        const media = wrap.closest('.iv-how-it-works__media');
        const trigger = media && media.querySelector('[data-hiw-play]');
        if (trigger) trigger.hidden = false;
        el.muted = !wrap.hasAttribute('data-hiw-sound');
        return;
      }
      el.muted = true;
      el.loop = true;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) el.play().catch(() => {});
          else el.pause();
        });
      }, { threshold: 0.3 });
      io.observe(el);
      el.addEventListener('click', () => {
        // Alleen unmuten als de geluid-schakelaar aan staat; anders blijft de
        // video bewust gedempt (merchant-keuze).
        if (el.muted && wrap.hasAttribute('data-hiw-sound')) {
          el.muted = false;
          el.controls = true;
          el.play().catch(() => {});
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-ivono-at-work"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SPOT = '.iv-iaw__spot';

  function closeSpot(spot) {
    spot.classList.remove('is-open');
    var btn = spot.querySelector('[data-iv-spot-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function closeAllSpots(except) {
    document.querySelectorAll(SPOT + '.is-open').forEach(function (spot) {
      if (spot !== except) closeSpot(spot);
    });
  }

  /* De kaart hangt per Figma boven-links van de dot; zit een dot hoog of aan de rand,
     dan schuiven we de kaart terug binnen de foto (de tegel heeft overflow:hidden). */
  function placeSpotCard(spot) {
    var card = spot.querySelector('[data-iv-spot-card]');
    var bounds = spot.closest('.iv-iaw__project-slide');
    if (!card || !bounds) return;
    card.style.transform = '';
    var b = bounds.getBoundingClientRect();
    var c = card.getBoundingClientRect();
    if (!c.width || !b.width) return;
    var pad = 8;
    var dx = 0;
    var dy = 0;
    if (c.left < b.left + pad) dx = b.left + pad - c.left;
    else if (c.right > b.right - pad) dx = Math.max(b.right - pad - c.right, b.left + pad - c.left);
    if (c.top < b.top + pad) dy = b.top + pad - c.top;
    else if (c.bottom > b.bottom - pad) dy = Math.max(b.bottom - pad - c.bottom, b.top + pad - c.top);
    if (dx || dy) card.style.transform = 'translate(' + Math.round(dx) + 'px, ' + Math.round(dy) + 'px)';
  }

  function placeOpenSpots(root) {
    (root || document).querySelectorAll(SPOT + '.is-open').forEach(placeSpotCard);
  }

  function initSpots(root) {
    root.querySelectorAll('[data-iv-spot-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var spot = btn.closest(SPOT);
        if (!spot) return;
        var willOpen = !spot.classList.contains('is-open');
        closeAllSpots(spot);
        spot.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) placeSpotCard(spot);
      });
    });
    placeOpenSpots(root);
  }

  if (!window.ivTestimonialsSpotsBound) {
    window.ivTestimonialsSpotsBound = true;
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest(SPOT)) return;
      closeAllSpots();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllSpots();
    });
    window.addEventListener('resize', function () {
      placeOpenSpots();
    });
  }

  function initProject(card) {
    if (card.dataset.ivProjectInit) return;
    card.dataset.ivProjectInit = 'true';
    var media = card.querySelector('[data-iv-project-media]');
    var prev = card.querySelector('[data-iv-project-prev]');
    var next = card.querySelector('[data-iv-project-next]');
    var dots = card.querySelectorAll('.iv-iaw__project-dots span');
    if (!media || !prev || !next) return;

    function update() {
      var w = media.clientWidth || 1;
      var idx = Math.round(media.scrollLeft / w);
      var max = media.scrollWidth - media.clientWidth - 1;
      prev.disabled = media.scrollLeft <= 0;
      next.disabled = media.scrollLeft >= max;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    prev.addEventListener('click', function () {
      media.scrollBy({ left: -media.clientWidth, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      media.scrollBy({ left: media.clientWidth, behavior: 'smooth' });
    });
    media.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    if (root.dataset.ivTestimonialsInit) return;
    root.dataset.ivTestimonialsInit = 'true';
    root.querySelectorAll('[data-iv-project]').forEach(initProject);
    initSpots(root);
    var scroller = root.querySelector('[data-iv-iaw-scroller]');
    var prev = root.querySelector('[data-iv-iaw-prev]');
    var next = root.querySelector('[data-iv-iaw-next]');
    if (!scroller || !prev || !next) return;

    function step() {
      var card = scroller.querySelector('.iv-iaw__card, .iv-iaw__project');
      if (!card) return scroller.clientWidth;
      var styles = window.getComputedStyle(scroller);
      var gap = parseFloat(styles.columnGap || styles.gap) || 4;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth - 1;
      prev.disabled = scroller.scrollLeft <= 0;
      next.disabled = scroller.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      scroller.scrollBy({ left: -1 * step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      scroller.scrollBy({ left: step(), behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Trustpilot-live-bron: verse reviews (4-5 sterren) van het TrustBox-data-
     endpoint, gerenderd in exact de eigen kaart-markup. Cache in localStorage
     van 1 uur (Ivo 31/08, was 24); elke fout laat de server-gerenderde
     fallback-kaarten gewoon staan. Alle reviewvelden gaan via textContent,
     nooit via innerHTML. */
  var TP_STAR_PATH = 'M11.9985 16.1755L15.6471 15.2542L17.1664 19.9561L11.9865 16.1755H11.9985ZM20.3963 10.0977H13.9723L11.9985 4.04387L10.0247 10.0977H3.60075L8.80449 13.8425L6.83065 19.8963L12.0344 16.1515L15.2404 13.8544L20.4202 10.1097L20.3963 10.0977Z';
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function tpEl(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text) el.textContent = text;
    return el;
  }

  function tpStars(count) {
    var wrap = tpEl('div', 'iv-iaw__stars iv-iaw__stars--sm');
    wrap.setAttribute('role', 'img');
    // Zelfde label als de server-gerenderde sterren; /^nl/ omdat de JS-kaarten
    // de Liquid-variant vervangen en anders in het Engels terugkomen.
    wrap.setAttribute('aria-label', count + (/^nl\b/i.test(document.documentElement.lang || '')
      ? ' van de 5 sterren' : ' out of 5 stars'));
    for (var i = 1; i <= 5; i++) {
      var svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      var rect = document.createElementNS(SVG_NS, 'rect');
      rect.setAttribute('width', '24');
      rect.setAttribute('height', '24');
      if (i <= count) rect.setAttribute('fill', '#00B67A');
      else rect.setAttribute('class', 'iv-tst-star-rest');
      svg.appendChild(rect);
      var path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', TP_STAR_PATH);
      path.setAttribute('fill', '#FFFFFF');
      svg.appendChild(path);
      wrap.appendChild(svg);
    }
    return wrap;
  }

  // Exact de officiële Trustpilot-badge (Mehmet 24/08, naar hun live shop):
  // grijs bolletje met wit vinkje, grijze onderstreepte tekst.
  function tpVerifiedBadge(label) {
    var span = tpEl('span', 'iv-iaw__verified');
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('aria-hidden', 'true');
    var circle = document.createElementNS(SVG_NS, 'circle');
    circle.setAttribute('cx', '8');
    circle.setAttribute('cy', '8');
    circle.setAttribute('r', '8');
    circle.setAttribute('fill', 'currentColor');
    svg.appendChild(circle);
    var check = document.createElementNS(SVG_NS, 'path');
    check.setAttribute('d', 'M4.5 8.4 7 10.9l4.5-5');
    check.setAttribute('stroke', '#FFFFFF');
    check.setAttribute('stroke-width', '1.6');
    check.setAttribute('fill', 'none');
    check.setAttribute('stroke-linecap', 'round');
    check.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(check);
    span.appendChild(svg);
    var tekst = tpEl('span', 'iv-iaw__verified-label', label);
    span.appendChild(tekst);
    return span;
  }

  // Datum exact in Trustpilot-telling (correctie Mehmet 24/08: onze "yesterday"
  // was bij Trustpilot "2 dagen geleden"). Trustpilot telt KALENDERdagen, geen
  // blokken van 24 uur, schrijft het getal uit ("1 dag geleden", niet
  // "gisteren") en gebruikt uren binnen dezelfde dag. Ouder dan een maand: de
  // gewone lange datum.
  function tpDagenGeleden(d) {
    var nu = new Date();
    return Math.round((new Date(nu.getFullYear(), nu.getMonth(), nu.getDate()) -
      new Date(d.getFullYear(), d.getMonth(), d.getDate())) / 86400000);
  }

  // Datum-locale: de storefront-taal, maar 'en' expliciet naar en-GB. Kaal 'en'
  // is voor Intl en-US en dat geeft "8/26/2026" — maand-eerst, terwijl de
  // Nederlandse kaart ernaast dag-eerst toont. Eén review met twee leesrichtingen
  // is precies de inconsistentie die de klant op 26/08 meldde.
  function tpLocale(lang) {
    return /^en\b/i.test(lang || '') ? 'en-GB' : (lang || 'en-GB');
  }

  function tpDatum(iso, lang) {
    var d = new Date(iso);
    if (isNaN(d)) return String(iso || '').slice(0, 10);
    var loc = tpLocale(lang);
    var dagen = tpDagenGeleden(d);
    if (dagen >= 0 && dagen < 30 && window.Intl && Intl.RelativeTimeFormat) {
      try {
        var rtf = new Intl.RelativeTimeFormat(loc, { numeric: 'always' });
        if (dagen === 0) {
          // `nu` stond hier tot 26/08 buiten scope (hij is lokaal aan
          // tpDagenGeleden): elke review van vandaag gooide een ReferenceError,
          // viel door naar de lange datum en kreeg daaronder ook nog de exacte
          // datum — dezelfde dag twee keer, in twee opmaken.
          var uren = Math.max(1, Math.floor((Date.now() - d.getTime()) / 3600000));
          return rtf.format(-uren, 'hour');
        }
        return rtf.format(-dagen, 'day');
      } catch (e) { /* onbekende locale: val door naar de datum */ }
    }
    try {
      return d.toLocaleDateString(loc, { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) {
      return String(iso).slice(0, 10);
    }
  }

  // Exacte datum (Ivo 25/08: "de datum er subtiel bij, dan is hij fake-proof"):
  // altijd dag-maand-jaar in cijfers, alleen onder een relatieve datum; ouder
  // dan een maand staat de volledige datum al in de regel zelf.
  // NL geeft 26-08-2026, en-GB 26/08/2026 — zelfde volgorde, eigen scheidingsteken.
  function tpIsRelatief(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return false;
    var dagen = tpDagenGeleden(d);
    return dagen >= 0 && dagen < 30 && !!(window.Intl && Intl.RelativeTimeFormat);
  }

  // Exacte datum onder de relatieve tekst, volledig uitgeschreven (Mehmet 26/08: "niet
  // 22/08/2026 maar 22 augustus 2026"): nl "22 augustus 2026", en "22 August 2026".
  // Zelfde vorm als de uitgeschreven datum van oudere reviews in tpDatum().
  function tpDatumExact(iso, lang) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    if (window.Intl && Intl.DateTimeFormat) {
      try {
        return new Intl.DateTimeFormat(tpLocale(lang), {
          day: 'numeric', month: 'long', year: 'numeric'
        }).format(d);
      } catch (e) { /* onbekende locale: val door naar de handmatige vorm */ }
    }
    var maanden = (lang || '').indexOf('nl') === 0
      ? ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
      : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return d.getDate() + ' ' + maanden[d.getMonth()] + ' ' + d.getFullYear();
  }

  function initTrustpilot(root) {
    var scroller = root.querySelector('[data-iv-tp-source]');
    if (!scroller || scroller.dataset.ivTpDone) return;
    scroller.dataset.ivTpDone = 'true';
    var src = scroller.dataset.ivTpSource;
    var cacheKey = 'iv-tp-reviews:v5:' + src;
    // 1 uur (Ivo 31/08, was 24). Zelfde waarde als assets/iv-trustpilot-live.js,
    // iv-testimonials, iv-footer en iv-product-rating: gedeelde cache-key.
    var TTL = 60 * 60 * 1000;
    var lang = document.documentElement.lang || 'en';

    function render(data) {
      // Dynamische teller (Ivo 24/08): het getal in de koptekst ("500+ reviews
      // on") wordt het echte Trustpilot-totaal; de rest van de tekst en dus de
      // vertaling blijft staan. Ook bij nul kaarten, het totaal is winkelbreed.
      var totaal = data && data.businessUnit && data.businessUnit.total;
      if (totaal) {
        var teller = root.querySelector('[data-iv-tst-count]');
        if (teller && /[\d.,+]+/.test(teller.textContent)) {
          teller.textContent = teller.textContent.replace(/[\d.,+]+/, String(totaal));
        }
      }
      // Trustpilot-label (Ivo 25/08): Trustpilots eigen starsString, in de
      // taal van de storefront opgehaald, vervangt de placeholder in de kop.
      var label = data && data.starsString;
      if (label) {
        var labelEl = root.querySelector('[data-iv-tst-label]');
        if (labelEl) labelEl.textContent = label;
      }
      var reviews = (data && data.reviews) || [];
      var frag = document.createDocumentFragment();
      reviews.forEach(function (r) {
        if (!r || !r.text) return;
        // Trustpilot-stijl (Mehmet 24/08): een kaart linkt naar zijn eigen
        // review op Trustpilot, in een nieuw tabblad. Zonder reviewUrl (oude
        // cache, productreviews) blijft de kaart een gewoon article.
        var card;
        if (r.reviewUrl) {
          card = tpEl('a', 'iv-iaw__card iv-iaw__card--link');
          card.href = r.reviewUrl;
          card.target = '_blank';
          card.rel = 'noopener';
        } else {
          card = tpEl('article', 'iv-iaw__card');
        }
        var main = tpEl('div', 'iv-iaw__card-main');
        var starsRow = tpEl('div', 'iv-iaw__stars-row');
        starsRow.appendChild(tpStars(r.stars || 5));
        if (r.verification && r.verification.isVerified) starsRow.appendChild(tpVerifiedBadge(scroller.dataset.ivTpVerified || 'Verified'));
        main.appendChild(starsRow);
        var text = tpEl('div', 'iv-iaw__card-text');
        if (r.title) text.appendChild(tpEl('h3', 'iv-iaw__card-title', r.title));
        text.appendChild(tpEl('p', 'iv-iaw__card-body', r.text));
        main.appendChild(text);
        card.appendChild(main);
        var author = tpEl('div', 'iv-iaw__card-author');
        var naam = (r.consumer && r.consumer.displayName) || '';
        if (naam) author.appendChild(tpEl('p', 'iv-iaw__card-name', naam));
        if (r.createdAt) {
          author.appendChild(tpEl('p', 'iv-iaw__card-date', tpDatum(r.createdAt, lang)));
          if (tpIsRelatief(r.createdAt)) author.appendChild(tpEl('p', 'iv-iaw__card-date-exact', tpDatumExact(r.createdAt, lang)));
        }
        card.appendChild(author);
        frag.appendChild(card);
      });
      if (!frag.childNodes.length) return;
      scroller.textContent = '';
      scroller.appendChild(frag);
      scroller.scrollLeft = 0;
      scroller.dispatchEvent(new Event('scroll'));
    }

    try {
      var cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
      if (cached && cached.t && Date.now() - cached.t < TTL && cached.d) {
        render(cached.d);
        return;
      }
    } catch (e) { /* cache onbruikbaar: gewoon fetchen */ }

    var mode = scroller.dataset.ivTpMode || 'service';
    fetch(src)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        // Bron 'product' levert productReviews.reviews met 'content' i.p.v.
        // 'text' en zonder titel of verificatieveld; hier al gelijkgetrokken
        // zodat cache en render maar één vorm kennen.
        var lijst = mode === 'product' ? ((d.productReviews && d.productReviews.reviews) || []) : (d.reviews || []);
        var slank = {
          businessUnit: d.businessUnit && d.businessUnit.numberOfReviews ? { total: d.businessUnit.numberOfReviews.total, trustScore: d.businessUnit.trustScore, stars: d.businessUnit.stars } : null,
          starsString: d.starsString || '',
          reviews: lijst.map(function (r) {
            return {
              stars: r.stars,
              title: r.title,
              text: r.text || r.content,
              createdAt: r.createdAt,
              reviewUrl: r.reviewUrl,
              consumer: { displayName: r.consumer && r.consumer.displayName },
              verification: { isVerified: !!(r.verification && r.verification.isVerified) }
            };
          })
        };
        try { localStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), d: slank })); } catch (e) { /* private mode */ }
        render(slank);
      })
      .catch(function () { /* fallback: de server-gerenderde kaarten blijven staan */ });
  }

  document.querySelectorAll('.iv-iaw').forEach(function (root) {
    init(root);
    initTrustpilot(root);
  });
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.iv-iaw');
    if (root) {
      init(root);
      initTrustpilot(root);
    }
  });

  /* ---------- Mobiele strook (verhuisd uit iv-product-hero op 27/08) ---------- */
  function initStrip(root) {
      var impTrack = root.querySelector('[data-iv-iaw-strip-track]');
      var impPrev = root.querySelector('[data-iv-iaw-strip-prev]');
      var impNext = root.querySelector('[data-iv-iaw-strip-next]');
      if (impTrack && impPrev && impNext) {
        function impStep() {
          var slide = impTrack.querySelector('.iv-iaw-strip__slide');
          return slide ? slide.offsetWidth + 4 : impTrack.clientWidth;
        }
        function impUpdate() {
          var max = impTrack.scrollWidth - impTrack.clientWidth - 1;
          impPrev.disabled = impTrack.scrollLeft <= 0;
          impNext.disabled = impTrack.scrollLeft >= max;
        }
        impPrev.addEventListener('click', function () {
          impTrack.scrollBy({ left: -impStep(), behavior: 'smooth' });
        });
        impNext.addEventListener('click', function () {
          impTrack.scrollBy({ left: impStep(), behavior: 'smooth' });
        });
        impTrack.addEventListener('scroll', impUpdate, { passive: true });
        window.addEventListener('resize', impUpdate);
        impUpdate();
      }

      /* Hotspots op de impression-foto's: tap opent/sluit de productkaart, kaart linkt naar het product */
      var IMP_SPOT = '.iv-iaw-strip__spot';

      function impCloseSpot(spot) {
        spot.classList.remove('is-open');
        var btn = spot.querySelector('[data-iv-iaw-spot-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }

      function impCloseSpots(except) {
        root.querySelectorAll(IMP_SPOT + '.is-open').forEach(function (spot) {
          if (spot !== except) impCloseSpot(spot);
        });
      }

      /* De kaart is groot t.o.v. de foto: terugschuiven binnen de slide (die heeft overflow:hidden) */
      function impPlaceCard(spot) {
        var card = spot.querySelector('[data-iv-iaw-spot-card]');
        var bounds = spot.closest('.iv-iaw-strip__slide');
        if (!card || !bounds) return;
        card.style.transform = '';
        var b = bounds.getBoundingClientRect();
        var c = card.getBoundingClientRect();
        if (!c.width || !b.width) return;
        var pad = 8;
        var dx = 0;
        var dy = 0;
        if (c.left < b.left + pad) dx = b.left + pad - c.left;
        else if (c.right > b.right - pad) dx = Math.max(b.right - pad - c.right, b.left + pad - c.left);
        if (c.top < b.top + pad) dy = b.top + pad - c.top;
        else if (c.bottom > b.bottom - pad) dy = Math.max(b.bottom - pad - c.bottom, b.top + pad - c.top);
        if (dx || dy) card.style.transform = 'translate(' + Math.round(dx) + 'px, ' + Math.round(dy) + 'px)';
      }

      function impPlaceOpen() {
        root.querySelectorAll(IMP_SPOT + '.is-open').forEach(impPlaceCard);
      }

      root.querySelectorAll('[data-iv-iaw-spot-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var spot = btn.closest(IMP_SPOT);
          if (!spot) return;
          var willOpen = !spot.classList.contains('is-open');
          impCloseSpots(spot);
          spot.classList.toggle('is-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          if (willOpen) impPlaceCard(spot);
        });
      });

      document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest(IMP_SPOT)) return;
        impCloseSpots();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') impCloseSpots();
      });
      window.addEventListener('resize', impPlaceOpen);
      impPlaceOpen();
  }
  document.querySelectorAll('.iv-iaw').forEach(initStrip);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.iv-iaw');
    if (root) initStrip(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-product-features"] && !Shopify.designMode) return;
  try {
    
  /* Kenmerk-video's (Ivo 28/08: "autoplay loop video/animatie bij de Features,
     op desktop bij hover zodat het niet te druk wordt"). Twee standen, gezet
     door de sectie-instelling "Video afspelen" (data-iv-pf-play):
       hover — een muis met echte hover: de video speelt zolang de kaart is
               aangewezen en springt bij het verlaten terug naar het begin;
               aanraakschermen: zodra de kaart voor de helft in beeld staat.
       auto  — overal zodra de kaart voor de helft in beeld staat.
     Bij prefers-reduced-motion start er nooit iets vanzelf; aanwijzen mag.
     Voorladen gebeurt pas als de kaart de viewport nadert (patroon van de
     Content-banner), dus bij het laden van de pagina kost een video 0 bytes.
     Een permanent driehoekje in de hoek (Ivo 22/10, CSS hierboven) toont vooraf
     dat een kaart een video heeft; hij vervaagt in sync met de .is-playing-klasse
     die hier op het beeldvak gezet wordt. */
  function ivPfVideos(scope) {
    var videos = (scope || document).querySelectorAll('[data-iv-pf-video]');
    if (!videos.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var hasIO = 'IntersectionObserver' in window;
    Array.prototype.forEach.call(videos, function (video) {
      if (video.dataset.ivPfInit) return;
      video.dataset.ivPfInit = '1';
      var card = video.closest('.iv-product-features__card') || video.parentNode;
      var media = video.closest('.iv-product-features__media');
      var speel = function () {
        var poging = video.play();
        if (poging && poging.catch) poging.catch(function () {});
      };
      var stop = function (terug) {
        if (!video.paused) video.pause();
        if (terug) {
          try { video.currentTime = 0; } catch (e) { /* nog geen metadata */ }
        }
        video.classList.remove('is-playing');
        if (media) media.classList.remove('is-playing');
      };
      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
        if (media) media.classList.add('is-playing');
      });
      video.addEventListener('pause', function () {
        video.classList.remove('is-playing');
        if (media) media.classList.remove('is-playing');
      });
      if (hasIO) {
        var lader = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (video.paused && video.readyState === 0) {
              video.preload = 'auto';
              video.load();
            }
            lader.disconnect();
          });
        }, { rootMargin: '50% 0px' });
        lader.observe(video);
      }
      if (hoverable && video.dataset.ivPfPlay !== 'auto') {
        card.addEventListener('mouseenter', speel);
        card.addEventListener('mouseleave', function () { stop(true); });
        return;
      }
      if (reduce || !hasIO) return;
      var waarnemer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) speel();
          else stop(false);
        });
      }, { threshold: 0.5 });
      waarnemer.observe(video);
    });
  }
  ivPfVideos();
  document.addEventListener('DOMContentLoaded', function () { ivPfVideos(); });
  document.addEventListener('shopify:section:load', function (event) { ivPfVideos(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-product-hero"] && !Shopify.designMode) return;
  try {
    
  /* Letterbox-correctie galerij (Mehmet 22/08; herbouwd 24/08 op zijn "kleine foto's moeten
     ook gewoon gevuld worden"). Leest elke galerijfoto op een 96px-canvas en meet per rij en
     kolom het aandeel pixels dat van de achtergrondkleur (gemiddelde van de vier hoeken)
     afwijkt. Zo ontstaat de bounding box van de echte foto-inhoud; zachte schaduw- en
     verlooprandjes vallen binnen de tolerantie en braken de oude uniformiteitsmeting juist
     te vroeg af (waardoor banen bleven staan). Is de eerste inhoudsrij vrijwel volledig
     gevuld (een echte foto, geen vrijstaand product met lege zijkanten), dan wordt het beeld
     geschaald en verschoven tot de inhoud het vak vult; vrijstaande renders blijven
     ongemoeid. Schaal gemaximeerd op 2.6 tegen extreme pixelatie. Vereist
     crossorigin=anonymous op de img (cdn.shopify.com stuurt CORS-headers); faalt de
     canvas-uitlezing, dan gebeurt er niets. */
  (function () {
    var N = 96;
    var canvas = document.createElement('canvas');
    canvas.width = N;
    canvas.height = N;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return;

    // Aandeel van de rij (kolom) dat afwijkt van de achtergrondkleur.
    function rowBusy(d, y, ref, tol) {
      var busy = 0;
      for (var x = 0; x < N; x++) {
        var i = (y * N + x) * 4;
        if (Math.abs(d[i] - ref[0]) > tol || Math.abs(d[i + 1] - ref[1]) > tol || Math.abs(d[i + 2] - ref[2]) > tol) busy++;
      }
      return busy / N;
    }
    function colBusy(d, x, ref, tol) {
      var busy = 0;
      for (var y = 0; y < N; y++) {
        var i = (y * N + x) * 4;
        if (Math.abs(d[i] - ref[0]) > tol || Math.abs(d[i + 1] - ref[1]) > tol || Math.abs(d[i + 2] - ref[2]) > tol) busy++;
      }
      return busy / N;
    }

    function analyse(img) {
      if (!img.naturalWidth || img.dataset.phAutocrop) return;
      img.dataset.phAutocrop = '1';
      var d;
      try {
        ctx.clearRect(0, 0, N, N);
        ctx.drawImage(img, 0, 0, N, N);
        d = ctx.getImageData(0, 0, N, N).data;
      } catch (e) {
        return; /* CORS of decodeprobleem: laat het beeld zoals het is */
      }
      var TOL = 22;        // ruim: jpeg-ruis en zachte verloopranden tellen als band
      var CONTENT = 0.06;  // rij is inhoud zodra >6% van de pixels echt afwijkt
      var MARGE = 0.6 / N; // ruim een halve rij extra wegzoomen tegen een restrand
      var c1 = 0, c2 = (N - 1) * 4, c3 = (N - 1) * N * 4, c4 = ((N - 1) * N + N - 1) * 4;
      var ref = [
        (d[c1] + d[c2] + d[c3] + d[c4]) / 4,
        (d[c1 + 1] + d[c2 + 1] + d[c3 + 1] + d[c4 + 1]) / 4,
        (d[c1 + 2] + d[c2 + 2] + d[c3 + 2] + d[c4 + 2]) / 4
      ];
      var rows = [], cols = [];
      for (var y = 0; y < N; y++) rows[y] = rowBusy(d, y, ref, TOL);
      for (var x = 0; x < N; x++) cols[x] = colBusy(d, x, ref, TOL);
      var top = 0, bottom = 0, left = 0, right = 0;
      while (top < N / 2 && rows[top] < CONTENT) top++;
      while (bottom < N / 2 && rows[N - 1 - bottom] < CONTENT) bottom++;
      while (left < N / 2 && cols[left] < CONTENT) left++;
      while (right < N / 2 && cols[right] < CONTENT) right++;
      // Foto-poort per as: de eerste inhoudsrij (-kolom) moet vrijwel vol zijn,
      // anders is het een vrijstaand product en blijven we eraf.
      var gateV = top + bottom >= N * 0.06 && rows[Math.min(top, N - 1)] > 0.7 && rows[Math.max(N - 1 - bottom, 0)] > 0.7;
      var gateH = left + right >= N * 0.06 && cols[Math.min(left, N - 1)] > 0.7 && cols[Math.max(N - 1 - right, 0)] > 0.7;
      var t = gateV ? top / N + MARGE : 0, b = gateV ? bottom / N + MARGE : 0;
      var l = gateH ? left / N + MARGE : 0, r = gateH ? right / N + MARGE : 0;
      var sY = gateV ? 1 / (1 - t - b) : 1;
      var sX = gateH ? 1 / (1 - l - r) : 1;
      var scale = Math.max(sY, sX);
      // Boven 2.2 is het beeld vrijwel leeg (vrijstaand product op wit): zo ver
      // inzoomen geeft een abstract fragment, dus dan liever niets doen.
      if (scale <= 1.05 || scale > 2.2) return;
      var cy = gateV ? (t + (1 - b)) / 2 : 0.5;
      var cx = gateH ? (l + (1 - r)) / 2 : 0.5;
      img.style.transformOrigin = (cx * 100) + '% ' + (cy * 100) + '%';
      img.style.transform = 'translate(' + ((0.5 - cx) * 100) + '%, ' + ((0.5 - cy) * 100) + '%) scale(' + scale.toFixed(4) + ')';
      img.classList.add('is-autocropped');
    }

    function scan(root) {
      (root || document).querySelectorAll('.iv-ph__cell[data-ph-kind="image"] .iv-ph__img').forEach(function (img) {
        if (img.complete) analyse(img);
        else img.addEventListener('load', function () { analyse(img); }, { once: true });
      });
    }
    // Bij een variantwissel krijgt een cel een nieuwe src: analyse opnieuw.
    document.addEventListener('load', function (event) {
      var img = event.target;
      if (img && img.matches && img.matches('.iv-ph__cell[data-ph-kind="image"] .iv-ph__img')) {
        delete img.dataset.phAutocrop;
        img.style.transform = '';
        img.classList.remove('is-autocropped');
        analyse(img);
      }
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();
  (function () {
    function money(cents) {
      // Audience-aware: zakelijke klanten zien excl. btw (module herrekent).
      if (window.IVAudience) return window.IVAudience.display(cents);
      var euros = cents / 100;
      var whole = Math.floor(euros);
      var frac = Math.round((euros - whole) * 100);
      var intStr = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (frac === 0) return '€' + intStr;
      return '€' + intStr + ',' + (frac < 10 ? '0' + frac : frac);
    }

    function initSection(root) {
      if (!root || root.dataset.phInit) return;
      root.dataset.phInit = '1';

      var dataEl = root.querySelector('[data-ph-data]');
      if (!dataEl) return;
      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      var addUrl = root.getAttribute('data-add-url') || '/cart/add';
      // Tekst achter het kortingspercentage op de bundelbadge; komt als
      // sectie-setting mee in het JSON-blok (Liquid werkt niet in deze tag).
      function discountSuffix() {
        return typeof data.discountSuffix === 'string' ? data.discountSuffix : '';
      }
      var variants = data.variants || [];

      // Start op de set van de geladen variant: de servergerenderde galerij
      // (de eerste, gecureerde beelden) blijft staan tot een échte wissel.
      var huidigeMset = 0;
      for (var hms = 0; hms < variants.length; hms++) {
        if (variants[hms].id === data.selectedId) {
          huidigeMset = variants[hms].mset || 0;
          break;
        }
      }

      /* Preload van de fotoseries (Mehmet 14/08: de wissel moet instant zijn).
         Zelfde srcset + sizes als de galerij-imgs, zodat de browser exact de
         kandidaat cachet die de swap straks nodig heeft. Alle sets laden
         gestaffeld na window.load; save-data respecteren we. */
      var preloadedSets = {};
      var generalsPreloaded = false;
      function preloadMedia(m) {
        var im = new Image();
        im.sizes = '(max-width: 749px) 100vw, 440px';
        im.srcset = m.srcset;
        im.src = m.main;
        var th = new Image();
        th.src = m.thumb;
      }
      function preloadSet(key) {
        var set = data.mediaSets && data.mediaSets[key];
        if (!set || preloadedSets[key]) return;
        preloadedSets[key] = 1;
        set.forEach(preloadMedia);
        // De sfeerfoto's hangen achter élke serie, dus één keer meeladen.
        if (!generalsPreloaded && data.mediaGenerals && data.mediaGenerals.length) {
          generalsPreloaded = true;
          data.mediaGenerals.forEach(preloadMedia);
        }
      }
      if (data.mediaSets && !(navigator.connection && navigator.connection.saveData)) {
        var msetKeys = Object.keys(data.mediaSets);
        var msetIdx = 0;
        var laadVolgendeSet = function () {
          if (msetIdx >= msetKeys.length) return;
          preloadSet(msetKeys[msetIdx++]);
          setTimeout(laadVolgendeSet, 250);
        };
        var startPreload = function () {
          setTimeout(laadVolgendeSet, 800);
        };
        if (document.readyState === 'complete') startPreload();
        else window.addEventListener('load', startPreload);
      }
      var optionCount = variants.length ? variants[0].opts.length : 0;

      var state = { qty: 1, sel: [] };
      var initial = variants.filter(function (v) { return v.id === data.selectedId; })[0] || variants[0];
      if (initial) state.sel = initial.opts.slice();

      /* Kaartgroepen zonder voorselectie (Mehmet 26/08, hoofdsteun): Liquid markeert
         ze met data-ph-choose en rendert geen actieve kaart. De gerenderde variant
         draagt wel een waarde voor die optie, dus die wissen we hier uit state.sel;
         add-to-cart stuurt de bezoeker er dan eerst heen (requiredCardGroups). De
         uitvoering (Smart/Pro) houdt zijn voorselectie. */
      root.querySelectorAll('[data-ph-group] [data-ph-choose]').forEach(function (cards) {
        var groep = cards.closest('[data-ph-group]');
        if (!groep) return;
        var idx = parseInt(groep.getAttribute('data-ph-group'), 10);
        if (!isNaN(idx)) state.sel[idx] = '';
      });

      /* VOORSELECTIE VAN DE VERSIE (klantfeedback 26/08, vervangt 20/08)

         Tot vandaag werd de selectie van elke uitvoeringskaartgroep hier
         gewist, zodat de bezoeker eerst SMART of PRO moest kiezen. De klant wil
         de eerste waarde voorgeselecteerd hebben. state.sel komt uit de variant
         die Liquid rendert, en dat is sinds vandaag de EERSTE variant van het
         product (of die uit ?variant=), dus de selectie klopt al: we laten hem
         gewoon staan.

         requiredCardGroups blijft bestaan als vangnet voor de ATC-validatie,
         mocht een groep tóch zonder waarde staan (bijvoorbeeld een product
         zonder varianten in de gerenderde combinatie). De KABELGOOT houdt zijn
         validatie wel echt: die kaartgroep start bewust leeg (cardAddonChoice
         begint op null) en add-to-cart stuurt de bezoeker er eerst heen. */
      var requiredCardGroups = [];
      root.querySelectorAll('[data-ph-group][data-ph-type="cards"]').forEach(function (g) {
        if (g.querySelectorAll('[data-ph-option]').length < 2) return;
        requiredCardGroups.push({ idx: parseInt(g.getAttribute('data-ph-group'), 10), el: g });
      });

      /* Deelvariant: de goedkoopste beschikbare variant die past bij de keuzes die de
         bezoeker AL heeft gemaakt (lege keuzes tellen niet mee). Nodig zolang een
         verplichte kaartgroep nog leeg is: currentVariant() geeft dan null en zonder deze
         hulp bleef de pagina op de beginvariant staan, dus een kleurkeuze veranderde noch
         de foto noch de prijs (QA 26/08 op de Butterfly). */
      function deelVariant() {
        var kandidaten = variants.filter(function (v) {
          for (var j = 0; j < optionCount; j++) {
            if (state.sel[j] && v.opts[j] !== state.sel[j]) return false;
          }
          return true;
        });
        if (!kandidaten.length) return null;
        var beschikbaar = kandidaten.filter(function (v) { return v.avail; });
        var lijst = beschikbaar.length ? beschikbaar : kandidaten;
        return lijst.reduce(function (a, b) { return b.price < a.price ? b : a; });
      }

      function currentVariant() {
        for (var i = 0; i < variants.length; i++) {
          var match = true;
          for (var j = 0; j < optionCount; j++) {
            if (variants[i].opts[j] !== state.sel[j]) { match = false; break; }
          }
          if (match) return variants[i];
        }
        return null;
      }

      /* Vergelijkt een variant-optiewaarde met de huidige selectie op index j.
         Een nog niet gemaakte keuze (Version start leeg sinds 20/08) telt als
         wildcard: anders oogt elke maat en kleur als uitverkocht zolang er
         geen versie gekozen is. Bij een half-lege splitwaarde (" Black")
         telt alleen de kleurhelft mee. */
      function selMatches(j, optValue) {
        var s = state.sel[j];
        if (s == null || s === '') return true;
        if (s.charAt(0) === ' ') return splitsWaarde(optValue).kleur === s.slice(1);
        return optValue === s;
      }

      function variantWith(optIndex, value) {
        var exact = null;
        var fallback = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].opts[optIndex] !== value) continue;
          if (!fallback) fallback = variants[i];
          var match = true;
          for (var j = 0; j < optionCount; j++) {
            if (j === optIndex) continue;
            if (!selMatches(j, variants[i].opts[j])) { match = false; break; }
          }
          if (match) { exact = variants[i]; break; }
        }
        return exact || fallback;
      }

      function anyAvailable(optIndex, value) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].opts[optIndex] !== value) continue;
          var match = true;
          for (var j = 0; j < optionCount; j++) {
            if (j === optIndex) continue;
            if (!selMatches(j, variants[i].opts[j])) { match = false; break; }
          }
          if (match && variants[i].avail) return true;
        }
        return false;
      }

      /* Galerij zonder maximum (26/08): een andere variant kan een langere
         fotoserie hebben dan de server rendert, en de verdeling hieronder
         loopt over de CELLEN, niet over de foto's. Dan valt het overschot stil
         weg. Deze functie kloont er zo nodig cellen bij, met thumbnail en
         indicatorstreepje, zodat de drie rijtjes gelijk blijven lopen.
         Verwijderen doen we nooit: overtollige cellen krijgen display:none en
         zijn bij een langere serie meteen weer bruikbaar. */
      function zorgVoorCellen(nodig) {
        var gal = root.querySelector('[data-ph-gallery]');
        if (!gal) return;
        var fotoCellen = gal.querySelectorAll('.iv-ph__cell[data-ph-kind="image"]');
        if (fotoCellen.length >= nodig) return;
        var celSjabloon = fotoCellen[fotoCellen.length - 1];
        if (!celSjabloon) return;
        var thumbsEl = root.querySelector('[data-ph-thumbs]');
        var indEl = root.querySelector('[data-ph-indicator]');
        var thumbSjabloon = null;
        if (thumbsEl) {
          var alle = thumbsEl.querySelectorAll('[data-ph-thumb]');
          for (var t = alle.length - 1; t >= 0; t--) {
            if (alle[t].getAttribute('data-ph-thumb-kind') !== 'video') {
              thumbSjabloon = alle[t];
              break;
            }
          }
        }
        var segSjabloon = indEl ? indEl.querySelector('.iv-ph__indicator-seg') : null;
        var tekort = nodig - fotoCellen.length;
        for (var i = 0; i < tekort; i++) {
          var cel = celSjabloon.cloneNode(true);
          cel.classList.remove('is-active');
          cel.removeAttribute('data-ph-cell-index');
          cel.style.display = 'none';
          var img = cel.querySelector('img');
          if (img) {
            img.removeAttribute('srcset');
            img.removeAttribute('fetchpriority');
            img.removeAttribute('data-ph-main-image');
            img.setAttribute('loading', 'lazy');
          }
          gal.appendChild(cel);
          if (thumbsEl && thumbSjabloon) {
            var th = thumbSjabloon.cloneNode(true);
            th.classList.remove('is-active');
            th.style.display = 'none';
            var thImg = th.querySelector('img');
            if (thImg) {
              thImg.removeAttribute('srcset');
              thImg.removeAttribute('data-ph-thumb-image');
            }
            thumbsEl.appendChild(th);
          }
          if (indEl && segSjabloon) {
            var sg = segSjabloon.cloneNode(true);
            sg.classList.remove('is-active');
            sg.style.display = 'none';
            indEl.appendChild(sg);
          }
        }
        /* De thumbnailklik rekent met data-ph-thumb minus 1 als celindex. */
        if (thumbsEl) {
          thumbsEl.querySelectorAll('[data-ph-thumb]').forEach(function (th, i) {
            th.setAttribute('data-ph-thumb', i + 1);
          });
        }
      }

      /* Foto's per variant, één helper voor beide routes (Ivo 08/09): dit blok draaide
         alleen bij een volledige keuze. Bij een deelkeuze (hoofdsteun nog leeg op de
         Butterfly) wisselde render() alleen `src` van de eerste cel, en die img heeft
         een srcset, dus de browser bleef het oude beeld tonen. Nu loopt dezelfde wissel
         (fotoserie uit mediaSets, anders hoofdfoto met srcset weg, plus zoom, thumb en
         sticky) ook voor de goedkoopste passende deelvariant. */
      /* Vervang het img-element in plaats van src/srcset op het bestaande element te
         herschrijven. Een beeldvertaler die op DOM-mutaties werkt (Langify, de NL-versies
         van de tekst-afbeeldingen) ziet dan één nieuw element en vertaalt src én srcset in
         één keer. Bij herschrijven vertaalde hij alleen src en toonde de browser de
         Engelse srcset (Ivo 14/09, Butterfly na een kleurwissel). */
      function zetBron(img, src, srcset) {
        if (!img || !img.parentNode) return img;
        var nieuw = img.cloneNode(false);
        nieuw.removeAttribute('data-ly-processed');
        if (srcset) nieuw.setAttribute('srcset', srcset);
        else nieuw.removeAttribute('srcset');
        nieuw.setAttribute('src', src);
        img.parentNode.replaceChild(nieuw, img);
        return nieuw;
      }

      function wisselMedia(variant) {
        /* Galerij per variant-combinatie (Mehmet 14/08): heeft de gekozen
           variant (kleur x frame) een eigen fotoserie in mediaSets, wissel
           dan álle cellen + thumbs + zoom-bronnen; series korter dan de
           galerij verbergen de overtollige cellen. Anders de oude
           hoofdfoto-swap als vangnet. */
        var mediaSet = null;
        if (variant.mset && data.mediaSets) {
          var kandidaat = data.mediaSets[String(variant.mset)];
          /* Eén foto in de eigen serie (Butterfly: één foto per variant, Mehmet 08/09):
             de variantfoto's van dezelfde kleur erachter ("msib", mediavolgorde), zodat
             een kleurkeuze álle foto's van die kleur toont. Series langer dan één foto
             (Toka, Echo, Doko) veranderen niet. Zelfde regel als de startgalerij in Liquid. */
          if (kandidaat && kandidaat.length === 1 && variant.msib && variant.msib.length) {
            variant.msib.forEach(function (k) { kandidaat = kandidaat.concat(data.mediaSets[String(k)] || []); });
          }
          if (kandidaat && kandidaat.length) {
            /* Sfeerfoto's achter de serie (merchant 18/08): media vóór de
               eerste variantfoto gelden voor élke variant, zoals hun
               StarApps-app ze ook achteraan hing.
               Geen cap meer (26/08); zorgVoorCellen() maakt zo nodig extra
               cellen aan zodat een langere serie niet wordt afgekapt. */
            mediaSet = kandidaat.concat(data.mediaGenerals || []);
            if (variant.mset !== huidigeMset) {
              huidigeMset = variant.mset;
              preloadSet(String(variant.mset));
              /* Video-cellen staan vast (Ivo 18/08): de wissel vult alleen de
                 fotocellen, in volgorde. Zonder deze splitsing zou de video
                 per kleurkeuze van plek verspringen en opnieuw moeten laden.
                 De thumbnails en de indicatorstreepjes volgen dezelfde
                 indexen, dus die blijven één op één met de cellen lopen. */
              zorgVoorCellen(mediaSet.filter(function (m) { return !m.vid; }).length);
              var alleCellen = root.querySelectorAll('[data-ph-gallery] .iv-ph__cell');
              var alleThumbs = root.querySelectorAll('[data-ph-thumbs] .iv-ph__thumb');
              var alleSegs = root.querySelectorAll('[data-ph-indicator] .iv-ph__indicator-seg');
              var fotoIdx = [];
              alleCellen.forEach(function (cell, i) {
                if ((cell.getAttribute('data-ph-kind') || 'image') === 'image') fotoIdx.push(i);
              });
              var fotoSet = mediaSet.filter(function (m) { return !m.vid; });
              fotoIdx.forEach(function (celIndex, j) {
                var m = fotoSet[j];
                var cell = alleCellen[celIndex];
                cell.style.display = m ? '' : 'none';
                if (alleThumbs[celIndex]) alleThumbs[celIndex].style.display = m ? '' : 'none';
                if (alleSegs[celIndex]) alleSegs[celIndex].style.display = m ? '' : 'none';
                if (!m) return;
                var cellImg = cell.querySelector('img');
                if (cellImg) zetBron(cellImg, m.main, m.srcset);
                cell.setAttribute('data-ph-zoom-src', m.zoom);
                var t = alleThumbs[celIndex] ? alleThumbs[celIndex].querySelector('img') : null;
                if (t) zetBron(t, m.thumb, null);
              });
              var galleryEl = root.querySelector('[data-ph-gallery]');
              if (galleryEl) galleryEl.scrollTo({ left: 0 });
            }
          }
        }
        if (!mediaSet && variant.img) {
          var mainImg = root.querySelector('[data-ph-main-image]');
          if (mainImg && mainImg.src !== variant.img) {
            var mainCell = mainImg.closest('[data-ph-zoom-open]');
            zetBron(mainImg, variant.img, null);
            if (mainCell) {
              /* De zoom volgde de variantwissel niet en toonde het oude beeld
                 groot (Mehmet 14/08). */
              mainCell.setAttribute('data-ph-zoom-src', variant.img.replace(/width=900/, 'width=1800'));
            }
          }
        }
        if (variant.img) {
          var thumbImg = root.querySelector('[data-ph-thumb-image]');
          if (thumbImg && variant.thumb && !mediaSet) {
            zetBron(thumbImg, variant.thumb, null);
          }
          var stickyImg = root.querySelector('[data-ph-sticky-image]');
          if (stickyImg) {
            zetBron(stickyImg, variant.img, null);
          }
        }
      }

      function render() {
        var variant = currentVariant();
        /* Nog niet alles gekozen: toon dan wél de foto en de prijs van de goedkoopste
           passende variant, in plaats van de pagina op de beginvariant te laten staan. De
           add-to-cart-validatie blijft ongemoeid: kiezen blijft verplicht. */
        var toonVariant = variant || deelVariant();

        /* Klarna-poort staat vóór de variant-tak: zolang een verplichte keuzekaartgroep
           leeg is (hoofdsteun op de Butterfly) is `variant` null en draaide de poort niet,
           waardoor het attribuut ontbrak en een Klarna-boodschap bleef staan (QA 26/08). */
        klarnaGate(variant, variant ? variantLevertijd(variant) : '');

        /* Zonder volledige keuze: prijs en hoofdfoto tóch laten meelopen met wat al gekozen
           is (QA 26/08). Alleen deze twee; knoplabel en voorraadregel blijven bij de
           volledige variant horen, want die beloven iets over een concreet artikel. */
        if (!variant && toonVariant) {
          var dv = extrasTotaal();
          var dvTotaal = toonVariant.price + dv.prijs;
          var dvBasisCap = toonVariant.cap > toonVariant.price ? toonVariant.cap : toonVariant.price;
          var dvCap = dvBasisCap + dv.compare;
          var dvPrice = root.querySelector('[data-ph-price]');
          var dvCompare = root.querySelector('[data-ph-compare]');
          if (dvPrice) { dvPrice.dataset.ivPrice = dvTotaal; dvPrice.textContent = money(dvTotaal); }
          if (dvCompare) {
            if (dvCap > dvTotaal) { dvCompare.dataset.ivPrice = dvCap; dvCompare.textContent = money(dvCap); dvCompare.hidden = false; }
            else dvCompare.hidden = true;
          }
          wisselMedia(toonVariant);
          /* Knoplabel gelijk aan de getoonde prijs: anders stond er "Add to cart - €279"
             onder een prijs van €315 (QA 26/08). Klikken blijft geblokkeerd tot de bezoeker
             de openstaande keuze maakt. */
          var dvLabel = atcWoord(toonVariant) + ' - ' + money(dvTotaal);
          var dvAtc = root.querySelector('[data-ph-atc-label]');
          var dvSticky = root.querySelector('[data-ph-sticky-atc-label]');
          if (dvAtc) dvAtc.textContent = dvLabel;
          if (dvSticky) dvSticky.textContent = dvLabel;
          /* Levertijdregel volgt de getoonde variant mee (28/08, zie zetLevertijd). */
          zetLevertijd(toonVariant);
        }

        root.querySelectorAll('[data-ph-group]').forEach(function (group) {
          var optIndex = parseInt(group.getAttribute('data-ph-group'), 10);
          var type = group.getAttribute('data-ph-type');
          var splitDeel = group.getAttribute('data-ph-split');
          var gesplitst = !!group.querySelector('[data-ph-split-part]');
          var huidig = splitsWaarde(state.sel[optIndex]);
          var valueLabel = group.querySelector('[data-ph-group-value]');
          if (valueLabel) {
            // Een gesplitste groep toont alleen zijn eigen helft in het label.
            // Zolang er niets gekozen is blijft de servertekst ("Select an
            // option") staan; die wordt bij de eerste render bewaard.
            if (!valueLabel.dataset.phPlaceholder) valueLabel.dataset.phPlaceholder = valueLabel.textContent;
            var eigenWaarde = splitDeel === 'color'
              ? huidig.kleur
              : (gesplitst && type === 'cards' ? huidig.model : state.sel[optIndex]);
            valueLabel.textContent = eigenWaarde || valueLabel.dataset.phPlaceholder;
            if (eigenWaarde) group.classList.remove('is-missing');
          }

          /* Zet de knopwaarde om naar de volledige optiewaarde, zodat
             variantWith() en anyAvailable() blijven werken zoals ze zijn: die
             kennen alleen de echte Shopify-waarden. */
          function volleWaarde(btn) {
            var deel = btn.getAttribute('data-ph-split-part');
            if (!deel) return btn.getAttribute('data-ph-value');
            var v = btn.getAttribute('data-ph-part-value');
            return deel === 'color'
              ? (huidig.model + ' ' + v).trim()
              : (v + ' ' + huidig.kleur).trim();
          }

          var groupMin = null;
          if (type === 'cards') {
            group.querySelectorAll('[data-ph-option]').forEach(function (btn) {
              var v = variantWith(optIndex, volleWaarde(btn));
              if (v && (groupMin === null || v.price < groupMin)) groupMin = v.price;
            });
          }

          group.querySelectorAll('[data-ph-option]').forEach(function (btn) {
            var value = volleWaarde(btn);
            var deel = btn.getAttribute('data-ph-split-part');
            // Bij een gesplitste knop telt alleen of zijn eigen helft gekozen is.
            var active = deel
              ? btn.getAttribute('data-ph-part-value') === (deel === 'color' ? huidig.kleur : huidig.model)
              : value === state.sel[optIndex];
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
            if (type === 'pills') {
              btn.classList.toggle('is-disabled', !anyAvailable(optIndex, value));
            }
            if (type === 'cards') {
              var priceEl = btn.querySelector('[data-ph-card-price]');
              if (priceEl) {
                var v = variantWith(optIndex, value);
                var delta = v && groupMin !== null ? v.price - groupMin : 0;
                if (delta > 0) {
                  priceEl.textContent = '+ ' + money(delta);
                  priceEl.hidden = false;
                } else {
                  priceEl.hidden = true;
                }
              }
            }
          });
        });

        var priceEl = root.querySelector('[data-ph-price]');
        var compareEl = root.querySelector('[data-ph-compare]');
        var stockEl = root.querySelector('[data-ph-stock]');
        var stockTextEl = root.querySelector('[data-ph-stock-text]');
        var atc = root.querySelector('[data-ph-atc]');
        var atcLabel = root.querySelector('[data-ph-atc-label]');
        var stickyAtc = root.querySelector('[data-ph-sticky-atc]');
        var stickyAtcLabel = root.querySelector('[data-ph-sticky-atc-label]');
        var stickySpecs = root.querySelector('[data-ph-sticky-specs]');
        var stickyNoteEl = root.querySelector('[data-ph-sticky-note]');

        if (variant) {
          /* Prijzen incl. gekozen add-ons (26/08): koos je "With cable tray",
             dan bleef hier de kale variantprijs staan terwijl de winkelwagen
             de kabelgoot wel afrekende. Zie extrasTotaal(). */
          var extra = extrasTotaal();
          var totaal = variant.price + extra.prijs;
          var basisCap = variant.cap > variant.price ? variant.cap : variant.price;
          var totaalCap = basisCap + extra.compare;
          if (priceEl) {
            priceEl.dataset.ivPrice = totaal;
            priceEl.textContent = money(totaal);
          }
          if (compareEl) {
            if (totaalCap > totaal) {
              compareEl.dataset.ivPrice = totaalCap;
              compareEl.textContent = money(totaalCap);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
          var label = variant.avail
            ? atcWoord(variant) + ' - ' + money(totaal * state.qty)
            : data.outLabel;
          if (atcLabel) atcLabel.textContent = label;
          if (stickyAtcLabel) stickyAtcLabel.textContent = label;
          if (atc) atc.disabled = !variant.avail;
          if (stickyAtc) stickyAtc.disabled = !variant.avail;
          /* Backorder-levertijd per variant (Ivo 18/08). Liquid heeft de staat
             al per variant uitgerekend en meegegeven als "back"; hier wisselt
             alleen de tekst mee. Zonder bron (backorderText leeg) verdwijnt de
             hele regel: geen termijn is beter dan een valse termijn. */
          /* Levertijd en voorraadstijl: één helper voor beide routes (28/08). */
          var levertijd = zetLevertijd(variant);
          klarnaGate(variant, levertijd);
          if (stickySpecs) stickySpecs.textContent = state.sel.filter(function (v) { return v !== 'Default Title'; }).join(' • ');

          wisselMedia(variant);
        }

        /* De add-on-rijen lopen mee met de bureaukeuze (kleur/maat) en met de
           audience-toggle, die render() opnieuw draait. */
        renderAddons();
      }

      /* Splitst "SMART Black" in model en kleur. De optie bestaat in Shopify als
         één waarde; de UI toont hem als twee keuzes (Figma pdp), dus we moeten
         heen en weer kunnen tussen die twee vormen. Het laatste woord is de
         kleur, de rest het model, precies zoals de Liquid het opsplitst. */
      function splitsWaarde(waarde) {
        if (!waarde) return { model: '', kleur: '' };
        var i = waarde.lastIndexOf(' ');
        if (i < 0) return { model: waarde, kleur: '' };
        return { model: waarde.slice(0, i), kleur: waarde.slice(i + 1) };
      }

      root.addEventListener('click', function (event) {
        var optBtn = event.target.closest('[data-ph-option]');
        if (optBtn && root.contains(optBtn)) {
          var optIndex = parseInt(optBtn.getAttribute('data-ph-option'), 10);
          var deel = optBtn.getAttribute('data-ph-split-part');
          if (deel) {
            // Combineer het aangeklikte deel met het deel dat al gekozen was.
            var huidig = splitsWaarde(state.sel[optIndex]);
            var nieuw = optBtn.getAttribute('data-ph-part-value');
            // Bij een nog niet gekozen model blijft de leidende spatie staan,
            // anders zou de kale kleurwaarde als model gelezen worden.
            state.sel[optIndex] = deel === 'color'
              ? ((huidig.model === '' ? ' ' : huidig.model + ' ') + nieuw)
              : (nieuw + ' ' + huidig.kleur).trim();
          } else {
            state.sel[optIndex] = optBtn.getAttribute('data-ph-value');
          }
          render();
        }

        var addonBtn = event.target.closest('[data-ph-addon-toggle]');
        if (addonBtn && root.contains(addonBtn)) {
          var addonRow = addonBtn.closest('[data-ph-addon]');
          if (addonRow) {
            setAddonChecked(addonRow, addonRow.classList.contains('is-unchecked'));
            render();
          }
        }

        /* Kabelgoot-kaartgroep (Figma With/Without, teruggezet 20/08) */
        var cardAddonBtn = event.target.closest('[data-ph-addon-option]');
        if (cardAddonBtn && root.contains(cardAddonBtn)) {
          cardAddonChoice = cardAddonBtn.getAttribute('data-ph-addon-option') === 'yes';
          var cardAddonGroup = cardAddonBtn.closest('[data-ph-addon-group]');
          if (cardAddonGroup) {
            cardAddonGroup.classList.remove('is-missing');
            cardAddonGroup.querySelectorAll('[data-ph-addon-option]').forEach(function (b) {
              var on = b === cardAddonBtn;
              b.classList.toggle('is-active', on);
              b.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            var cardAddonLabel = cardAddonGroup.querySelector('[data-ph-addon-value]');
            var cardAddonName = cardAddonBtn.querySelector('.iv-ph__card-name');
            if (cardAddonLabel && cardAddonName) cardAddonLabel.textContent = cardAddonName.textContent;
          }
          /* Klacht 26/08: "prijs verandert niet bij with cable tray". */
          render();
        }

        var tipBtn = event.target.closest('[data-ph-tooltip]');
        if (tipBtn && root.contains(tipBtn)) {
          var openTip = !tipBtn.classList.contains('is-open');
          root.querySelectorAll('[data-ph-tooltip].is-open').forEach(function (b) {
            b.classList.remove('is-open');
            b.setAttribute('aria-expanded', 'false');
          });
          tipBtn.classList.toggle('is-open', openTip);
          tipBtn.setAttribute('aria-expanded', openTip ? 'true' : 'false');
        }
      });

      /* Tooltip sluit via het kruisje of een klik buiten de ballon; een klik
         op de ballontekst zelf laat hem staan. */
      document.addEventListener('click', function (event) {
        if (event.target.closest('[data-ph-tooltip]')) return;
        var inTip = event.target.closest('.iv-ph__tooltip');
        if (inTip && !event.target.closest('[data-ph-tooltip-close]')) return;
        root.querySelectorAll('[data-ph-tooltip].is-open').forEach(function (b) {
          b.classList.remove('is-open');
          b.setAttribute('aria-expanded', 'false');
        });
      });

      /* ---------- Add-ons (kabelgoot, akoestiekpaneel) ----------
         Eén rij per add-on-product, elk met een eigen variantkeuze. Aanvinken
         zet dat product als extra winkelwagenregel bij dezelfde add-to-cart.

         Slimme koppeling: een select met data-ph-addon-link="color" volgt de
         framekleur van het bureau (het gedrag van 11/08; nu mét voorrang voor
         de optie die "frame" heet, anders won "Scandic Wood White" van de
         echte framekleur) en een select met link="size" volgt de gekozen
         bureaumaat (160 x 80 CM → 160 CM). Kiest de klant zélf iets in zo'n
         select, dan stopt het meelopen voor die select: de keuze blijft vrij. */
      var addonRows = Array.prototype.slice.call(root.querySelectorAll('[data-ph-addon]'));

      function addonData(row) {
        var slot = row.getAttribute('data-ph-addon');
        return (data.addons && data.addons[slot]) || null;
      }

      function setAddonChecked(row, on) {
        row.classList.toggle('is-unchecked', !on);
        var btn = row.querySelector('[data-ph-addon-toggle]');
        if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }

      /* Eerste getal uit een optiewaarde: "180 x 80 CM" en "180 CM" → "180". */
      function firstNumber(value) {
        var m = String(value || '').match(/\d+/);
        return m ? m[0] : null;
      }

      /* De bureaukeuze die bij deze add-on-select past, of null als er geen
         betrouwbare match is — dan blijft de select gewoon een dropdown. */
      function deskMatch(select, link) {
        var values = Array.prototype.map.call(select.options, function (o) { return o.value; });
        var names = data.optionNames || [];
        var order = [];
        for (var i = 0; i < state.sel.length; i++) order.push(i);
        if (link === 'color') {
          order.sort(function (a, b) {
            var fa = String(names[a] || '').toLowerCase().indexOf('frame') > -1 ? 0 : 1;
            var fb = String(names[b] || '').toLowerCase().indexOf('frame') > -1 ? 0 : 1;
            return fa - fb;
          });
        }
        for (var k = 0; k < order.length; k++) {
          var deskValue = String(state.sel[order[k]] || '');
          var last = deskValue.split(' ').pop().toLowerCase();
          if (last === 'zwart') last = 'black';
          if (last === 'wit') last = 'white';
          var deskNumber = firstNumber(deskValue);
          for (var v = 0; v < values.length; v++) {
            if (link === 'size') {
              if (deskNumber && deskNumber === firstNumber(values[v])) return values[v];
            } else {
              var cand = String(values[v]).toLowerCase();
              if (cand === deskValue.toLowerCase() || cand === last) return values[v];
            }
          }
        }
        return null;
      }

      /* De variant die bij de huidige keuzes van deze rij hoort. Opties zonder
         keuze (één waarde) beperken niets; zonder match de eerste leverbare. */
      function addonVariant(row) {
        var addon = addonData(row);
        if (!addon || !addon.variants || !addon.variants.length) return null;
        var picks = {};
        row.querySelectorAll('[data-ph-addon-opt]').forEach(function (select) {
          picks[select.getAttribute('data-ph-addon-opt')] = select.value;
        });
        var fallback = null;
        for (var i = 0; i < addon.variants.length; i++) {
          var v = addon.variants[i];
          if (!v.avail) continue;
          if (!fallback) fallback = v;
          var ok = true;
          for (var key in picks) {
            if (v.opts[parseInt(key, 10)] !== picks[key]) {
              ok = false;
              break;
            }
          }
          if (ok) return v;
        }
        return fallback;
      }

      function renderAddons() {
        if (!addonRows) return;
        addonRows.forEach(function (row) {
          row.querySelectorAll('[data-ph-addon-opt]').forEach(function (select) {
            var link = select.getAttribute('data-ph-addon-link');
            if (link && link !== 'none' && !select.dataset.phTouched) {
              var match = deskMatch(select, link);
              if (match && select.value !== match) select.value = match;
            }
            var label = select.parentNode.querySelector('[data-ph-addon-select-label]');
            if (label) label.textContent = select.value;
          });
          var variant = addonVariant(row);
          if (!variant) return;
          var priceEl = row.querySelector('[data-ph-addon-price]');
          if (priceEl) priceEl.textContent = '+ ' + money(variant.price);
          var img = row.querySelector('[data-ph-addon-image]');
          if (img && variant.img) {
            /* image_tag rendert een srcset en een browser kiest die boven src:
               zonder de srcset mee te wisselen blijft de oude foto zichtbaar. */
            img.src = variant.img;
            if (variant.img2) img.setAttribute('srcset', variant.img2 + ' 2x');
            else img.removeAttribute('srcset');
          }
        });
      }

      addonRows.forEach(function (row) {
        row.querySelectorAll('[data-ph-addon-opt]').forEach(function (select) {
          select.addEventListener('change', function () {
            select.dataset.phTouched = '1';
            /* render(), niet renderAddons(): een andere add-on-maat of -kleur
               kan een andere prijs hebben en die telt mee in de totalen. */
            render();
          });
        });
      });

      var qtyInput = root.querySelector('[data-ph-qty]');
      var qtyMinus = root.querySelector('[data-ph-qty-minus]');
      var qtyPlus = root.querySelector('[data-ph-qty-plus]');

      function setQty(q) {
        if (!q || q < 1) q = 1;
        state.qty = q;
        if (qtyInput) qtyInput.value = q;
        if (qtyMinus) qtyMinus.disabled = q <= 1;
        render();
      }

      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          setQty(parseInt(qtyInput.value, 10));
        });
        qtyInput.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            qtyInput.blur();
          }
        });
      }
      if (qtyMinus) {
        qtyMinus.addEventListener('click', function () {
          setQty(state.qty - 1);
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', function () {
          setQty(state.qty + 1);
        });
      }

      function openCartDrawer() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var proxy = root.querySelector('[data-ph-drawer-proxy]');
        if (proxy) proxy.click();
      }

      function addItems(items, button) {
        if (!items.length) return;
        if (button) {
          if (button.dataset.phAdding) return; /* dubbelklik tijdens de keten */
          button.dataset.phAdding = '1';
          button.classList.add('is-busy');
        }
        /* Shopify's botfilter geeft op cart-calls soms een 429-challenge met
           HTML als antwoord (gemeten 02/09: klanten strandden in de
           samensteller omdat EEN challenge de hele toevoeging brak, terwijl
           dezelfde call seconden later gewoon slaagt). Daarom twee stille
           herkansingen met korte pauze; alleen een echte weigering (422,
           bv. uitverkocht) of drie mislukkingen toont de foutmelding. */
        var pogingen = 0;
        function klaar() {
          if (button) {
            delete button.dataset.phAdding;
            button.classList.remove('is-busy');
          }
        }
        function toonFout() {
          if (!button) return;
          var lbl = button.querySelector('[data-ph-atc-label], [data-ph-sticky-atc-label]') || button;
          var old = lbl.textContent;
          lbl.textContent = button.getAttribute('data-label-error') || 'Something went wrong, please try again';
          button.classList.add('is-error');
          window.setTimeout(function () {
            lbl.textContent = old;
            button.classList.remove('is-error');
          }, 3000);
        }
        function poging() {
          pogingen += 1;
          fetch(addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items }),
          })
            .then(function (response) {
              if (!response.ok) {
                var fout = new Error('add failed');
                fout.status = response.status;
                throw fout;
              }
              return response.json();
            })
            .then(function () {
              openCartDrawer();
              klaar();
            })
            .catch(function (fout) {
              if (pogingen < 3 && (!fout || fout.status !== 422)) {
                window.setTimeout(poging, pogingen === 1 ? 1200 : 2800);
                return;
              }
              toonFout();
              klaar();
            });
        }
        poging();
      }

      /* ---------- Kabelgoot-kaartgroep (Figma With/Without, teruggezet 20/08) ---------- */
      var cardAddonChoice = null; // null = nog niets gekozen, true = met, false = zonder

      /* Kiest de kabelgoot-variant die qua kleur bij het gekozen frame past:
         de framekleur is het laatste woord van een optiewaarde (SMART Black)
         of een losse kleurwaarde. Geen kleurmatch = eerste beschikbare. */
      function cardAddonVariant() {
        var addon = data.addon;
        if (!addon || !addon.variants || !addon.variants.length) return null;
        var frameColor = null;
        for (var i = 0; i < state.sel.length; i++) {
          var last = String(state.sel[i] || '').split(' ').pop().toLowerCase();
          if (last === 'zwart') last = 'black';
          if (last === 'wit') last = 'white';
          if (last === 'black' || last === 'white') { frameColor = last; break; }
        }
        var pick = null;
        for (var j = 0; j < addon.variants.length; j++) {
          var av = addon.variants[j];
          if (!av.avail) continue;
          if (!pick) pick = av;
          if (frameColor && av.opts.join(' ').toLowerCase().indexOf(frameColor) > -1) return av;
        }
        return pick;
      }

      /* Wat de gekozen add-ons bovenop de variantprijs leggen (26/08).
         Dezelfde twee bronnen die handleAtc() aan de winkelwagen toevoegt,
         zodat weergave en cart niet uit elkaar lopen. `compare` telt een
         add-on zonder eigen vanaf-prijs voor zijn gewone prijs mee. */
      function extrasTotaal() {
        var uit = { prijs: 0, compare: 0 };
        function tel(v) {
          if (!v) return;
          uit.prijs += v.price;
          uit.compare += v.cap > v.price ? v.cap : v.price;
        }
        if (cardAddonChoice === true) tel(cardAddonVariant());
        (addonRows || []).forEach(function (row) {
          if (row.classList.contains('is-unchecked')) return;
          tel(addonVariant(row));
        });
        return uit;
      }

      /* LEVERTIJDREGEL PER VARIANT, op alle plekken tegelijk (26/08, helper 28/08).
         Backorder (Liquid gaf "back" mee) met eigen backorder-tekst wint; zonder die
         tekst de gewone belofte van de variant (dp) of het product (stockText); leeg =
         regel weg (geen termijn is beter dan een valse). Uitverkocht = de
         uitverkocht-tekst. Geeft de levertijd terug voor de Klarna-poort.
         Sinds 28/08 ook in de "nog niet alles gekozen"-route: met levertijd per kleur
         (Butterfly, backorderkleuren 2-4 weken) bleef anders de regel van de vorige
         kleur staan naast een knop die al "Add to cart" of "Preorder" zei. */
      function zetLevertijd(variant) {
        var stockEl = root.querySelector('[data-ph-stock]');
        var stockTextEl = root.querySelector('[data-ph-stock-text]');
        var stickyNoteEl = root.querySelector('[data-ph-sticky-note]');
        var opBackorder = variant.avail && variant.back === true;
        var backTekst = typeof data.backorderText === 'string' ? data.backorderText : '';
        var backGetoond = opBackorder && backTekst !== '';
        var levertijd = backGetoond ? backTekst : variantLevertijd(variant);
        var regelWeg = levertijd === '';
        if (stockEl) {
          stockEl.classList.toggle('is-out', !variant.avail);
          stockEl.classList.toggle('is-backorder', backGetoond);
          stockEl.hidden = regelWeg;
        }
        if (stockTextEl) {
          if (!variant.avail) stockTextEl.textContent = data.stockOutText;
          else stockTextEl.textContent = levertijd;
        }
        root.querySelectorAll('[data-ph-delivery]').forEach(function (el) {
          el.textContent = levertijd;
        });
        /* Geen leveringsbelofte naast "Temporarily sold out". */
        root.querySelectorAll('.iv-ph__assurances [data-ph-delivery]').forEach(function (el) {
          var li = el.closest('li');
          if (li) li.hidden = !variant.avail || regelWeg;
        });
        /* Meeloopbalk: alleen de levertijdregel; volgt de beschikbaarheid. */
        if (stickyNoteEl) stickyNoteEl.hidden = !variant.avail || regelWeg;
        return levertijd;
      }

      /* Knopwoord per variant (28/08): op backorder de Preorder-knoptekst, anders
         de winkelwagen-tekst. Zelfde regel als ph_atc_word in Liquid. */
      function atcWoord(v) {
        var pre = typeof data.preorderLabel === 'string' ? data.preorderLabel.trim() : '';
        /* Alleen met gevuld variantveld ("dp"), zie ph_atc_word in Liquid. */
        var eigenLevertijd = v && typeof v.dp === 'string' ? v.dp.trim() : '';
        if (v && v.avail && v.back === true && eigenLevertijd && pre) return pre;
        return data.atcLabel;
      }

      /* Variantmetaveld custom.delivery_promise ("dp"), anders "stockText". */
      function variantLevertijd(v) {
        var eigen = v && typeof v.dp === 'string' ? v.dp.trim() : '';
        if (eigen) return eigen;
        return typeof data.stockText === 'string' ? data.stockText : '';
      }

      /* KLARNA-MESSAGING VERBERGEN (klantfeedback 26/08)

         De Klarna-boodschap op de pdp komt NIET uit dit theme maar uit de
         app-embed van Klarna (script #klarna-osm-script-tag, web-sdk), die zelf
         een <klarna-placement> in de pagina zet. Wij bepalen dus niet of hij
         bestaat, alleen of hij zichtbaar is.

         Drie regels:
         - de gekozen variant is niet te kopen (availability 0);
         - de variant staat op backorder. Shopify meldt zo'n variant als
           `available`, maar de voorraad is 0 en er is doorverkoop aangezet:
           in de termen van de klant is dat óók availability 0, en het is per
           definitie het geval "duurt langer dan vijf dagen". Zonder deze regel
           zou juist het artikel met de langste levertijd Klarna wél tonen,
           want een backordervariant heeft vaak helemaal geen termijntekst;
         - de levertijd is langer dan het aantal werkdagen bij "Klarna
           verbergen vanaf", afgeleid uit de levertijdTEKST: het grootste getal
           erin ("2-4 working days" -> 4, "14 days" -> 14). Staat er geen getal
           in de tekst, dan blijft die derde regel buiten werking.

         Uitvoering via een attribuut op <html> plus een CSS-regel in
         assets/iv-product-hero.css. Dat werkt ook als de embed pas later
         injecteert, want CSS geldt net zo goed voor knopen die daarna
         binnenkomen; een MutationObserver is daarvoor niet nodig. Verbergen
         doen we met display:none en niet met remove(): de app-bundle heeft een
         watchForRemoval() die een verwijderde placement terugzet. Een verborgen
         placement laadt en initialiseert gewoon door en staat na un-hide meteen
         goed, dus we breken niets in de app. */
      function grootsteGetal(tekst) {
        var m = String(tekst || '').match(/\d+/g);
        return m ? Math.max.apply(null, m.map(Number)) : null;
      }

      /* Zolang een verplichte keuzekaartgroep nog leeg is (hoofdsteun op de Butterfly)
         geeft currentVariant() null, en dan draaide deze poort helemaal niet: het attribuut
         ontbrak en een Klarna-boodschap bleef staan, ook bij een backordervariant (QA 26/08).
         Zonder gekozen variant nemen we daarom de strengste variant van het product: is er
         één regel die Klarna zou verbergen, dan verbergen we hem tot de bezoeker kiest. */
      function klarnaGate(variant, levertijd) {
        var max = typeof data.klarnaMaxDagen === 'number' ? data.klarnaMaxDagen : 0;
        var weg;
        if (variant) {
          var dagen = grootsteGetal(levertijd);
          weg = !variant.avail || variant.back === true || (max > 0 && dagen !== null && dagen > max);
        } else {
          weg = variants.some(function (v) {
            var d = grootsteGetal(variantLevertijd(v));
            return !v.avail || v.back === true || (max > 0 && d !== null && d > max);
          });
        }
        document.documentElement.setAttribute('data-iv-klarna', weg ? 'hide' : 'show');
      }

      /* Add-to-cart alleen na een expliciete keuze (Mehmet 20/08): eerst de
         version-/uitvoeringskaarten, dan de kabelgoot-kaartgroep. De knop
         blijft klikbaar; een klik zonder keuze scrolt naar de ontbrekende
         groep en markeert hem. */
      function ontbrekendeKeuze() {
        for (var i = 0; i < requiredCardGroups.length; i++) {
          var g = requiredCardGroups[i];
          var gekozen = g.el.querySelector('[data-ph-split-part]')
            ? splitsWaarde(state.sel[g.idx]).model !== ''
            : !!state.sel[g.idx];
          if (!gekozen) return g.el;
        }
        var kabelGroep = root.querySelector('[data-ph-addon-group]');
        if (kabelGroep && cardAddonChoice === null) return kabelGroep;
        return null;
      }

      function markeerKeuze(el) {
        el.classList.add('is-missing');
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      function handleAtc(button) {
        var missend = ontbrekendeKeuze();
        if (missend) { markeerKeuze(missend); return; }
        var variant = currentVariant();
        if (!variant || !variant.avail) return;
        var items = [{ id: variant.id, quantity: state.qty }];
        addonRows.forEach(function (row) {
          if (row.classList.contains('is-unchecked')) return;
          var av = addonVariant(row);
          if (av) items.push({ id: av.id, quantity: state.qty });
        });
        if (cardAddonChoice === true) {
          var cav = cardAddonVariant();
          if (cav) items.push({ id: cav.id, quantity: state.qty });
        }
        addItems(items, button);
      }

      var atcBtn = root.querySelector('[data-ph-atc]');
      if (atcBtn) atcBtn.addEventListener('click', function () { handleAtc(atcBtn); });
      var stickyAtcBtn = root.querySelector('[data-ph-sticky-atc]');
      if (stickyAtcBtn) stickyAtcBtn.addEventListener('click', function () { handleAtc(stickyAtcBtn); });

      /* ---------- Sticky bar ---------- */
      var sticky = root.querySelector('[data-ph-sticky]');
      if (sticky && atcBtn) {
        /* Tonen zodra de ATC naar bóven uit beeld is gescrold — niet wanneer hij
           nog onder de fold ligt (mobiele page-load). */
        var applySticky = function (show) {
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        };
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              var entry = entries[entries.length - 1];
              applySticky(entry.boundingClientRect.bottom < 0);
            },
            { threshold: 0 }
          );
          observer.observe(atcBtn);
        }
        /* Vangnet voor sprongen die het viewport overslaan (anchor/instant
           scroll): dan wisselt de intersectie-state niet en vuurt de observer
           niet — de scroll-check houdt de balk dan alsnog in sync. */
        var stickyRaf = null;
        window.addEventListener(
          'scroll',
          function () {
            if (stickyRaf) return;
            stickyRaf = requestAnimationFrame(function () {
              stickyRaf = null;
              applySticky(atcBtn.getBoundingClientRect().bottom < 0);
            });
          },
          { passive: true }
        );
      }

      /* ---------- Mobiele galerij ---------- */
      var gallery = root.querySelector('[data-ph-gallery]');
      var indicator = root.querySelector('[data-ph-indicator]');
      var thumbs = root.querySelector('[data-ph-thumbs]');

      function setGalleryIndex(index) {
        if (indicator) {
          indicator.querySelectorAll('.iv-ph__indicator-seg').forEach(function (seg, i) {
            seg.classList.toggle('is-active', i === index);
          });
        }
        if (thumbs) {
          thumbs.querySelectorAll('[data-ph-thumb]').forEach(function (thumb, i) {
            thumb.classList.toggle('is-active', i === index);
          });
        }
      }

      if (gallery) {
        var scrollRaf = null;
        gallery.addEventListener('scroll', function () {
          if (scrollRaf) return;
          scrollRaf = requestAnimationFrame(function () {
            scrollRaf = null;
            var width = gallery.clientWidth;
            if (width > 0) setGalleryIndex(Math.round(gallery.scrollLeft / width));
          });
        });
      }

      if (thumbs && gallery) {
        thumbs.addEventListener('click', function (event) {
          var thumb = event.target.closest('[data-ph-thumb]');
          if (!thumb) return;
          var index = parseInt(thumb.getAttribute('data-ph-thumb'), 10) - 1;
          gallery.scrollTo({ left: index * gallery.clientWidth, behavior: 'smooth' });
          setGalleryIndex(index);
        });
      }

      /* ---------- Video-cellen in de galerij (klantpunt Ivo 18/08) ----------
         Een geüploade productvideo speelt gedempt en inline zodra zijn cel voor
         de helft in beeld staat, en pauzeert zodra hij eruit loopt: anders
         draait op mobiel de hele carrousel mee te spelen en blijft een video
         onderaan de pagina onzichtbaar rondgaan.

         Twee dingen die de speler NIET mag overrulen:
         - prefers-reduced-motion: dan start hij nooit vanzelf. Het
           voorbeeldbeeld (poster) blijft staan en de bezoeker drukt zelf op
           play in de ingebouwde bediening.
         - een handmatige pauze. Zet de bezoeker de video stil, dan houdt hij
           hem stil, ook als je er nog eens langs scrollt. Het onderscheid
           tussen "ik pauzeer" en "de waarnemer pauzeert" loopt via phAuto,
           want beide vuren hetzelfde pause-event af. */
      var galerijVideos = root.querySelectorAll('[data-ph-gallery] [data-ph-video]');
      if (galerijVideos.length && 'IntersectionObserver' in window) {
        var minderBeweging = window.matchMedia('(prefers-reduced-motion: reduce)');
        var videoWaarnemer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var v = entry.target;
              if (entry.isIntersecting) {
                if (minderBeweging.matches) return;
                if (v.dataset.phStil === '1') return;
                var poging = v.play();
                if (poging && poging.catch) poging.catch(function () {});
              } else if (!v.paused) {
                v.dataset.phAuto = '1';
                v.pause();
              }
            });
          },
          { threshold: 0.5 }
        );
        galerijVideos.forEach(function (v) {
          var cel = v.closest('.iv-ph__cell');
          v.addEventListener('pause', function () {
            if (cel) cel.classList.remove('is-playing');
            if (v.dataset.phAuto === '1') {
              v.dataset.phAuto = '';
              return;
            }
            v.dataset.phStil = '1';
          });
          v.addEventListener('play', function () {
            if (cel) cel.classList.add('is-playing');
            v.dataset.phStil = '';
          });
        });
        /* Pas waarnemen ná window.load. De video-cel staat op de meeste pdp's
           al bij het openen half in beeld, dus zonder deze vertraging begint
           een mp4 van 7 Mbit/s te downloaden terwijl de LCP-foto nog binnenkomt.
           Zelfde afweging als de fotoserie-preload hierboven. */
        var startWaarnemen = function () {
          galerijVideos.forEach(function (v) {
            videoWaarnemer.observe(v);
          });
        };
        if (document.readyState === 'complete') startWaarnemen();
        else window.addEventListener('load', startWaarnemen);
      }

      /* De ronde knop op een video-cel zet hem aan of uit. Zonder
         IntersectionObserver (of met prefers-reduced-motion) is dit de enige
         manier om het fragment te starten, dus hij hangt buiten het blok
         hierboven. */
      if (gallery) {
        gallery.addEventListener('click', function (event) {
          var knop = event.target.closest('[data-ph-video-toggle]');
          if (!knop) return;
          var v = knop.closest('.iv-ph__cell').querySelector('[data-ph-video]');
          if (!v) return;
          if (v.paused) {
            var poging = v.play();
            if (poging && poging.catch) poging.catch(function () {});
          } else {
            v.pause();
          }
        });
      }

      /* YouTube/Vimeo: pas op een klik laden we de iframe van de derde partij. */
      if (gallery) {
        gallery.addEventListener('click', function (event) {
          var knop = event.target.closest('[data-ph-embed-play]');
          if (!knop) return;
          var cell = knop.closest('[data-ph-embed]');
          if (!cell || cell.querySelector('iframe')) return;
          var src = cell.getAttribute('data-ph-embed');
          if (!src) return;
          var frame = document.createElement('iframe');
          frame.className = 'iv-ph__cell-frame';
          frame.src = src;
          frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          frame.setAttribute('allowfullscreen', '');
          frame.setAttribute('title', knop.getAttribute('aria-label') || 'Video');
          cell.append(frame);
          cell.classList.add('is-playing');
        });
      }

      /* ---------- Bundle ---------- */
      var bundleRoot = root.querySelector('[data-ph-bundle]');
      if (bundleRoot) {
        var bundleData = data.bundle || [];
        var bundleState = [];
        bundleRoot.querySelectorAll('[data-ph-bundle-item]').forEach(function (item, i) {
          var info = bundleData[i] || { colorPos: -1, variants: [] };
          var variant = info.variants.filter(function (v) { return v.avail; })[0] || info.variants[0] || null;
          bundleState.push({
            checked: !item.classList.contains('is-unchecked'),
            variant: variant,
            info: info,
          });
        });

        function renderBundle() {
          var total = 0;
          var compare = 0;
          bundleRoot.querySelectorAll('[data-ph-bundle-item]').forEach(function (item, i) {
            var entry = bundleState[i];
            item.classList.toggle('is-unchecked', !entry.checked);
            var toggle = item.querySelector('[data-ph-bundle-toggle]');
            if (toggle) toggle.setAttribute('aria-pressed', entry.checked ? 'true' : 'false');
            if (!entry.variant) return;
            var priceEl = item.querySelector('[data-ph-bundle-price]');
            var compareEl = item.querySelector('[data-ph-bundle-compare]');
            if (priceEl) {
              priceEl.dataset.ivPrice = entry.variant.price;
              priceEl.textContent = money(entry.variant.price);
            }
            if (compareEl) {
              if (entry.variant.cap > entry.variant.price) {
                compareEl.dataset.ivPrice = entry.variant.cap;
                compareEl.textContent = money(entry.variant.cap);
                compareEl.hidden = false;
              } else {
                compareEl.hidden = true;
              }
            }
            if (entry.checked) {
              total += entry.variant.price;
              compare += entry.variant.cap > entry.variant.price ? entry.variant.cap : entry.variant.price;
            }
          });
          var totalEl = bundleRoot.querySelector('[data-ph-bundle-total]');
          var totalCompareEl = bundleRoot.querySelector('[data-ph-bundle-total-compare]');
          var badgeEl = bundleRoot.querySelector('[data-ph-bundle-badge]');
          /* Het bundeltotaal toont uitsluitend korting die de checkout ook echt
             afrekent: de som van de verkoopprijzen tegenover de som van de
             compare-at-prijzen. Een theme kan geen korting afdwingen, de
             add-to-cart hieronder is een gewone /cart/add en Shopify rekent
             server-side de volle variantprijzen.

             Hier stond tot 19/08 een tweede tak op metafield
             custom.bundle_discount. Die streepte de ACTUELE verkoopprijs door en
             trok er een vast percentage vanaf. Gemeten op toka-desk-pro en
             echo-desk (de enige twee met dat veld, waarde 10.0 uit de seed van
             31/07): de pagina beloofde 182,70 euro, /cart.js gaf total_price
             20300 en total_discount 0. Een gat van 20,30 euro, oplopend tot
             55,20 euro met alle vier de items aangevinkt. Die tak is verwijderd;
             het metafield stuurt niets meer aan. Wil IVONO een echte
             bundelkorting, dan hoort die uit een Shopify Function of een
             automatische korting te komen, niet uit een rekensom in de
             storefront. */
          if (totalEl) totalEl.textContent = money(total);
          if (totalCompareEl) {
            totalCompareEl.textContent = compare > total ? money(compare) : '';
            totalCompareEl.hidden = compare <= total;
          }
          if (badgeEl) {
            var pct = compare > 0 ? Math.round((1 - total / compare) * 100) : 0;
            badgeEl.textContent = pct + discountSuffix();
            badgeEl.hidden = pct <= 0;
          }
          var bundleAtc = bundleRoot.querySelector('[data-ph-bundle-atc]');
          if (bundleAtc) bundleAtc.disabled = total === 0;
        }

        bundleRoot.addEventListener('click', function (event) {
          var toggle = event.target.closest('[data-ph-bundle-toggle]');
          if (!toggle) return;
          var item = toggle.closest('[data-ph-bundle-item]');
          var index = parseInt(item.getAttribute('data-ph-bundle-index'), 10);
          bundleState[index].checked = !bundleState[index].checked;
          renderBundle();
        });

        bundleRoot.addEventListener('change', function (event) {
          var select = event.target.closest('[data-ph-bundle-color]');
          if (!select) return;
          var item = select.closest('[data-ph-bundle-item]');
          var index = parseInt(item.getAttribute('data-ph-bundle-index'), 10);
          var entry = bundleState[index];
          var pos = entry.info.colorPos;
          var chosen = select.value;
          var next = null;
          for (var i = 0; i < entry.info.variants.length; i++) {
            var v = entry.info.variants[i];
            if (v.opts[pos] === chosen && (v.avail || !next)) {
              if (!next || v.avail) next = v;
              if (v.avail) break;
            }
          }
          if (next) {
            entry.variant = next;
            var label = item.querySelector('[data-ph-bundle-color-label]');
            if (label) label.textContent = chosen;
            var img = item.querySelector('[data-ph-bundle-image]');
            if (img && next.img) { img.src = next.img; img.removeAttribute('srcset'); }
            var swatch = item.querySelector('[data-ph-bundle-swatch]');
            if (swatch && next.swatch) { swatch.innerHTML = next.swatch; }
          }
          renderBundle();
        });

        var bundleAtcBtn = bundleRoot.querySelector('[data-ph-bundle-atc]');
        if (bundleAtcBtn) {
          bundleAtcBtn.addEventListener('click', function () {
            var items = [];
            bundleState.forEach(function (entry) {
              if (entry.checked && entry.variant && entry.variant.avail) {
                items.push({ id: entry.variant.id, quantity: 1 });
              }
            });
            addItems(items, bundleAtcBtn);
          });
        }

        renderBundle();
      }

      /* ---------- Flyouts ---------- */
      var overlay = root.querySelector('[data-ph-flyout-overlay]');

      function closeFlyouts() {
        var open = false;
        root.querySelectorAll('[data-ph-flyout]').forEach(function (panel) {
          if (panel.classList.contains('is-open')) open = true;
          panel.classList.remove('is-open');
        });
        if (overlay) overlay.classList.remove('is-open');
        if (open) document.documentElement.style.overflow = '';
      }

      function openFlyout(key) {
        var panel = root.querySelector('[data-ph-flyout="' + key + '"]');
        if (!panel) return;
        root.querySelectorAll('[data-ph-flyout]').forEach(function (p) {
          p.classList.toggle('is-open', p === panel);
        });
        if (overlay) overlay.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        panel.focus({ preventScroll: true });
      }

      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-iv-flyout-open]');
        if (opener) {
          event.preventDefault();
          openFlyout(opener.getAttribute('data-iv-flyout-open'));
          return;
        }
        if (event.target.closest('[data-ph-flyout-close]')) {
          closeFlyouts();
          return;
        }
        if (overlay && event.target === overlay) {
          closeFlyouts();
        }
      });

      /* Site-breed contract: andere secties (bv. iv-product-specs) openen een
         flyout via een globaal event met detail.flyout. */
      document.addEventListener('iv:flyout:open', function (event) {
        var key = event.detail && event.detail.flyout;
        if (key) openFlyout(key);
      });

      /* ---------- Zoom ---------- */
      var zoom = root.querySelector('[data-ph-zoom]');
      var zoomPrev = zoom && zoom.querySelector('[data-ph-zoom-prev]');
      var zoomNext = zoom && zoom.querySelector('[data-ph-zoom-next]');
      /* De galerijcel waaruit de overlay is geopend; null bij een werktekening
         (dan geen pijlen en geen vegen naar een volgende foto). */
      var zoomCel = null;
      /* Eigen zoomstand (Ivo 21/09): schaal plus verschuiving, zodat knijpen en
         slepen in de overlay blijven en de browser er geen paginazoom of
         terug-veeg van maakt (op mobiel belandden bezoekers zo soms op een
         foutpagina van de browser). */
      var zs = 1, ztx = 0, zty = 0;
      var zoomGebaarTot = 0;

      function zoomBeeld() { return zoom ? zoom.querySelector('img') : null; }

      function zetZoom(metAnimatie) {
        var img = zoomBeeld();
        if (!img) return;
        var maxX = (img.offsetWidth * (zs - 1)) / 2;
        var maxY = (img.offsetHeight * (zs - 1)) / 2;
        ztx = Math.max(-maxX, Math.min(maxX, ztx));
        zty = Math.max(-maxY, Math.min(maxY, zty));
        img.classList.toggle('is-dragging', !metAnimatie);
        img.classList.toggle('is-zoomed', zs > 1);
        img.style.transformOrigin = '';
        img.style.transform = zs > 1 ? 'translate(' + ztx + 'px,' + zty + 'px) scale(' + zs + ')' : '';
      }

      function resetZoom() { zs = 1; ztx = 0; zty = 0; zetZoom(true); }

      function zoomCellen() {
        return Array.prototype.filter.call(
          root.querySelectorAll('[data-ph-gallery] .iv-ph__cell'),
          function (cel) {
            if (cel.style.display === 'none') return false;
            var soort = cel.getAttribute('data-ph-kind') || 'image';
            if (soort === 'video') return !!cel.querySelector('video');
            if (soort === 'external') return !!cel.getAttribute('data-ph-embed');
            return !!cel.getAttribute('data-ph-zoom-src');
          }
        );
      }

      function zoomPijlen() {
        var tonen = !!zoomCel && zoomCellen().length > 1;
        if (zoomPrev) zoomPrev.hidden = !tonen;
        if (zoomNext) zoomNext.hidden = !tonen;
        zoomPijlPlek();
      }

      /* De pijlen staan binnen het beeld: de beeldrand (niet ingezoomd) als CSS-variabele */
      function zoomPijlPlek() {
        var img = zoomBeeld();
        if (zoomMedia && !zoomMedia.hidden && zoomMedia.firstElementChild) img = zoomMedia.firstElementChild;
        if (!img || !zoom.classList.contains('is-open') || zs > 1) return;
        var r = img.getBoundingClientRect(), o = zoom.getBoundingClientRect();
        if (!r.width) return;
        zoom.style.setProperty('--ph-zoom-l', (r.left - o.left) + 'px');
        zoom.style.setProperty('--ph-zoom-r', (r.right - o.left) + 'px');
      }

      var zoomMedia = zoom && zoom.querySelector('[data-ph-zoom-media]');

      /* Video in de overlay (Ivo 21/09): een videocel toont de video groot, gedempt in
         een lus en zonder knoppen, net als in de galerij; een YouTube/Vimeo-cel zijn
         embed. De foto verdwijnt zolang. De galerijvideo blijft ongemoeid: pauzeren
         zou hij als "bezoeker pauzeerde" onthouden en dan staat er een afspeelknop. */
      function zoomMediaMaat() {
        if (!zoomMedia || zoomMedia.hidden) return;
        var el = zoomMedia.firstElementChild;
        if (!el) return;
        var verhouding = parseFloat(el.getAttribute('data-verhouding')) || 1;
        var maxB = Math.min(1200, zoom.clientWidth - 64);
        var maxH = zoom.clientHeight - 64;
        var b = maxB, h = b / verhouding;
        if (h > maxH) { h = maxH; b = h * verhouding; }
        el.style.width = Math.round(b) + 'px';
        el.style.height = Math.round(h) + 'px';
      }

      function zoomToonMedia(cel) {
        var img = zoomBeeld();
        if (!zoomMedia) return false;
        zoomMedia.innerHTML = '';
        var soort = cel ? cel.getAttribute('data-ph-kind') : '';
        if (soort !== 'video' && soort !== 'external') {
          zoomMedia.hidden = true;
          if (img) img.hidden = false;
          return false;
        }
        var el;
        if (soort === 'video') {
          var bron = cel.querySelector('video');
          var bronSrc = bron ? bron.currentSrc : '';
          if (bron && !bronSrc) {
            var mp4 = bron.querySelector('source[type="video/mp4"]') || bron.querySelector('source');
            bronSrc = mp4 ? mp4.src : '';
          }
          if (!bronSrc) return false;
          el = document.createElement('video');
          el.className = 'iv-ph-zoom__video';
          el.muted = true;
          el.defaultMuted = true;
          el.loop = true;
          el.autoplay = true;
          el.controls = false;
          el.setAttribute('muted', '');
          el.setAttribute('playsinline', '');
          el.setAttribute('disablepictureinpicture', '');
          if (bron.poster) el.poster = bron.poster;
          el.setAttribute('data-verhouding', bron.videoWidth && bron.videoHeight ? bron.videoWidth / bron.videoHeight : 1);
          el.addEventListener('loadedmetadata', function () {
            if (el.videoWidth && el.videoHeight) el.setAttribute('data-verhouding', el.videoWidth / el.videoHeight);
            zoomMediaMaat();
            zoomPijlPlek();
          });
          el.src = bronSrc;
        } else {
          el = document.createElement('iframe');
          el.className = 'iv-ph-zoom__embed';
          el.src = cel.getAttribute('data-ph-embed');
          el.allow = 'autoplay; fullscreen; picture-in-picture';
          el.setAttribute('allowfullscreen', '');
          el.setAttribute('data-verhouding', 16 / 9);
        }
        zoomMedia.appendChild(el);
        zoomMedia.hidden = false;
        if (img) img.hidden = true;
        zoomMediaMaat();
        if (soort === 'video') {
          var start = el.play();
          if (start && start.catch) start.catch(function () {});
        }
        return true;
      }

      function laadZoom(zoomOpener) {
        if (zoomToonMedia(zoomOpener.closest('.iv-ph__cell'))) { zoomPijlPlek(); return; }
        /* Metafield-route: meerdere werktekeningen — de knop draagt dan zijn eigen zoom-src */
        var zoomSrc = zoomOpener.getAttribute('data-ph-zoom-src');
        var zoomImg = zoomBeeld();
        if (!zoomSrc || !zoomImg || zoomImg.getAttribute('src') === zoomSrc) return;
        zoomImg.removeAttribute('srcset');
        /* De width/height-attributen horen bij de vórige bron: laten staan
           geeft de nieuwe foto een verkeerde beeldverhouding zolang hij laadt. */
        zoomImg.removeAttribute('width');
        zoomImg.removeAttribute('height');
        /* Progressief laden (Mehmet 24/08: de overlay bleef wit tot de
           1800px-versie binnen was): toon meteen de al geladen galerijfoto
           uit de cel en wissel stil naar de grote versie zodra die er is. */
        var celImg = zoomOpener.querySelector('img');
        var kleineBron = celImg && celImg.currentSrc ? celImg.currentSrc : '';
        if (kleineBron && kleineBron !== zoomSrc) {
          zoomImg.src = kleineBron;
          var groot = new Image();
          groot.onload = function () {
            /* Alleen wisselen als de overlay nog déze foto toont (niet
               intussen een andere cel geopend). */
            if (zoomImg.getAttribute('src') === kleineBron) zoomImg.src = zoomSrc;
          };
          groot.src = zoomSrc;
        } else {
          zoomImg.src = zoomSrc;
        }
      }

      function zoomStap(richting) {
        var cellen = zoomCellen();
        var i = cellen.indexOf(zoomCel);
        if (i < 0 || cellen.length < 2) return;
        zoomCel = cellen[(i + richting + cellen.length) % cellen.length];
        resetZoom();
        laadZoom(zoomCel);
      }

      function closeZoom() {
        if (!zoom) return;
        zoom.classList.remove('is-open');
        zoomCel = null;
        zoomToonMedia(null);
        resetZoom();
      }

      root.addEventListener('click', function (event) {
        var zoomOpener = event.target.closest('[data-ph-zoom-open]');
        if (zoomOpener && event.target.closest('[data-ph-video-toggle], [data-ph-embed-play]')) zoomOpener = null;
        if (zoomOpener) {
          if (zoom) {
            zoomCel = zoomOpener.closest('[data-ph-gallery] .iv-ph__cell');
            resetZoom();
            laadZoom(zoomOpener);
            zoom.classList.add('is-open');
            zoomPijlen();
          }
          return;
        }
        if (zoom && zoom.classList.contains('is-open')) {
          /* De klik die de browser na een sleep- of knijpgebaar nastuurt telt niet */
          if (Date.now() < zoomGebaarTot && zoom.contains(event.target)) return;
          if (event.target.closest('[data-ph-zoom-prev]')) { zoomStap(-1); return; }
          if (event.target.closest('[data-ph-zoom-next]')) { zoomStap(1); return; }
          /* In de overlay: klik op het beeld = 2x zoomen op het klikpunt (Ivo 14/08) */
          var overlayImg = event.target.closest('.iv-ph-zoom img');
          if (overlayImg) {
            if (zs > 1) {
              resetZoom();
            } else {
              var rect = overlayImg.getBoundingClientRect();
              zs = 2;
              ztx = -(event.clientX - (rect.left + rect.width / 2));
              zty = -(event.clientY - (rect.top + rect.height / 2));
              zetZoom(true);
            }
            return;
          }
        }
        if (event.target.closest('[data-ph-zoom-close]') || event.target === zoom) {
          closeZoom();
        }
      });

      if (zoom) {
        /* Andere foto of ander venster = andere beeldrand */
        zoom.querySelector('img') && zoom.querySelector('img').addEventListener('load', zoomPijlPlek);
        window.addEventListener('resize', function () { zoomMediaMaat(); zoomPijlPlek(); });
      }

      /* Aanraken in de overlay: knijpen = zoomen, slepen = verschuiven (ingezoomd)
         of naar de vorige/volgende foto vegen (niet ingezoomd). */
      if (zoom) {
        var zt = null;
        var zoomPunt = function (touch) {
          var r = zoom.getBoundingClientRect();
          return { x: touch.clientX - (r.left + r.width / 2), y: touch.clientY - (r.top + r.height / 2) };
        };
        var zoomStart = function (touches) {
          if (touches.length >= 2) {
            var a = zoomPunt(touches[0]), b = zoomPunt(touches[1]);
            zt = { knijp: true, d0: Math.hypot(a.x - b.x, a.y - b.y) || 1, s0: zs, tx0: ztx, ty0: zty, mx0: (a.x + b.x) / 2, my0: (a.y + b.y) / 2 };
          } else if (touches.length === 1) {
            var p = zoomPunt(touches[0]);
            zt = { knijp: false, x0: p.x, y0: p.y, tx0: ztx, ty0: zty, dx: 0, dy: 0, bewogen: zt ? zt.bewogen : false };
          } else {
            zt = null;
          }
        };
        zoom.addEventListener('touchstart', function (event) {
          if (event.target.closest('button, [data-ph-zoom-media]')) { zt = null; return; }
          zt = null;
          zoomStart(event.touches);
        }, { passive: true });
        zoom.addEventListener('touchmove', function (event) {
          if (!zt) return;
          if (event.cancelable) event.preventDefault();
          if (zt.knijp && event.touches.length >= 2) {
            var a = zoomPunt(event.touches[0]), b = zoomPunt(event.touches[1]);
            var s = Math.max(1, Math.min(4, zt.s0 * (Math.hypot(a.x - b.x, a.y - b.y) / zt.d0)));
            var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
            ztx = mx - (zt.mx0 - zt.tx0) * (s / zt.s0);
            zty = my - (zt.my0 - zt.ty0) * (s / zt.s0);
            zs = s;
            zt.bewogen = true;
            zetZoom(false);
          } else if (!zt.knijp && event.touches.length === 1) {
            var p = zoomPunt(event.touches[0]);
            zt.dx = p.x - zt.x0;
            zt.dy = p.y - zt.y0;
            if (Math.abs(zt.dx) + Math.abs(zt.dy) > 8) zt.bewogen = true;
            if (zs > 1) {
              ztx = zt.tx0 + zt.dx;
              zty = zt.ty0 + zt.dy;
              zetZoom(false);
            }
          }
        }, { passive: false });
        var zoomEinde = function (event) {
          if (!zt) return;
          if (zt.bewogen) zoomGebaarTot = Date.now() + 400;
          if (event.touches.length > 0) {
            /* Eén vinger blijft staan na het knijpen: van daaruit verder slepen zonder sprong */
            var bewogen = zt.bewogen;
            zoomStart(event.touches);
            if (zt) zt.bewogen = bewogen;
            return;
          }
          if (zs < 1.05) {
            var veeg = !zt.knijp && zt.bewogen && Math.abs(zt.dx) > 50 && Math.abs(zt.dx) > Math.abs(zt.dy) * 1.5;
            var richting = zt.dx < 0 ? 1 : -1;
            zt = null;
            resetZoom();
            if (veeg && zoomCel) zoomStap(richting);
            return;
          }
          zt = null;
          zetZoom(true);
        };
        zoom.addEventListener('touchend', zoomEinde);
        zoom.addEventListener('touchcancel', zoomEinde);
        /* Oudere iOS-versies: de eigen knijpzoom van Safari uit binnen de overlay */
        zoom.addEventListener('gesturestart', function (event) { event.preventDefault(); });
      }

      document.addEventListener('keydown', function (event) {
        if (zoom && zoom.classList.contains('is-open')) {
          if (event.key === 'ArrowLeft') { zoomStap(-1); return; }
          if (event.key === 'ArrowRight') { zoomStap(1); return; }
        }
        if (event.key !== 'Escape') return;
        if (zoom && zoom.classList.contains('is-open')) {
          closeZoom();
          return;
        }
        closeFlyouts();
      });


      render();
      // B2C/B2B-wissel: alle dynamische prijzen (ATC-label, bundel, sticky)
      // opnieuw renderen in de juiste btw-weergave.
      document.addEventListener('iv:audience', render);
    }

    function initAll() {
      document.querySelectorAll('.iv-product-hero').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-product-listing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const GAP = 4;

    // Kaartfoto's: hover toont foto 2, weg = terug (klantpunt Ivo 14/08; de
    // losse foto-pijltjes op de kaart zijn op 14/08 door Mehmet geschrapt —
    // de strook heeft zijn eigen pijltjes al). Document-level met guard:
    // section-javascript bundelt site-breed en de kaart-snippet rendert ook
    // op de zoekpagina en in de cart.
    //
    // "Thuis" is niet altijd slide 0: na een swatch-klik is dat de slide van die
    // uitvoering (data-lp-home). En de hover wisselt alleen binnen de fotoreeks van
    // dezelfde uitvoering (data-lp-series uit de snippet, data-lp-run na een klik) —
    // een foto van een andere kleur onder een kleurlabel is precies de verwarring
    // die de merchant op 18/08 meldde. Kaarten zonder swatches hebben geen
    // reeks-informatie; die houden het oude gedrag (foto 2 op hover).
    const ivCardStep = (slider) => slider.clientWidth + 2;
    const ivCardHome = (card) => parseInt(card.dataset.lpHome || '0', 10) || 0;
    const ivCardRun = (card, slider) => {
      const n = parseInt(card.dataset.lpRun || card.dataset.lpSeries || '', 10);
      if (Number.isFinite(n)) return n;
      return slider.children.length;
    };
    if (!window.__ivCardPhotoNav) {
      window.__ivCardPhotoNav = 1;
      if (window.matchMedia('(hover: hover)').matches) {
        document.addEventListener('mouseover', (e) => {
          const card = e.target.closest('[data-lp-card]');
          if (!card || card.contains(e.relatedTarget)) return;
          const slider = card.querySelector('[data-lp-slider]');
          if (!slider || slider.children.length < 2) return;
          // Kaart met hover-laag (tweede foto, Ivo 28/08): de laag wint, niet scrollen.
          if (card.dataset.lpDesktop && card.dataset.lpDesktop !== 'slider') return;
          if (card.querySelector('[data-lp-hover]')) return;
          const home = ivCardHome(card);
          if (ivCardRun(card, slider) < 2 || home + 1 >= slider.children.length) return;
          const step = ivCardStep(slider);
          if (Math.abs(slider.scrollLeft - home * step) < 4) {
            slider.scrollTo({ left: (home + 1) * step, behavior: 'smooth' });
          }
        });
        document.addEventListener('mouseout', (e) => {
          const card = e.target.closest('[data-lp-card]');
          if (!card || card.contains(e.relatedTarget)) return;
          const slider = card.querySelector('[data-lp-slider]');
          if (!slider) return;
          const left = ivCardHome(card) * ivCardStep(slider);
          if (Math.abs(slider.scrollLeft - left) > 4) {
            slider.scrollTo({ left: left, behavior: 'smooth' });
          }
        });
      }
    }

    // Kaartfoto = foto van de ACTIEVE swatch (merchantmelding 18/08). De snippet
    // regelt dat server-side, maar de productkaart van iv-collection-grid heeft zijn
    // eigen markup; daar zet deze sweep de juiste slide vooraan (DOM-volgorde, geen
    // scroll: positie 0 blijft "thuis" voor hover en indicator). Staat de foto van
    // de actieve uitvoering niet tussen de vijf slides, dan krijgt slide 0 die foto
    // als bron. Voor de snippetkaarten is dit een no-op.
    //
    // De originele bronnen worden hier vastgelegd: de gedeelde swatch-handler
    // overschrijft slide 0 wanneer een uitvoering geen eigen slide heeft, en zonder
    // dat geheugen toont een terugklik naar de eerste kleur de foto van de vorige.
    function ivSyncCardMedia(card) {
      if (card.dataset.lpSync) return;
      card.dataset.lpSync = '1';
      const slider = card.querySelector('[data-lp-slider], [data-cg-slider]');
      if (!slider) return;
      const slides = Array.from(slider.children);
      slides.forEach((slide) => {
        const img = slide.querySelector('img');
        if (img && img.dataset.ivSrc === undefined) {
          img.dataset.ivSrc = img.getAttribute('src') || '';
          img.dataset.ivSrcset = img.getAttribute('srcset') || '';
        }
      });
      const active = card.querySelector('[data-swatch-value].is-active');
      if (!active) return;
      card.dataset.lpHomeValue = active.dataset.swatchValue || '';
      const mediaId = active.dataset.swatchMedia;
      const idx = mediaId ? slides.findIndex((s) => s.dataset.mediaId === mediaId) : -1;
      if (idx > 0) {
        slider.insertBefore(slides[idx], slider.firstChild);
      } else if (idx < 0 && active.dataset.swatchImage && slides[0]) {
        const img = slides[0].querySelector('img');
        if (img) {
          img.removeAttribute('srcset');
          img.src = active.dataset.swatchImage;
          img.dataset.ivSrc = active.dataset.swatchImage;
          img.dataset.ivSrcset = '';
        }
      }
    }

    const ivSyncAllCards = (scope) => {
      (scope || document).querySelectorAll('[data-lp-card], [data-cg-card]').forEach(ivSyncCardMedia);
    };
    if (!window.__ivCardMediaSync) {
      window.__ivCardMediaSync = 1;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => ivSyncAllCards());
      } else {
        ivSyncAllCards();
      }
      document.addEventListener('shopify:section:load', (event) => ivSyncAllCards(event.target));

      // Loopt ná de gedeelde swatch-handler (die staat eerder in de gebundelde
      // scripts.js en heeft dus al gescrold of slide 0 overschreven): hier zetten we
      // de overschreven foto's terug zodra de aangeklikte uitvoering wél een eigen
      // slide heeft, en onthouden we wat "thuis" is voor de hover.
      document.addEventListener('click', (e) => {
        const sw = e.target.closest('[data-swatch-value]');
        if (!sw) return;
        const card = sw.closest('[data-lp-card], [data-cg-card]');
        if (!card) return;
        // Een echte klik legt de keuze vast: het hover-voorbeeld hieronder zet dan
        // niets meer terug.
        if (e.isTrusted) delete card.dataset.lpHoverOrigin;
        // Hover-foto uit tot de muis de kaart verlaat, anders blijft foto 2 over de
        // gekozen kleur liggen (Ivo 22/09).
        card.classList.add('is-swatched');
        card.addEventListener('mouseleave', () => card.classList.remove('is-swatched'), { once: true });
        const slider = card.querySelector('[data-lp-slider], [data-cg-slider]');
        if (!slider) return;
        const slides = Array.from(slider.children);
        const idx = sw.dataset.swatchMedia
          ? slides.findIndex((s) => s.dataset.mediaId === sw.dataset.swatchMedia)
          : -1;
        if (idx >= 0) {
          slides.forEach((slide) => {
            const img = slide.querySelector('img');
            if (!img || img.dataset.ivSrc === undefined) return;
            if (img.getAttribute('src') !== img.dataset.ivSrc) {
              img.src = img.dataset.ivSrc;
              if (img.dataset.ivSrcset) img.setAttribute('srcset', img.dataset.ivSrcset);
            }
          });
          card.dataset.lpHome = String(idx);
          card.dataset.lpRun =
            sw.dataset.swatchValue === card.dataset.lpHomeValue ? card.dataset.lpSeries || '1' : '1';
        } else {
          card.dataset.lpHome = '0';
          card.dataset.lpRun = '1';
        }
      });
    }

    // Kleurstaal aanwijzen = die kleur alvast tonen (Ivo 22/09), alleen met muis.
    // Het voorbeeld loopt via dezelfde klikhandler als een echte klik (synthetische
    // click, isTrusted false); verlaat de muis de kaart zonder klik, dan gaat de
    // kaart terug naar de kleur die actief was.
    if (!window.__ivSwatchHover && window.matchMedia('(hover: hover)').matches) {
      window.__ivSwatchHover = 1;
      document.addEventListener('mouseover', (e) => {
        const sw = e.target.closest('[data-swatch-value]');
        if (!sw || sw.classList.contains('is-active')) return;
        const card = sw.closest('[data-lp-card], [data-cg-card]');
        if (!card) return;
        if (card.dataset.lpHoverOrigin === undefined) {
          const active = card.querySelector('[data-swatch-value].is-active');
          card.dataset.lpHoverOrigin = active ? active.dataset.swatchValue || '' : '';
        }
        sw.click();
      });
      document.addEventListener('mouseout', (e) => {
        const card = e.target.closest('[data-lp-card], [data-cg-card]');
        if (!card || card.contains(e.relatedTarget)) return;
        const origin = card.dataset.lpHoverOrigin;
        if (origin === undefined) return;
        delete card.dataset.lpHoverOrigin;
        const terug = Array.from(card.querySelectorAll('[data-swatch-value]')).find((s) => s.dataset.swatchValue === origin);
        if (terug && !terug.classList.contains('is-active')) terug.click();
      });
    }

    function initListing(root) {
      if (root.dataset.lpInit) return;
      root.dataset.lpInit = '1';

      const tracks = Array.from(root.querySelectorAll('[data-lp-track]'));
      const prev = root.querySelector('[data-lp-prev]');
      const next = root.querySelector('[data-lp-next]');
      const activeTrack = () => tracks.find((t) => !t.hidden) || tracks[0];

      if (tracks.length && prev && next) {
        const update = () => {
          const track = activeTrack();
          const max = track.scrollWidth - track.clientWidth;
          prev.hidden = track.scrollLeft <= 2;
          next.hidden = track.scrollLeft >= max - 2;
        };
        const step = (dir) => {
          const track = activeTrack();
          const card = track.querySelector('[data-lp-card]');
          const span = card ? card.getBoundingClientRect().width + GAP : track.clientWidth;
          const visible = Math.max(1, Math.floor((track.clientWidth - 128) / span));
          track.scrollBy({ left: dir * span * visible, behavior: 'smooth' });
        };
        prev.addEventListener('click', () => step(-1));
        next.addEventListener('click', () => step(1));
        tracks.forEach((t) => {
          t.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
        });
        window.addEventListener('resize', update);
        update();

        const tabs = Array.from(root.querySelectorAll('[data-lp-tab]'));
        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            if (tab.classList.contains('is-active')) return;
            tabs.forEach((t) => {
              const on = t === tab;
              t.classList.toggle('is-active', on);
              t.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            tracks.forEach((t) => {
              t.hidden = t.dataset.lpPanel !== tab.dataset.lpTab;
            });
            if (tab.dataset.lpUrl) {
              root.querySelectorAll('[data-lp-viewall]').forEach((a) => { a.href = tab.dataset.lpUrl; });
            }
            update();
          });
        });
      }

      root.querySelectorAll('[data-lp-card]').forEach((card) => {
        const slider = card.querySelector('[data-lp-slider]');
        const segs = card.querySelectorAll('[data-lp-seg]');
        if (!slider || segs.length < 2) return;
        let current = 0;
        slider.addEventListener(
          'scroll',
          () => {
            requestAnimationFrame(() => {
              const i = Math.min(
                segs.length - 1,
                Math.max(0, Math.round(slider.scrollLeft / (slider.clientWidth + 2)))
              );
              if (i !== current) {
                segs[current].classList.remove('is-active');
                segs[i].classList.add('is-active');
                current = i;
              }
            });
          },
          { passive: true }
        );
      });
    }

    // Native product recommendations: de Liquid-render van deze sectie kan ze niet
    // zelf ophalen (recommendations.performed? is daar false), dus halen we de
    // sectie opnieuw op via de Product Recommendations API + Section Rendering API
    // en vervangen we de inhoud. De opgehaalde render valt zelf terug op de
    // collection-setting als Shopify geen aanbevelingen heeft.
    function loadRecommendations(root) {
      const url = root.dataset.lpRecommendUrl;
      if (!url) return;
      delete root.dataset.lpRecommendUrl;
      fetch(url)
        .then((r) => (r.ok ? r.text() : Promise.reject(new Error('recommendations failed'))))
        .then((html) => {
          const fresh = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('.iv-product-listing');
          if (!fresh || !fresh.querySelector('[data-lp-card]')) return;
          fresh.removeAttribute('hidden');
          root.replaceWith(fresh);
          initListing(fresh);
        })
        .catch(() => {});
    }

    const initAll = () => {
      document.querySelectorAll('.iv-product-listing').forEach((root) => {
        if (root.dataset.lpRecommendUrl) {
          loadRecommendations(root);
        } else {
          initListing(root);
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.iv-product-listing');
      if (!section) return;
      if (section.dataset.lpRecommendUrl) {
        loadRecommendations(section);
      } else {
        initListing(section);
      }
    });

    // Quick-ATC (compact-modus, cart "Ook interessant"): tas-knop voegt de
    // eerste beschikbare variant toe; cart:refresh laat cartpagina + header-badge
    // bijtrekken. Buiten de cartpagina opent daarna de drawer (site-contract).
    if (!window.__ivLpAtcInit) {
      window.__ivLpAtcInit = true;
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.iv-product-listing [data-lp-atc]');
        if (!btn) return;
        e.preventDefault();
        if (btn.classList.contains('is-busy')) return;
        btn.classList.add('is-busy');
        // Zelfde herkansing als de samensteller (02/09): een 429-challenge op
        // /cart/add.js is tijdelijk; twee stille herkansingen, 422 niet.
        let pogingen = 0;
        const poging = () => {
          pogingen += 1;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.lpAtc, 10), quantity: 1 }] }),
          })
            .then((r) => {
              if (!r.ok) {
                const fout = new Error('cart add failed');
                fout.status = r.status;
                throw fout;
              }
              return r.json();
            })
            .then(() => {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              if (!document.querySelector('.iv-cart')) {
                const opener = document.querySelector('[data-cart-drawer-open]');
                if (opener) opener.click();
              }
              btn.classList.remove('is-busy');
            })
            .catch((fout) => {
              if (pogingen < 3 && (!fout || fout.status !== 422)) {
                window.setTimeout(poging, pogingen === 1 ? 1200 : 2800);
                return;
              }
              btn.classList.remove('is-busy');
            });
        };
        poging();
      });
    }

    // Swatch-klik -> toon de foto van die uitvoering. Gedeeld met iv-collection-grid
    // (zelfde data-attributen), vandaar één document-handler met window-guard.
    if (!window.__ivSwatchInit) {
      window.__ivSwatchInit = true;
      document.addEventListener('click', (e) => {
        const sw = e.target.closest('[data-swatch-value]');
        if (!sw) return;
        e.preventDefault();
        const card = sw.closest('[data-lp-card], [data-cg-card]');
        if (!card) return;
        card.querySelectorAll('[data-swatch-value]').forEach((s) => {
          s.classList.toggle('is-active', s === sw);
        });
        const label = card.querySelector('.iv-product-listing__swatch-label, .iv-collection-grid__swatch-label');
        if (label) label.textContent = sw.dataset.swatchValue;
        const slider = card.querySelector('[data-lp-slider], [data-cg-slider]');
        if (!slider) return;
        const slides = Array.from(slider.children);
        const target = sw.dataset.swatchMedia
          ? slides.findIndex((s) => s.dataset.mediaId === sw.dataset.swatchMedia)
          : -1;
        if (target >= 0) {
          slider.scrollTo({ left: target * (slider.clientWidth + 2), behavior: 'smooth' });
        } else if (sw.dataset.swatchImage) {
          const img = slides[0] && slides[0].querySelector('img');
          if (img) {
            img.removeAttribute('srcset');
            img.src = sw.dataset.swatchImage;
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-product-row"] && !Shopify.designMode) return;
  try {
    
  // ------------- Werkplek-samensteller flyout (Golf 6) -------------
  // Stappen-drawer met data-gedreven optie-dropdowns, variant-resolutie,
  // galerij, info-subpaneel en één /cart/add.js-call voor de hele selectie.
  (function () {
    var REDUCED = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function wsMoney(cents) {
      var neg = cents < 0;
      cents = Math.abs(Math.round(cents));
      var eur = Math.floor(cents / 100);
      var rest = cents % 100;
      var s = String(eur).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return (neg ? '-' : '') + '€' + s + (rest ? ',' + ('0' + rest).slice(-2) : '');
    }

    function initWsRoot(wsRoot) {
      if (wsRoot.__ivWs) return wsRoot.__ivWs;

      var panel = wsRoot.querySelector('[data-ws-panel]');
      var overlay = wsRoot.querySelector('[data-ws-overlay]');
      var tabs = Array.prototype.slice.call(wsRoot.querySelectorAll('[data-ws-tab]'));
      var progress = wsRoot.querySelector('[data-ws-progress]');
      var footerBtn = wsRoot.querySelector('[data-ws-next]');
      var body = wsRoot.querySelector('.iv-pr-ws__body');
      var stepEls = Array.prototype.slice.call(wsRoot.querySelectorAll('[data-ws-step]'));
      // Productkeuze per stap (22/08): een stap (data-ws-step) draagt één of meer panelen
      // (data-ws-panel, één per toegestaan product); het zichtbare paneel is het actieve.
      var panelEls = Array.prototype.slice.call(wsRoot.querySelectorAll('[data-ws-panel]'));
      var infoEls = Array.prototype.slice.call(wsRoot.querySelectorAll('[data-ws-info]'));
      var infoByIdx = {};
      infoEls.forEach(function (el) {
        infoByIdx[el.getAttribute('data-ws-info')] = el;
      });

      var current = 0;
      var openInfoKey = null;
      var busy = false;

      function findVariant(slot, opts) {
        var vs = slot.data.variants;
        for (var i = 0; i < vs.length; i++) {
          var match = true;
          for (var j = 0; j < opts.length; j++) {
            if (vs[i].o[j] !== opts[j]) {
              match = false;
              break;
            }
          }
          if (match) return vs[i];
        }
        return null;
      }

      function optionDelta(slot, oi, value) {
        var cand = null;
        var min = null;
        var optData = slot.data.options[oi];
        if (!optData) return null;
        for (var k = 0; k < optData.values.length; k++) {
          var probe = slot.selected.slice();
          probe[oi] = optData.values[k].v;
          var pv = findVariant(slot, probe);
          if (pv && (min === null || pv.p < min)) min = pv.p;
          if (optData.values[k].v === value) cand = pv;
        }
        if (cand === null || min === null) return null;
        return cand.p - min;
      }

      // Het kleurvlak is in Liquid al gerenderd (snippets/iv-swatch.liquid) en zit
      // per optiewaarde als markup in de slot-data. De browser hoeft dus geen
      // kleurregels te kennen en kan ook nooit op een productfoto terugvallen.
      function paintSwatch(swEl, slot, oi, value) {
        var optData = slot.data.options[oi];
        if (!optData) return;
        for (var i = 0; i < optData.values.length; i++) {
          if (optData.values[i].v === value) {
            if (optData.values[i].sw) swEl.innerHTML = optData.values[i].sw;
            return;
          }
        }
      }

      function updateOptionLabels(slot) {
        if (slot.data.hasOnlyDefault) return;
        slot.selects.forEach(function (sel, oi) {
          Array.prototype.slice.call(sel.options).forEach(function (optEl) {
            var d = optionDelta(slot, oi, optEl.value);
            // Gratis-stap: geen meerprijs-hints, elke keuze is even gratis.
            optEl.textContent = optEl.value + (!slot.free && d > 0 ? ' (+' + wsMoney(d) + ')' : '');
          });
          var wrap = sel.closest('.iv-pr-ws__select');
          if (!wrap) return;
          var valEl = wrap.querySelector('[data-ws-display-value]');
          var selOpt = sel.options[sel.selectedIndex >= 0 ? sel.selectedIndex : 0];
          if (valEl) valEl.textContent = selOpt ? selOpt.textContent : sel.value;
          var sw = wrap.querySelector('[data-ws-display-swatch]');
          if (sw) paintSwatch(sw, slot, oi, sel.value);
        });
      }

      // Gesplitste model-optie (Uitvoering + Frame kleur, Figma-flyout): de twee
      // zichtbare selects sturen samen de verborgen master-select met de échte
      // Shopify-optiewaarde aan; alle variant-logica blijft op de master lopen.
      function applySplit(slot, changed) {
        var oi = parseInt(changed.getAttribute('data-ws-split-for'), 10);
        var model = '';
        var color = '';
        slot.splitSelects.forEach(function (s) {
          if (parseInt(s.getAttribute('data-ws-split-for'), 10) !== oi) return;
          if (s.getAttribute('data-ws-split-part') === 'model') model = s.value;
          else color = s.value;
        });
        var master = null;
        slot.selects.forEach(function (s) {
          if (parseInt(s.getAttribute('data-ws-option'), 10) === oi) master = s;
        });
        if (!master || !model) return;
        var exact = null;
        var prefix = null;
        Array.prototype.slice.call(master.options).forEach(function (o) {
          if (color && o.value === model + ' ' + color) exact = o.value;
          if (!prefix && o.value.indexOf(model + ' ') === 0) prefix = o.value;
        });
        var target = exact || prefix;
        if (!target) return;
        master.value = target;
        changeOption(slot, oi, target);
      }

      function updateSplitDisplays(slot) {
        if (!slot.splitSelects || !slot.splitSelects.length) return;
        slot.splitSelects.forEach(function (sel) {
          var oi = parseInt(sel.getAttribute('data-ws-split-for'), 10);
          var part = sel.getAttribute('data-ws-split-part');
          var cur = slot.variant ? String(slot.variant.o[oi]) : '';
          var curColor = cur ? cur.split(' ').pop() : '';
          var curModel = cur ? cur.slice(0, cur.length - curColor.length).trim() : '';
          if (cur) sel.value = part === 'model' ? curModel : curColor;
          Array.prototype.slice.call(sel.options).forEach(function (optEl) {
            var suffix = '';
            if (part === 'model' && curColor && !slot.free) {
              var d = optionDelta(slot, oi, optEl.value + ' ' + curColor);
              if (d > 0) suffix = ' (+' + wsMoney(d) + ')';
            }
            optEl.textContent = optEl.value + suffix;
          });
          var wrap = sel.closest('.iv-pr-ws__select');
          if (!wrap) return;
          var valEl = wrap.querySelector('[data-ws-display-value]');
          var selOpt = sel.options[sel.selectedIndex >= 0 ? sel.selectedIndex : 0];
          if (valEl) valEl.textContent = selOpt ? selOpt.textContent : sel.value;
          var sw = wrap.querySelector('[data-ws-split-swatch]');
          if (sw && part === 'color' && slot && slot.data.splitSwatches) {
            var html = slot.data.splitSwatches[sel.value];
            if (html) sw.innerHTML = html;
          }
        });
      }

      // Kabelgoot-add-on: variant met kleurmatch op de gekozen framekleur,
      // anders de eerste leverbare (zelfde principe als de buy-box-add-on).
      function addonVariantFor(slot) {
        var ad = slot.data.addon;
        if (!ad || !ad.variants || !ad.variants.length) return null;
        var color = '';
        if (slot.data.execIdx >= 0 && slot.variant) {
          var bits = String(slot.variant.o[slot.data.execIdx]).split(' ');
          color = (bits[bits.length - 1] || '').toLowerCase();
        }
        var match = null;
        var firstA = null;
        ad.variants.forEach(function (v) {
          if (!firstA && v.a) firstA = v;
          if (!match && color && v.a) {
            for (var i = 0; i < v.o.length; i++) {
              if (String(v.o[i]).toLowerCase().indexOf(color) !== -1) {
                match = v;
                break;
              }
            }
          }
        });
        return match || firstA || ad.variants[0];
      }

      function updateAddonDisplay(slot) {
        if (!slot.addonSel) return;
        var av = addonVariantFor(slot);
        Array.prototype.slice.call(slot.addonSel.options).forEach(function (optEl) {
          var base = optEl.getAttribute('data-base');
          if (!base) {
            base = optEl.textContent;
            optEl.setAttribute('data-base', base);
          }
          optEl.textContent = optEl.value === 'yes' && av && av.p > 0 && !slot.free ? base + ' (+' + wsMoney(av.p) + ')' : base;
        });
        var wrap = slot.addonSel.closest('.iv-pr-ws__select');
        if (!wrap) return;
        var valEl = wrap.querySelector('[data-ws-display-value]');
        var selOpt = slot.addonSel.options[slot.addonSel.selectedIndex >= 0 ? slot.addonSel.selectedIndex : 0];
        if (valEl) valEl.textContent = selOpt ? selOpt.textContent : slot.addonSel.value;
      }

      function variantSlideIndex(slot) {
        var v = slot.variant;
        if (!v) return -1;
        if (v.mid !== null) {
          for (var i = 0; i < slot.slides.length; i++) {
            if (slot.slides[i].getAttribute('data-media-id') === String(v.mid)) return i;
          }
        }
        if (v.img) return 0;
        return -1;
      }

      function updateChip(slot) {
        if (!slot.chip) return;
        var ci = slot.data.colorIdx;
        if (ci < 0 || !slot.variant) {
          slot.chip.hidden = true;
          return;
        }
        if (slot.chipLabel) slot.chipLabel.textContent = slot.variant.o[ci];
        if (slot.chipSwatch) paintSwatch(slot.chipSwatch, slot, ci, slot.variant.o[ci]);
        slot.chip.hidden = slot.currentSlide !== variantSlideIndex(slot);
      }

      function updateSummary(slot) {
        if (slot.summary) {
          var parts = [slot.data.name];
          if (!slot.data.hasOnlyDefault && slot.variant) parts = parts.concat(slot.variant.o);
          var text = parts.join(' | ');
          if (slot.addonOn) {
            var addonLbl = slot.el.querySelector('[data-ws-addon-label]');
            if (addonLbl) text += ' | ' + addonLbl.textContent.trim();
          }
          if (slot.variant && !slot.variant.a) text += ' · Uitverkocht';
          slot.summary.textContent = text;
        }
        updateChip(slot);
      }

      function isPanelHidden(slot) {
        // Het paneel zelf kan verborgen zijn (niet-actief product) of zijn stap (data-ws-step).
        var group = slot.el.closest('[data-ws-step]');
        return slot.el.hidden || (group && group.hidden);
      }

      function scrollToSlide(slot, idx, smooth) {
        if (!slot.slidesWrap || !slot.slides[idx]) return;
        if (isPanelHidden(slot)) {
          slot.pendingSlide = idx;
          return;
        }
        var behavior = smooth && !(REDUCED && REDUCED.matches) ? 'smooth' : 'auto';
        slot.slidesWrap.scrollTo({ left: slot.slides[idx].offsetLeft, behavior: behavior });
      }

      function goToVariantSlide(slot, smooth) {
        var v = slot.variant;
        if (!v || !slot.slides.length) return;
        var idx = -1;
        if (v.mid !== null) {
          for (var i = 0; i < slot.slides.length; i++) {
            if (slot.slides[i].getAttribute('data-media-id') === String(v.mid)) {
              idx = i;
              break;
            }
          }
        }
        if (idx === -1 && v.img) {
          // Variant-beeld zit niet in de (gecapte) galerij: eerste slide overnemen
          var img = slot.slides[0].querySelector('img');
          if (img && img.getAttribute('src') !== v.img) {
            img.src = v.img;
            img.removeAttribute('srcset');
          }
          idx = 0;
        }
        if (idx === -1) {
          updateChip(slot);
          return;
        }
        scrollToSlide(slot, idx, smooth);
        updateChip(slot);
      }

      function paintGallery(slot) {
        var count = slot.slides.length;
        var multi = count > 1;
        if (slot.prev) slot.prev.hidden = !multi || slot.currentSlide <= 0;
        if (slot.next) slot.next.hidden = !multi || slot.currentSlide >= count - 1;
        if (slot.bar) {
          slot.bar.hidden = !multi;
          if (multi && slot.thumb) {
            slot.thumb.style.width = 100 / count + '%';
            slot.thumb.style.left = (slot.currentSlide * 100) / count + '%';
          }
        }
      }

      function onSlideScroll(slot) {
        var w = slot.slidesWrap.clientWidth || 1;
        var idx = Math.round(slot.slidesWrap.scrollLeft / w);
        idx = Math.min(Math.max(idx, 0), slot.slides.length - 1);
        if (idx !== slot.currentSlide) {
          slot.currentSlide = idx;
          updateChip(slot);
        }
        paintGallery(slot);
      }

      function slideBy(slot, dir) {
        var target = Math.min(Math.max(slot.currentSlide + dir, 0), slot.slides.length - 1);
        scrollToSlide(slot, target, true);
      }

      function changeOption(slot, oi, value) {
        var wanted = slot.selected.slice();
        wanted[oi] = value;
        var v = findVariant(slot, wanted);
        if (!v) {
          // Combinatie bestaat niet: eerste variant met deze waarde, andere selects mee-syncen
          for (var i = 0; i < slot.data.variants.length; i++) {
            if (slot.data.variants[i].o[oi] === value) {
              v = slot.data.variants[i];
              break;
            }
          }
          if (v) {
            wanted = v.o.slice();
            slot.selects.forEach(function (sel, si) {
              sel.value = wanted[si];
            });
          }
        }
        if (!v) return;
        slot.selected = wanted;
        slot.variant = v;
        updateOptionLabels(slot);
        updateSplitDisplays(slot);
        updateAddonDisplay(slot);
        updateSummary(slot);
        goToVariantSlide(slot, true);
        renderFooter();
      }

      function buildSlot(el, idx) {
        var slot = {
          el: el,
          idx: idx,
          data: { name: '', hasOnlyDefault: true, colorIdx: -1, optional: false, options: [], variants: [] },
          variant: null,
          selected: [],
          include: true,
          currentSlide: 0,
          pendingSlide: -1,
          // Gratis-stap (data-ws-free op de stepgroup): telt niet mee in het knoptotaal,
          // de automatische korting "Free accessory" maakt hem in de checkout 0.
          free: !!el.closest('[data-ws-step][data-ws-free]'),
        };
        var dataEl = el.querySelector('[data-ws-data]');
        if (dataEl) {
          try {
            slot.data = JSON.parse(dataEl.textContent);
          } catch (e) {
            /* defensief: slot blijft leeg maar de flyout werkt door */
          }
        }
        slot.slides = Array.prototype.slice.call(el.querySelectorAll('.iv-pr-ws__slide'));
        slot.slidesWrap = el.querySelector('[data-ws-slides]');
        slot.chip = el.querySelector('[data-ws-chip]');
        slot.chipSwatch = el.querySelector('[data-ws-chip-swatch]');
        slot.chipLabel = el.querySelector('[data-ws-chip-label]');
        slot.summary = el.querySelector('[data-ws-summary]');
        slot.prev = el.querySelector('[data-ws-prev]');
        slot.next = el.querySelector('[data-ws-next-slide]');
        slot.bar = el.querySelector('[data-ws-gallery-bar]');
        slot.thumb = el.querySelector('[data-ws-gallery-thumb]');
        slot.selects = Array.prototype.slice.call(el.querySelectorAll('select[data-ws-option]'));

        var includeBox = el.querySelector('[data-ws-include]');
        if (includeBox) {
          slot.include = includeBox.checked;
          includeBox.addEventListener('change', function () {
            slot.include = includeBox.checked;
            renderFooter();
          });
        }

        if (slot.data.hasOnlyDefault) {
          slot.variant = slot.data.variants[0] || null;
        } else {
          slot.selected = slot.selects.map(function (sel) {
            return sel.value;
          });
          slot.variant = findVariant(slot, slot.selected) || slot.data.variants[0] || null;
          if (slot.variant) slot.selected = slot.variant.o.slice();
        }

        slot.selects.forEach(function (sel) {
          sel.addEventListener('change', function () {
            changeOption(slot, parseInt(sel.getAttribute('data-ws-option'), 10), sel.value);
          });
        });
        slot.splitSelects = Array.prototype.slice.call(el.querySelectorAll('select[data-ws-split-part]'));
        slot.splitSelects.forEach(function (sel) {
          sel.addEventListener('change', function () {
            applySplit(slot, sel);
          });
        });
        slot.addonSel = el.querySelector('select[data-ws-addon]');
        slot.addonOn = false;
        if (slot.addonSel) {
          slot.addonSel.addEventListener('change', function () {
            slot.addonOn = slot.addonSel.value === 'yes';
            updateAddonDisplay(slot);
            updateSummary(slot);
            renderFooter();
          });
        }
        if (slot.prev) {
          slot.prev.addEventListener('click', function () {
            slideBy(slot, -1);
          });
        }
        if (slot.next) {
          slot.next.addEventListener('click', function () {
            slideBy(slot, 1);
          });
        }
        if (slot.slidesWrap) {
          slot.slidesWrap.addEventListener(
            'scroll',
            function () {
              onSlideScroll(slot);
            },
            { passive: true }
          );
        }

        updateOptionLabels(slot);
        updateSplitDisplays(slot);
        updateAddonDisplay(slot);
        updateSummary(slot);
        goToVariantSlide(slot, false);
        paintGallery(slot);
        return slot;
      }

      var panels = panelEls.map(function (el) {
        return buildSlot(el, parseInt(el.getAttribute('data-ws-panel'), 10) || 0);
      });
      var steps = stepEls.map(function (el, i) {
        var own = panels.filter(function (p) {
          return p.idx === i;
        });
        var active = 0;
        own.forEach(function (p, j) {
          if (!p.el.hidden) active = j;
        });
        return { el: el, panels: own, active: active, picks: Array.prototype.slice.call(el.querySelectorAll('[data-ws-pick]')) };
      });
      function activeSlot(i) {
        var st = steps[i];
        if (!st) return null;
        return st.panels[st.active] || null;
      }
      function activeSlots() {
        return steps
          .map(function (st) {
            return st.panels[st.active] || null;
          })
          .filter(Boolean);
      }
      function paintPicks(st, handle) {
        st.picks.forEach(function (btn) {
          var on = btn.getAttribute('data-ws-pick') === handle;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      // Keuzerij: ander product in deze stap activeren (paneel wisselen, galerij opnieuw meten).
      function pickProduct(stepIdx, handle) {
        var st = steps[stepIdx];
        if (!st) return;
        var target = -1;
        st.panels.forEach(function (p, j) {
          if (p.el.getAttribute('data-ws-panel-product') === handle) target = j;
        });
        if (target < 0) return;
        if (target === st.active) return;
        st.active = target;
        st.panels.forEach(function (p, j) {
          p.el.hidden = j !== target;
        });
        paintPicks(st, handle);
        var slot = st.panels[target];
        if (slot.pendingSlide >= 0) {
          var pendingPick = slot.pendingSlide;
          slot.pendingSlide = -1;
          slot.currentSlide = pendingPick;
        }
        scrollToSlide(slot, slot.currentSlide, false);
        paintGallery(slot);
        updateChip(slot);
        updateSummary(slot);
        renderFooter();
      }

      function renderFooter() {
        if (!footerBtn) return;
        var last = current === stepEls.length - 1;
        if (!last) {
          footerBtn.textContent = footerBtn.getAttribute('data-label-next') || 'Volgende';
          footerBtn.disabled = false;
          return;
        }
        var total = 0;
        var unavailable = false;
        activeSlots().forEach(function (slot) {
          if (slot.data.optional && !slot.include) return;
          if (slot.variant) {
            if (!slot.free) total += slot.variant.p;
            if (!slot.variant.a) unavailable = true;
          }
          if (slot.addonOn && slot.addonSel) {
            var av = addonVariantFor(slot);
            if (av) {
              total += av.p;
              if (!av.a) unavailable = true;
            }
          }
        });
        footerBtn.textContent = (footerBtn.getAttribute('data-label-cart') || 'Selectie in winkelwagen') + ' - ' + wsMoney(total);
        footerBtn.disabled = unavailable;
      }

      function activateStep(idx) {
        idx = Math.min(Math.max(idx, 0), stepEls.length - 1);
        current = idx;
        stepEls.forEach(function (el, i) {
          el.hidden = i !== idx;
        });
        tabs.forEach(function (tab, i) {
          tab.classList.toggle('is-active', i === idx);
          tab.classList.toggle('is-done', i < idx);
          tab.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        if (progress) {
          // Figma tekent de balk per stap exact uit: 16, 180 en 333px op een baan
          // van 432 (frames 1045:15808 / 16158 / 16296). Bij een afwijkend aantal
          // stappen valt hij terug op een gelijkmatige verdeling.
          var FIGMA_STAPPEN = [3.7037, 41.6667, 77.0833];
          var pct = stepEls.length === 3
            ? FIGMA_STAPPEN[idx]
            : ((idx + 0.2) / stepEls.length) * 100;
          progress.style.width = pct + '%';
        }
        var slot = activeSlot(idx);
        if (slot) {
          if (slot.pendingSlide >= 0) {
            var pending = slot.pendingSlide;
            slot.pendingSlide = -1;
            slot.currentSlide = pending;
            scrollToSlide(slot, pending, false);
          }
          paintGallery(slot);
          updateChip(slot);
        }
        renderFooter();
        if (body) body.scrollTop = 0;
      }

      function open() {
        wsRoot.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        activateStep(current);
        if (panel) panel.focus({ preventScroll: true });
      }

      function closeInfo() {
        if (openInfoKey === null) return;
        var el = infoByIdx[String(openInfoKey)];
        openInfoKey = null;
        if (!el) return;
        el.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
        if (panel) panel.focus({ preventScroll: true });
      }

      function close() {
        if (!wsRoot.classList.contains('is-open')) return;
        closeInfo();
        wsRoot.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }

      function openInfo(key) {
        var el = infoByIdx[String(key)];
        if (!el) return;
        openInfoKey = key;
        el.setAttribute('aria-hidden', 'false');
        el.classList.add('is-open');
        el.focus({ preventScroll: true });
      }

      function addSelection() {
        if (busy || !footerBtn) return;
        var items = [];
        activeSlots().forEach(function (slot) {
          if (slot.data.optional && !slot.include) return;
          if (slot.variant) items.push({ id: slot.variant.id, quantity: 1 });
          if (slot.addonOn && slot.addonSel) {
            var av = addonVariantFor(slot);
            if (av) items.push({ id: av.id, quantity: 1 });
          }
        });
        if (!items.length) return;
        busy = true;
        footerBtn.classList.add('is-busy');
        /* Shopify's botfilter geeft op cart-calls soms een 429-challenge met
           HTML als antwoord (gemeten 02/09: klanten strandden op stap 3 omdat
           EEN challenge de toevoeging afbrak, terwijl dezelfde call seconden
           later gewoon slaagt). Daarom twee stille herkansingen met korte
           pauze; alleen een echte weigering (422, bv. uitverkocht) of drie
           mislukkingen toont de foutmelding. */
        var pogingen = 0;
        function faalAf() {
          footerBtn.textContent = footerBtn.getAttribute('data-label-error') || 'Something went wrong, please try again';
          window.setTimeout(renderFooter, 3000);
          busy = false;
          footerBtn.classList.remove('is-busy');
        }
        function poging() {
          pogingen += 1;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items }),
          })
            .then(function (response) {
              if (!response.ok) {
                var fout = new Error('cart add failed');
                fout.status = response.status;
                throw fout;
              }
              return response.json();
            })
            .then(function () {
              // Set-korting (22/08): alleen als de sectie-instelling een kortingscode heeft.
              // Het theme kan zelf geen korting afdwingen; de code is een winkelobject van IVONO
              // (Kortingen in de admin) en Shopify rekent hem af. Leeg = niets gebeurt.
              var code = wsRoot.getAttribute('data-ws-discount-code');
              if (!code) return;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ discount: code }),
              }).catch(function () {
                /* code ongeldig of verlopen: de set staat wél in de cart, zonder korting */
              });
            })
            .then(function () {
              close();
              // Site-breed cart-contract: refresh + klik-equivalent van de opener
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              var opener = document.querySelector('[data-cart-drawer-open]');
              if (opener) opener.click();
              busy = false;
              footerBtn.classList.remove('is-busy');
            })
            .catch(function (fout) {
              if (pogingen < 3 && (!fout || fout.status !== 422)) {
                window.setTimeout(poging, pogingen === 1 ? 1200 : 2800);
                return;
              }
              faalAf();
            });
        }
        poging();
      }

      wsRoot.addEventListener('click', function (event) {
        if (event.target === overlay) {
          close();
          return;
        }
        if (event.target.closest('[data-ws-close]')) {
          close();
          return;
        }
        var pickBtn = event.target.closest('[data-ws-pick]');
        if (pickBtn) {
          var pickStep = pickBtn.closest('[data-ws-step]');
          pickProduct(stepEls.indexOf(pickStep), pickBtn.getAttribute('data-ws-pick'));
          return;
        }
        var infoOpenBtn = event.target.closest('[data-ws-info-open]');
        if (infoOpenBtn) {
          openInfo(infoOpenBtn.getAttribute('data-ws-info-open'));
          return;
        }
        if (event.target.closest('[data-ws-info-back]')) {
          closeInfo();
          return;
        }
        var play = event.target.closest('[data-ws-play]');
        if (play) {
          var box = play.closest('[data-ws-video]');
          if (!box) return;
          var vid = box.querySelector('video');
          if (vid) {
            box.classList.add('is-playing');
            vid.setAttribute('controls', 'controls');
            vid.play();
            return;
          }
          var url = box.getAttribute('data-ws-video-url');
          if (!url) return;
          var embed = url;
          var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
          var vm = url.match(/vimeo\.com\/(\d+)/);
          if (yt) embed = 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1';
          else if (vm) embed = 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
          var frame = document.createElement('iframe');
          frame.src = embed;
          frame.allow = 'autoplay; fullscreen';
          frame.setAttribute('allowfullscreen', '');
          frame.title = 'Video';
          box.classList.add('is-playing');
          box.appendChild(frame);
          return;
        }
        var tabBtn = event.target.closest('[data-ws-tab]');
        if (tabBtn) {
          activateStep(parseInt(tabBtn.getAttribute('data-ws-tab'), 10));
          return;
        }
        if (event.target.closest('[data-ws-next]')) {
          if (current < stepEls.length - 1) activateStep(current + 1);
          else addSelection();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !wsRoot.classList.contains('is-open')) return;
        if (openInfoKey !== null) closeInfo();
        else close();
      });

      window.addEventListener('resize', function () {
        var slot = activeSlot(current);
        if (slot && wsRoot.classList.contains('is-open')) {
          scrollToSlide(slot, slot.currentSlide, false);
          paintGallery(slot);
        }
      });

      renderFooter();

      var api = { open: open, close: close };
      wsRoot.__ivWs = api;
      return api;
    }

    // CTA opent de flyout (dode link krijgt gedrag; pagina springt niet naar boven)
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-ws-open]');
      if (!opener) return;
      var sectionEl = opener.closest('.iv-product-row');
      if (!sectionEl) return;
      var wsRoot = sectionEl.querySelector('[data-ws-root]');
      if (!wsRoot) return;
      event.preventDefault();
      initWsRoot(wsRoot).open();
    });

    function initAllWs() {
      document.querySelectorAll('.iv-product-row [data-ws-root]').forEach(function (wsRoot) {
        initWsRoot(wsRoot);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllWs);
    } else {
      initAllWs();
    }
    document.addEventListener('shopify:section:load', initAllWs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // De gedeelde kaarten krijgen hun foto-indicator-sync normaal via de
    // listing-sectie-init; op de zoekpagina initialiseren we ze zelf.
    function initSearchCards(root) {
      root.querySelectorAll('[data-lp-card]').forEach((card) => {
        if (card.dataset.ivSearchInit) return;
        card.dataset.ivSearchInit = '1';
        const slider = card.querySelector('[data-lp-slider]');
        const segs = card.querySelectorAll('[data-lp-seg]');
        if (!slider || segs.length < 2) return;
        let current = 0;
        slider.addEventListener(
          'scroll',
          () => {
            requestAnimationFrame(() => {
              const i = Math.min(
                segs.length - 1,
                Math.max(0, Math.round(slider.scrollLeft / (slider.clientWidth + 2)))
              );
              if (i !== current) {
                segs[current].classList.remove('is-active');
                segs[i].classList.add('is-active');
                current = i;
              }
            });
          },
          { passive: true }
        );
      });
    }
    const initAll = () => document.querySelectorAll('.iv-search').forEach(initSearchCards);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.iv-search');
      if (section) initSearchCards(section);
    });

    // Swatch-klik -> variant-foto. Sectie-JS bundelt per pagina alleen aanwezige
    // secties, dus de zoekpagina registreert de gedeelde handler zelf (zelfde
    // window-guard als iv-product-listing/iv-collection-grid).
    if (!window.__ivSwatchInit) {
      window.__ivSwatchInit = true;
      document.addEventListener('click', (e) => {
        const sw = e.target.closest('[data-swatch-value]');
        if (!sw) return;
        e.preventDefault();
        const card = sw.closest('[data-lp-card], [data-cg-card]');
        if (!card) return;
        card.querySelectorAll('[data-swatch-value]').forEach((s) => {
          s.classList.toggle('is-active', s === sw);
        });
        const label = card.querySelector('.iv-product-listing__swatch-label, .iv-collection-grid__swatch-label');
        if (label) label.textContent = sw.dataset.swatchValue;
        const slider = card.querySelector('[data-lp-slider], [data-cg-slider]');
        if (!slider) return;
        const slides = Array.from(slider.children);
        const target = sw.dataset.swatchMedia
          ? slides.findIndex((s) => s.dataset.mediaId === sw.dataset.swatchMedia)
          : -1;
        if (target >= 0) {
          slider.scrollTo({ left: target * (slider.clientWidth + 2), behavior: 'smooth' });
        } else if (sw.dataset.swatchImage) {
          const img = slides[0] && slides[0].querySelector('img');
          if (img) {
            img.removeAttribute('srcset');
            img.src = sw.dataset.swatchImage;
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SPOT = '.iv-testimonials__spot';

  function closeSpot(spot) {
    spot.classList.remove('is-open');
    var btn = spot.querySelector('[data-iv-spot-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function closeAllSpots(except) {
    document.querySelectorAll(SPOT + '.is-open').forEach(function (spot) {
      if (spot !== except) closeSpot(spot);
    });
  }

  /* De kaart hangt per Figma boven-links van de dot; zit een dot hoog of aan de rand,
     dan schuiven we de kaart terug binnen de foto (de tegel heeft overflow:hidden). */
  function placeSpotCard(spot) {
    var card = spot.querySelector('[data-iv-spot-card]');
    var bounds = spot.closest('.iv-testimonials__project-slide');
    if (!card || !bounds) return;
    card.style.transform = '';
    var b = bounds.getBoundingClientRect();
    var c = card.getBoundingClientRect();
    if (!c.width || !b.width) return;
    var pad = 8;
    var dx = 0;
    var dy = 0;
    if (c.left < b.left + pad) dx = b.left + pad - c.left;
    else if (c.right > b.right - pad) dx = Math.max(b.right - pad - c.right, b.left + pad - c.left);
    if (c.top < b.top + pad) dy = b.top + pad - c.top;
    else if (c.bottom > b.bottom - pad) dy = Math.max(b.bottom - pad - c.bottom, b.top + pad - c.top);
    if (dx || dy) card.style.transform = 'translate(' + Math.round(dx) + 'px, ' + Math.round(dy) + 'px)';
  }

  function placeOpenSpots(root) {
    (root || document).querySelectorAll(SPOT + '.is-open').forEach(placeSpotCard);
  }

  function initSpots(root) {
    root.querySelectorAll('[data-iv-spot-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var spot = btn.closest(SPOT);
        if (!spot) return;
        var willOpen = !spot.classList.contains('is-open');
        closeAllSpots(spot);
        spot.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) placeSpotCard(spot);
      });
    });
    placeOpenSpots(root);
  }

  if (!window.ivTestimonialsSpotsBound) {
    window.ivTestimonialsSpotsBound = true;
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest(SPOT)) return;
      closeAllSpots();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllSpots();
    });
    window.addEventListener('resize', function () {
      placeOpenSpots();
    });
  }

  function initProject(card) {
    if (card.dataset.ivProjectInit) return;
    card.dataset.ivProjectInit = 'true';
    var media = card.querySelector('[data-iv-project-media]');
    var prev = card.querySelector('[data-iv-project-prev]');
    var next = card.querySelector('[data-iv-project-next]');
    var dots = card.querySelectorAll('.iv-testimonials__project-dots span');
    if (!media || !prev || !next) return;

    function update() {
      var w = media.clientWidth || 1;
      var idx = Math.round(media.scrollLeft / w);
      var max = media.scrollWidth - media.clientWidth - 1;
      prev.disabled = media.scrollLeft <= 0;
      next.disabled = media.scrollLeft >= max;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    prev.addEventListener('click', function () {
      media.scrollBy({ left: -media.clientWidth, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      media.scrollBy({ left: media.clientWidth, behavior: 'smooth' });
    });
    media.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    if (root.dataset.ivTestimonialsInit) return;
    root.dataset.ivTestimonialsInit = 'true';
    root.querySelectorAll('[data-iv-project]').forEach(initProject);
    initSpots(root);
    var scroller = root.querySelector('[data-iv-testimonials-scroller]');
    var prev = root.querySelector('[data-iv-testimonials-prev]');
    var next = root.querySelector('[data-iv-testimonials-next]');
    if (!scroller || !prev || !next) return;

    function step() {
      var card = scroller.querySelector('.iv-testimonials__card, .iv-testimonials__project');
      if (!card) return scroller.clientWidth;
      var styles = window.getComputedStyle(scroller);
      var gap = parseFloat(styles.columnGap || styles.gap) || 4;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth - 1;
      prev.disabled = scroller.scrollLeft <= 0;
      next.disabled = scroller.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      scroller.scrollBy({ left: -1 * step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      scroller.scrollBy({ left: step(), behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* iOS-vangnet (Ivo 16/09): blijft de strook na een gechainde swipe buiten zijn
       randen hangen (scrollLeft onder 0 of boven het maximum), zet hem terug op de
       rand zodra het scrollen 200 ms stil is. Zie de CSS bij __scroller--projects. */
    var settle;
    function settleCheck() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      if (scroller.scrollLeft < 0) scroller.scrollTo({ left: 0 });
      else if (scroller.scrollLeft > max) scroller.scrollTo({ left: max });
    }
    function queueSettle() {
      clearTimeout(settle);
      settle = setTimeout(settleCheck, 200);
    }
    scroller.addEventListener('scroll', queueSettle, { passive: true });
    scroller.addEventListener('touchend', queueSettle, { passive: true });
  }

  /* Trustpilot-live-bron: verse reviews (4-5 sterren) van het TrustBox-data-
     endpoint, gerenderd in exact de eigen kaart-markup. Cache in localStorage
     van 1 uur (Ivo 31/08, was 24); elke fout laat de server-gerenderde
     fallback-kaarten gewoon staan. Alle reviewvelden gaan via textContent,
     nooit via innerHTML. */
  var TP_STAR_PATH = 'M11.9985 16.1755L15.6471 15.2542L17.1664 19.9561L11.9865 16.1755H11.9985ZM20.3963 10.0977H13.9723L11.9985 4.04387L10.0247 10.0977H3.60075L8.80449 13.8425L6.83065 19.8963L12.0344 16.1515L15.2404 13.8544L20.4202 10.1097L20.3963 10.0977Z';
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function tpEl(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text) el.textContent = text;
    return el;
  }

  function tpStars(count) {
    var wrap = tpEl('div', 'iv-testimonials__stars iv-testimonials__stars--sm');
    wrap.setAttribute('role', 'img');
    // Zelfde label als de server-gerenderde sterren; /^nl/ omdat de JS-kaarten
    // de Liquid-variant vervangen en anders in het Engels terugkomen.
    wrap.setAttribute('aria-label', count + (/^nl\b/i.test(document.documentElement.lang || '')
      ? ' van de 5 sterren' : ' out of 5 stars'));
    for (var i = 1; i <= 5; i++) {
      var svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      var rect = document.createElementNS(SVG_NS, 'rect');
      rect.setAttribute('width', '24');
      rect.setAttribute('height', '24');
      if (i <= count) rect.setAttribute('fill', '#00B67A');
      else rect.setAttribute('class', 'iv-tst-star-rest');
      svg.appendChild(rect);
      var path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', TP_STAR_PATH);
      path.setAttribute('fill', '#FFFFFF');
      svg.appendChild(path);
      wrap.appendChild(svg);
    }
    return wrap;
  }

  // Exact de officiële Trustpilot-badge (Mehmet 24/08, naar hun live shop):
  // grijs bolletje met wit vinkje, grijze onderstreepte tekst.
  function tpVerifiedBadge(label) {
    var span = tpEl('span', 'iv-testimonials__verified');
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('aria-hidden', 'true');
    var circle = document.createElementNS(SVG_NS, 'circle');
    circle.setAttribute('cx', '8');
    circle.setAttribute('cy', '8');
    circle.setAttribute('r', '8');
    circle.setAttribute('fill', 'currentColor');
    svg.appendChild(circle);
    var check = document.createElementNS(SVG_NS, 'path');
    check.setAttribute('d', 'M4.5 8.4 7 10.9l4.5-5');
    check.setAttribute('stroke', '#FFFFFF');
    check.setAttribute('stroke-width', '1.6');
    check.setAttribute('fill', 'none');
    check.setAttribute('stroke-linecap', 'round');
    check.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(check);
    span.appendChild(svg);
    var tekst = tpEl('span', 'iv-testimonials__verified-label', label);
    span.appendChild(tekst);
    return span;
  }

  // Datum exact in Trustpilot-telling (correctie Mehmet 24/08: onze "yesterday"
  // was bij Trustpilot "2 dagen geleden"). Trustpilot telt KALENDERdagen, geen
  // blokken van 24 uur, schrijft het getal uit ("1 dag geleden", niet
  // "gisteren") en gebruikt uren binnen dezelfde dag. Ouder dan een maand: de
  // gewone lange datum.
  function tpDagenGeleden(d) {
    var nu = new Date();
    return Math.round((new Date(nu.getFullYear(), nu.getMonth(), nu.getDate()) -
      new Date(d.getFullYear(), d.getMonth(), d.getDate())) / 86400000);
  }

  // Datum-locale: de storefront-taal, maar 'en' expliciet naar en-GB. Kaal 'en'
  // is voor Intl en-US en dat geeft "8/26/2026" — maand-eerst, terwijl de
  // Nederlandse kaart ernaast dag-eerst toont. Eén review met twee leesrichtingen
  // is precies de inconsistentie die de klant op 26/08 meldde.
  function tpLocale(lang) {
    return /^en\b/i.test(lang || '') ? 'en-GB' : (lang || 'en-GB');
  }

  function tpDatum(iso, lang) {
    var d = new Date(iso);
    if (isNaN(d)) return String(iso || '').slice(0, 10);
    var loc = tpLocale(lang);
    var dagen = tpDagenGeleden(d);
    if (dagen >= 0 && dagen < 30 && window.Intl && Intl.RelativeTimeFormat) {
      try {
        var rtf = new Intl.RelativeTimeFormat(loc, { numeric: 'always' });
        if (dagen === 0) {
          // `nu` stond hier tot 26/08 buiten scope (hij is lokaal aan
          // tpDagenGeleden): elke review van vandaag gooide een ReferenceError,
          // viel door naar de lange datum en kreeg daaronder ook nog de exacte
          // datum — dezelfde dag twee keer, in twee opmaken.
          var uren = Math.max(1, Math.floor((Date.now() - d.getTime()) / 3600000));
          return rtf.format(-uren, 'hour');
        }
        return rtf.format(-dagen, 'day');
      } catch (e) { /* onbekende locale: val door naar de datum */ }
    }
    try {
      return d.toLocaleDateString(loc, { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) {
      return String(iso).slice(0, 10);
    }
  }

  // Exacte datum (Ivo 25/08: "de datum er subtiel bij, dan is hij fake-proof"):
  // altijd dag-maand-jaar in cijfers, alleen onder een relatieve datum; ouder
  // dan een maand staat de volledige datum al in de regel zelf.
  // NL geeft 26-08-2026, en-GB 26/08/2026 — zelfde volgorde, eigen scheidingsteken.
  function tpIsRelatief(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return false;
    var dagen = tpDagenGeleden(d);
    return dagen >= 0 && dagen < 30 && !!(window.Intl && Intl.RelativeTimeFormat);
  }

  // Exacte datum onder de relatieve tekst, volledig uitgeschreven (Mehmet 26/08: "niet
  // 22/08/2026 maar 22 augustus 2026"): nl "22 augustus 2026", en "22 August 2026".
  // Zelfde vorm als de uitgeschreven datum van oudere reviews in tpDatum().
  function tpDatumExact(iso, lang) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    if (window.Intl && Intl.DateTimeFormat) {
      try {
        return new Intl.DateTimeFormat(tpLocale(lang), {
          day: 'numeric', month: 'long', year: 'numeric'
        }).format(d);
      } catch (e) { /* onbekende locale: val door naar de handmatige vorm */ }
    }
    var maanden = (lang || '').indexOf('nl') === 0
      ? ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
      : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return d.getDate() + ' ' + maanden[d.getMonth()] + ' ' + d.getFullYear();
  }

  function initTrustpilot(root) {
    var scroller = root.querySelector('[data-iv-tp-source]');
    if (!scroller || scroller.dataset.ivTpDone) return;
    scroller.dataset.ivTpDone = 'true';
    var src = scroller.dataset.ivTpSource;
    var cacheKey = 'iv-tp-reviews:v5:' + src;
    // 1 uur (Ivo 31/08, was 24). Zelfde waarde als assets/iv-trustpilot-live.js,
    // iv-footer, iv-ivono-at-work en iv-product-rating: gedeelde cache-key.
    var TTL = 60 * 60 * 1000;
    var lang = document.documentElement.lang || 'en';

    function render(data) {
      // Dynamische teller (Ivo 24/08): het getal in de koptekst ("500+ reviews
      // on") wordt het echte Trustpilot-totaal; de rest van de tekst en dus de
      // vertaling blijft staan. Ook bij nul kaarten, het totaal is winkelbreed.
      var totaal = data && data.businessUnit && data.businessUnit.total;
      if (totaal) {
        var teller = root.querySelector('[data-iv-tst-count]');
        if (teller && /[\d.,+]+/.test(teller.textContent)) {
          teller.textContent = teller.textContent.replace(/[\d.,+]+/, String(totaal));
        }
      }
      // Trustpilot-label (Ivo 25/08): Trustpilots eigen starsString, in de
      // taal van de storefront opgehaald, vervangt de placeholder in de kop.
      var label = data && data.starsString;
      if (label) {
        var labelEl = root.querySelector('[data-iv-tst-label]');
        if (labelEl) labelEl.textContent = label;
      }
      var reviews = (data && data.reviews) || [];
      var frag = document.createDocumentFragment();
      reviews.forEach(function (r) {
        if (!r || !r.text) return;
        // Trustpilot-stijl (Mehmet 24/08): een kaart linkt naar zijn eigen
        // review op Trustpilot, in een nieuw tabblad. Zonder reviewUrl (oude
        // cache, productreviews) blijft de kaart een gewoon article.
        var card;
        if (r.reviewUrl) {
          card = tpEl('a', 'iv-testimonials__card iv-testimonials__card--link');
          card.href = r.reviewUrl;
          card.target = '_blank';
          card.rel = 'noopener';
        } else {
          card = tpEl('article', 'iv-testimonials__card');
        }
        var main = tpEl('div', 'iv-testimonials__card-main');
        var starsRow = tpEl('div', 'iv-testimonials__stars-row');
        starsRow.appendChild(tpStars(r.stars || 5));
        if (r.verification && r.verification.isVerified) starsRow.appendChild(tpVerifiedBadge(scroller.dataset.ivTpVerified || 'Verified'));
        main.appendChild(starsRow);
        var text = tpEl('div', 'iv-testimonials__card-text');
        if (r.title) text.appendChild(tpEl('div', 'iv-testimonials__card-title', r.title));
        text.appendChild(tpEl('p', 'iv-testimonials__card-body', r.text));
        main.appendChild(text);
        card.appendChild(main);
        var author = tpEl('div', 'iv-testimonials__card-author');
        var naam = (r.consumer && r.consumer.displayName) || '';
        if (naam) author.appendChild(tpEl('p', 'iv-testimonials__card-name', naam));
        if (r.createdAt) {
          author.appendChild(tpEl('p', 'iv-testimonials__card-date', tpDatum(r.createdAt, lang)));
          if (tpIsRelatief(r.createdAt)) author.appendChild(tpEl('p', 'iv-testimonials__card-date-exact', tpDatumExact(r.createdAt, lang)));
        }
        card.appendChild(author);
        frag.appendChild(card);
      });
      if (!frag.childNodes.length) return;
      scroller.textContent = '';
      scroller.appendChild(frag);
      scroller.scrollLeft = 0;
      scroller.dispatchEvent(new Event('scroll'));
    }

    try {
      var cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
      if (cached && cached.t && Date.now() - cached.t < TTL && cached.d) {
        render(cached.d);
        return;
      }
    } catch (e) { /* cache onbruikbaar: gewoon fetchen */ }

    var mode = scroller.dataset.ivTpMode || 'service';
    fetch(src)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        // Bron 'product' levert productReviews.reviews met 'content' i.p.v.
        // 'text' en zonder titel of verificatieveld; hier al gelijkgetrokken
        // zodat cache en render maar één vorm kennen.
        var lijst = mode === 'product' ? ((d.productReviews && d.productReviews.reviews) || []) : (d.reviews || []);
        var slank = {
          businessUnit: d.businessUnit && d.businessUnit.numberOfReviews ? { total: d.businessUnit.numberOfReviews.total, trustScore: d.businessUnit.trustScore, stars: d.businessUnit.stars } : null,
          starsString: d.starsString || '',
          reviews: lijst.map(function (r) {
            return {
              stars: r.stars,
              title: r.title,
              text: r.text || r.content,
              createdAt: r.createdAt,
              reviewUrl: r.reviewUrl,
              consumer: { displayName: r.consumer && r.consumer.displayName },
              verification: { isVerified: !!(r.verification && r.verification.isVerified) }
            };
          })
        };
        try { localStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), d: slank })); } catch (e) { /* private mode */ }
        render(slank);
      })
      .catch(function () { /* fallback: de server-gerenderde kaarten blijven staan */ });
  }

  document.querySelectorAll('.iv-testimonials').forEach(function (root) {
    init(root);
    initTrustpilot(root);
  });
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.iv-testimonials');
    if (root) {
      init(root);
      initTrustpilot(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
